var qc = Object.defineProperty;
var Yc = (e, n, r) => n in e ? qc(e, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[n] = r;
var q = (e, n, r) => Yc(e, typeof n != "symbol" ? n + "" : n, r);
import { TableMap as Qr, goToNextCell as _r, columnResizing as Qc, tableEditing as es, CellSelection as ei, TableView as ts } from "prosemirror-tables";
import { b as Ut, $ as l, P as ns, Q as rs, R as is, S as fe, T as Tt, V as Et, W as re, X as G, Y as we, Z as Pt, _ as ti, a0 as ce, a1 as x, a2 as Ct, a3 as Dt, a4 as ni, a5 as os, a6 as yr, a7 as At, a8 as kt, a9 as se, aa as W, ab as wt, ac as ri, ad as Ye, ae as as, af as Ie, ag as It, ah as Se, ai as us, aj as h, ak as I, al as f, am as Zt, an as ii, ao as cs, ap as oi, aq as ai, ar as ui, as as ci, at as si, au as li, av as di, aw as mi, ax as fi, ay as pi, az as gi, aA as vi, aB as hi, aC as bi, aD as Qe, aE as ss, aF as ls, aG as ds, aH as ms, aI as Lt, aJ as Mt, aK as $i, aL as fs, aM as ps, aN as gs, aO as vs, aP as hs, aQ as _i, aR as yi, aS as kr, aT as bs, aU as $s, aV as _s, aW as ys, aX as ks, aY as ws, aZ as Is, a_ as Ss, v as zs, A as St, g as Oe, q as xs, u as Bt, a as ki, i as wr, t as Ns, U as wi, I as js, J as Ii, K as Os, y as Us, r as Ts, s as Si } from "./nodeToBlock-DJYxfW65.js";
import { Node as pe, Mark as Es, Extension as Ps, callOrReturn as Cs, getExtensionField as Ds, mergeAttributes as Rt, findParentNode as As } from "@tiptap/core";
import { TextSelection as zi, Plugin as Zs, PluginKey as Ls } from "prosemirror-state";
import { DecorationSet as Ir, Decoration as Sr } from "prosemirror-view";
import { ReplaceStep as Ms, Mapping as Bs } from "prosemirror-transform";
import { ySyncPluginKey as zr, absolutePositionToRelativePosition as Rs, relativePositionToAbsolutePosition as Fs } from "y-prosemirror";
import { c as A, a as xi } from "./BlockNoteExtension-C2X7LW-V.js";
import Vs from "@tiptap/extension-bold";
import Hs from "@tiptap/extension-code";
import Ws from "@tiptap/extension-italic";
import Js from "@tiptap/extension-strike";
import Gs from "@tiptap/extension-underline";
import { DOMParser as Ni, Fragment as Ks, DOMSerializer as xr } from "@tiptap/pm/model";
import { createHighlightPlugin as Xs } from "prosemirror-highlight";
import { createParser as qs } from "prosemirror-highlight/shiki";
import { Slice as ji, Fragment as et, DOMParser as Oi } from "prosemirror-model";
import { Plugin as Ys, PluginKey as Qs } from "@tiptap/pm/state";
import { DecorationSet as Nr, Decoration as el } from "@tiptap/pm/view";
const tl = () => typeof navigator < "u" && (/Mac/.test(navigator.platform) || /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent));
function Q(e, n = "Ctrl") {
  return tl() ? e.replace("Mod", "⌘") : e.replace("Mod", n);
}
function ze(...e) {
  return [
    // Converts to & from set to remove duplicates.
    ...new Set(
      e.filter((n) => n).join(" ").split(" ")
    )
  ].join(" ");
}
const rv = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
function nl(e, n, r, o) {
  const t = document.createElement("div");
  t.className = ze(
    "bn-block-content",
    r.class
  ), t.setAttribute("data-content-type", e);
  for (const [a, u] of Object.entries(r))
    a !== "class" && t.setAttribute(a, u);
  const i = document.createElement(n);
  i.className = ze(
    "bn-inline-content",
    o.class
  );
  for (const [a, u] of Object.entries(
    o
  ))
    a !== "class" && i.setAttribute(a, u);
  return t.appendChild(i), {
    dom: t,
    contentDOM: i
  };
}
const jr = (e, n) => {
  let r = Ut(e, n.pmSchema);
  r.type.name === "blockContainer" && (r = r.firstChild);
  const o = n.pmSchema.nodes[r.type.name].spec.toDOM;
  if (o === void 0)
    throw new Error(
      "This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`."
    );
  const t = o(r);
  if (typeof t != "object" || !("dom" in t))
    throw new Error(
      "Cannot use this block's default HTML serialization as its corresponding TipTap node's `renderHTML` function does not return an object with the `dom` property."
    );
  return t;
};
function rl(e, n = "<br>") {
  const r = e.querySelectorAll("p");
  if (r.length > 1) {
    const o = r[0];
    for (let t = 1; t < r.length; t++) {
      const i = r[t];
      o.innerHTML += n + i.innerHTML, i.remove();
    }
  }
}
const Ui = /^[cC][^\s-]{8,}$/, Ti = /^[0-9a-z]+$/, Ei = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Pi = /^[0-9a-vA-V]{20}$/, Ci = /^[A-Za-z0-9]{27}$/, Di = /^[a-zA-Z0-9_-]{21}$/, Ai = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, il = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Zi = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, le = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, ol = /* @__PURE__ */ le(4), al = /* @__PURE__ */ le(6), ul = /* @__PURE__ */ le(7), Li = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, cl = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, sl = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, Mi = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u, ll = Mi, dl = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, ml = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Bi() {
  return new RegExp(ml, "u");
}
const Ri = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Fi = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Vi = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Hi = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Wi = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Ft = /^[A-Za-z0-9_-]*$/, Vt = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, Ji = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/, Gi = /^\+(?:[0-9]){6,14}[0-9]$/, Ki = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Xi = /* @__PURE__ */ new RegExp(`^${Ki}$`);
function qi(e) {
  const n = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${n}` : e.precision === 0 ? `${n}:[0-5]\\d` : `${n}:[0-5]\\d\\.\\d{${e.precision}}` : `${n}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Yi(e) {
  return new RegExp(`^${qi(e)}$`);
}
function Qi(e) {
  const n = qi({ precision: e.precision }), r = ["Z"];
  e.local && r.push(""), e.offset && r.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${n}(?:${r.join("|")})`;
  return new RegExp(`^${Ki}T(?:${o})$`);
}
const eo = (e) => {
  const n = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${n}$`);
}, to = /^-?\d+n?$/, no = /^-?\d+$/, ro = /^-?\d+(?:\.\d+)?/, io = /^(?:true|false)$/i, oo = /^null$/i, ao = /^undefined$/i, uo = /^[^A-Z]*$/, co = /^[^a-z]*$/, so = /^[0-9a-fA-F]*$/;
function Ue(e, n) {
  return new RegExp(`^[A-Za-z0-9+/]{${e}}${n}$`);
}
function Te(e) {
  return new RegExp(`^[A-Za-z0-9_-]{${e}}$`);
}
const fl = /^[0-9a-fA-F]{32}$/, pl = /* @__PURE__ */ Ue(22, "=="), gl = /* @__PURE__ */ Te(22), vl = /^[0-9a-fA-F]{40}$/, hl = /* @__PURE__ */ Ue(27, "="), bl = /* @__PURE__ */ Te(27), $l = /^[0-9a-fA-F]{64}$/, _l = /* @__PURE__ */ Ue(43, "="), yl = /* @__PURE__ */ Te(43), kl = /^[0-9a-fA-F]{96}$/, wl = /* @__PURE__ */ Ue(64, ""), Il = /* @__PURE__ */ Te(64), Sl = /^[0-9a-fA-F]{128}$/, zl = /* @__PURE__ */ Ue(86, "=="), xl = /* @__PURE__ */ Te(86), Ht = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base64: Wi,
  base64url: Ft,
  bigint: to,
  boolean: io,
  browserEmail: dl,
  cidrv4: Vi,
  cidrv6: Hi,
  cuid: Ui,
  cuid2: Ti,
  date: Xi,
  datetime: Qi,
  domain: Ji,
  duration: Ai,
  e164: Gi,
  email: Li,
  emoji: Bi,
  extendedDuration: il,
  guid: Zi,
  hex: so,
  hostname: Vt,
  html5Email: cl,
  idnEmail: ll,
  integer: no,
  ipv4: Ri,
  ipv6: Fi,
  ksuid: Ci,
  lowercase: uo,
  md5_base64: pl,
  md5_base64url: gl,
  md5_hex: fl,
  nanoid: Di,
  null: oo,
  number: ro,
  rfc5322Email: sl,
  sha1_base64: hl,
  sha1_base64url: bl,
  sha1_hex: vl,
  sha256_base64: _l,
  sha256_base64url: yl,
  sha256_hex: $l,
  sha384_base64: wl,
  sha384_base64url: Il,
  sha384_hex: kl,
  sha512_base64: zl,
  sha512_base64url: xl,
  sha512_hex: Sl,
  string: eo,
  time: Yi,
  ulid: Ei,
  undefined: ao,
  unicodeEmail: Mi,
  uppercase: co,
  uuid: le,
  uuid4: ol,
  uuid6: al,
  uuid7: ul,
  xid: Pi
}, Symbol.toStringTag, { value: "Module" })), T = /* @__PURE__ */ l("$ZodCheck", (e, n) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = n, (r = e._zod).onattach ?? (r.onattach = []);
}), lo = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, Wt = /* @__PURE__ */ l("$ZodCheckLessThan", (e, n) => {
  T.init(e, n);
  const r = lo[typeof n.value];
  e._zod.onattach.push((o) => {
    const t = o._zod.bag, i = (n.inclusive ? t.maximum : t.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    n.value < i && (n.inclusive ? t.maximum = n.value : t.exclusiveMaximum = n.value);
  }), e._zod.check = (o) => {
    (n.inclusive ? o.value <= n.value : o.value < n.value) || o.issues.push({
      origin: r,
      code: "too_big",
      maximum: n.value,
      input: o.value,
      inclusive: n.inclusive,
      inst: e,
      continue: !n.abort
    });
  };
}), Jt = /* @__PURE__ */ l("$ZodCheckGreaterThan", (e, n) => {
  T.init(e, n);
  const r = lo[typeof n.value];
  e._zod.onattach.push((o) => {
    const t = o._zod.bag, i = (n.inclusive ? t.minimum : t.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    n.value > i && (n.inclusive ? t.minimum = n.value : t.exclusiveMinimum = n.value);
  }), e._zod.check = (o) => {
    (n.inclusive ? o.value >= n.value : o.value > n.value) || o.issues.push({
      origin: r,
      code: "too_small",
      minimum: n.value,
      input: o.value,
      inclusive: n.inclusive,
      inst: e,
      continue: !n.abort
    });
  };
}), mo = /* @__PURE__ */ l("$ZodCheckMultipleOf", (e, n) => {
  T.init(e, n), e._zod.onattach.push((r) => {
    var o;
    (o = r._zod.bag).multipleOf ?? (o.multipleOf = n.value);
  }), e._zod.check = (r) => {
    if (typeof r.value != typeof n.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? r.value % n.value === BigInt(0) : ns(r.value, n.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: n.value,
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
}), fo = /* @__PURE__ */ l("$ZodCheckNumberFormat", (e, n) => {
  var a;
  T.init(e, n), n.format = n.format || "float64";
  const r = (a = n.format) == null ? void 0 : a.includes("int"), o = r ? "int" : "number", [t, i] = rs[n.format];
  e._zod.onattach.push((u) => {
    const c = u._zod.bag;
    c.format = n.format, c.minimum = t, c.maximum = i, r && (c.pattern = no);
  }), e._zod.check = (u) => {
    const c = u.value;
    if (r) {
      if (!Number.isInteger(c)) {
        u.issues.push({
          expected: o,
          format: n.format,
          code: "invalid_type",
          continue: !1,
          input: c,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(c)) {
        c > 0 ? u.issues.push({
          input: c,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: o,
          continue: !n.abort
        }) : u.issues.push({
          input: c,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: o,
          continue: !n.abort
        });
        return;
      }
    }
    c < t && u.issues.push({
      origin: "number",
      input: c,
      code: "too_small",
      minimum: t,
      inclusive: !0,
      inst: e,
      continue: !n.abort
    }), c > i && u.issues.push({
      origin: "number",
      input: c,
      code: "too_big",
      maximum: i,
      inst: e
    });
  };
}), po = /* @__PURE__ */ l("$ZodCheckBigIntFormat", (e, n) => {
  T.init(e, n);
  const [r, o] = is[n.format];
  e._zod.onattach.push((t) => {
    const i = t._zod.bag;
    i.format = n.format, i.minimum = r, i.maximum = o;
  }), e._zod.check = (t) => {
    const i = t.value;
    i < r && t.issues.push({
      origin: "bigint",
      input: i,
      code: "too_small",
      minimum: r,
      inclusive: !0,
      inst: e,
      continue: !n.abort
    }), i > o && t.issues.push({
      origin: "bigint",
      input: i,
      code: "too_big",
      maximum: o,
      inst: e
    });
  };
}), go = /* @__PURE__ */ l("$ZodCheckMaxSize", (e, n) => {
  var r;
  T.init(e, n), (r = e._zod.def).when ?? (r.when = (o) => {
    const t = o.value;
    return !fe(t) && t.size !== void 0;
  }), e._zod.onattach.push((o) => {
    const t = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    n.maximum < t && (o._zod.bag.maximum = n.maximum);
  }), e._zod.check = (o) => {
    const t = o.value;
    t.size <= n.maximum || o.issues.push({
      origin: Tt(t),
      code: "too_big",
      maximum: n.maximum,
      inclusive: !0,
      input: t,
      inst: e,
      continue: !n.abort
    });
  };
}), vo = /* @__PURE__ */ l("$ZodCheckMinSize", (e, n) => {
  var r;
  T.init(e, n), (r = e._zod.def).when ?? (r.when = (o) => {
    const t = o.value;
    return !fe(t) && t.size !== void 0;
  }), e._zod.onattach.push((o) => {
    const t = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    n.minimum > t && (o._zod.bag.minimum = n.minimum);
  }), e._zod.check = (o) => {
    const t = o.value;
    t.size >= n.minimum || o.issues.push({
      origin: Tt(t),
      code: "too_small",
      minimum: n.minimum,
      inclusive: !0,
      input: t,
      inst: e,
      continue: !n.abort
    });
  };
}), ho = /* @__PURE__ */ l("$ZodCheckSizeEquals", (e, n) => {
  var r;
  T.init(e, n), (r = e._zod.def).when ?? (r.when = (o) => {
    const t = o.value;
    return !fe(t) && t.size !== void 0;
  }), e._zod.onattach.push((o) => {
    const t = o._zod.bag;
    t.minimum = n.size, t.maximum = n.size, t.size = n.size;
  }), e._zod.check = (o) => {
    const t = o.value, i = t.size;
    if (i === n.size)
      return;
    const a = i > n.size;
    o.issues.push({
      origin: Tt(t),
      ...a ? { code: "too_big", maximum: n.size } : { code: "too_small", minimum: n.size },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !n.abort
    });
  };
}), bo = /* @__PURE__ */ l("$ZodCheckMaxLength", (e, n) => {
  var r;
  T.init(e, n), (r = e._zod.def).when ?? (r.when = (o) => {
    const t = o.value;
    return !fe(t) && t.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const t = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    n.maximum < t && (o._zod.bag.maximum = n.maximum);
  }), e._zod.check = (o) => {
    const t = o.value;
    if (t.length <= n.maximum)
      return;
    const a = Et(t);
    o.issues.push({
      origin: a,
      code: "too_big",
      maximum: n.maximum,
      inclusive: !0,
      input: t,
      inst: e,
      continue: !n.abort
    });
  };
}), $o = /* @__PURE__ */ l("$ZodCheckMinLength", (e, n) => {
  var r;
  T.init(e, n), (r = e._zod.def).when ?? (r.when = (o) => {
    const t = o.value;
    return !fe(t) && t.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const t = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    n.minimum > t && (o._zod.bag.minimum = n.minimum);
  }), e._zod.check = (o) => {
    const t = o.value;
    if (t.length >= n.minimum)
      return;
    const a = Et(t);
    o.issues.push({
      origin: a,
      code: "too_small",
      minimum: n.minimum,
      inclusive: !0,
      input: t,
      inst: e,
      continue: !n.abort
    });
  };
}), _o = /* @__PURE__ */ l("$ZodCheckLengthEquals", (e, n) => {
  var r;
  T.init(e, n), (r = e._zod.def).when ?? (r.when = (o) => {
    const t = o.value;
    return !fe(t) && t.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const t = o._zod.bag;
    t.minimum = n.length, t.maximum = n.length, t.length = n.length;
  }), e._zod.check = (o) => {
    const t = o.value, i = t.length;
    if (i === n.length)
      return;
    const a = Et(t), u = i > n.length;
    o.issues.push({
      origin: a,
      ...u ? { code: "too_big", maximum: n.length } : { code: "too_small", minimum: n.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !n.abort
    });
  };
}), Ee = /* @__PURE__ */ l("$ZodCheckStringFormat", (e, n) => {
  var r, o;
  T.init(e, n), e._zod.onattach.push((t) => {
    const i = t._zod.bag;
    i.format = n.format, n.pattern && (i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n.pattern));
  }), n.pattern ? (r = e._zod).check ?? (r.check = (t) => {
    n.pattern.lastIndex = 0, !n.pattern.test(t.value) && t.issues.push({
      origin: "string",
      code: "invalid_format",
      format: n.format,
      input: t.value,
      ...n.pattern ? { pattern: n.pattern.toString() } : {},
      inst: e,
      continue: !n.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), yo = /* @__PURE__ */ l("$ZodCheckRegex", (e, n) => {
  Ee.init(e, n), e._zod.check = (r) => {
    n.pattern.lastIndex = 0, !n.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: n.pattern.toString(),
      inst: e,
      continue: !n.abort
    });
  };
}), ko = /* @__PURE__ */ l("$ZodCheckLowerCase", (e, n) => {
  n.pattern ?? (n.pattern = uo), Ee.init(e, n);
}), wo = /* @__PURE__ */ l("$ZodCheckUpperCase", (e, n) => {
  n.pattern ?? (n.pattern = co), Ee.init(e, n);
}), Io = /* @__PURE__ */ l("$ZodCheckIncludes", (e, n) => {
  T.init(e, n);
  const r = re(n.includes), o = new RegExp(typeof n.position == "number" ? `^.{${n.position}}${r}` : r);
  n.pattern = o, e._zod.onattach.push((t) => {
    const i = t._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(o);
  }), e._zod.check = (t) => {
    t.value.includes(n.includes, n.position) || t.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: n.includes,
      input: t.value,
      inst: e,
      continue: !n.abort
    });
  };
}), So = /* @__PURE__ */ l("$ZodCheckStartsWith", (e, n) => {
  T.init(e, n);
  const r = new RegExp(`^${re(n.prefix)}.*`);
  n.pattern ?? (n.pattern = r), e._zod.onattach.push((o) => {
    const t = o._zod.bag;
    t.patterns ?? (t.patterns = /* @__PURE__ */ new Set()), t.patterns.add(r);
  }), e._zod.check = (o) => {
    o.value.startsWith(n.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: n.prefix,
      input: o.value,
      inst: e,
      continue: !n.abort
    });
  };
}), zo = /* @__PURE__ */ l("$ZodCheckEndsWith", (e, n) => {
  T.init(e, n);
  const r = new RegExp(`.*${re(n.suffix)}$`);
  n.pattern ?? (n.pattern = r), e._zod.onattach.push((o) => {
    const t = o._zod.bag;
    t.patterns ?? (t.patterns = /* @__PURE__ */ new Set()), t.patterns.add(r);
  }), e._zod.check = (o) => {
    o.value.endsWith(n.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: n.suffix,
      input: o.value,
      inst: e,
      continue: !n.abort
    });
  };
});
function Or(e, n, r) {
  e.issues.length && n.issues.push(...G(r, e.issues));
}
const xo = /* @__PURE__ */ l("$ZodCheckProperty", (e, n) => {
  T.init(e, n), e._zod.check = (r) => {
    const o = n.schema._zod.run({
      value: r.value[n.property],
      issues: []
    }, {});
    if (o instanceof Promise)
      return o.then((t) => Or(t, r, n.property));
    Or(o, r, n.property);
  };
}), No = /* @__PURE__ */ l("$ZodCheckMimeType", (e, n) => {
  T.init(e, n);
  const r = new Set(n.mime);
  e._zod.onattach.push((o) => {
    o._zod.bag.mime = n.mime;
  }), e._zod.check = (o) => {
    r.has(o.value.type) || o.issues.push({
      code: "invalid_value",
      values: n.mime,
      input: o.value.type,
      inst: e,
      continue: !n.abort
    });
  };
}), jo = /* @__PURE__ */ l("$ZodCheckOverwrite", (e, n) => {
  T.init(e, n), e._zod.check = (r) => {
    r.value = n.tx(r.value);
  };
});
class Oo {
  constructor(n = []) {
    this.content = [], this.indent = 0, this && (this.args = n);
  }
  indented(n) {
    this.indent += 1, n(this), this.indent -= 1;
  }
  write(n) {
    if (typeof n == "function") {
      n(this, { execution: "sync" }), n(this, { execution: "async" });
      return;
    }
    const o = n.split(`
`).filter((a) => a), t = Math.min(...o.map((a) => a.length - a.trimStart().length)), i = o.map((a) => a.slice(t)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of i)
      this.content.push(a);
  }
  compile() {
    const n = Function, r = this == null ? void 0 : this.args, t = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new n(...r, t.join(`
`));
  }
}
const Uo = {
  major: 4,
  minor: 1,
  patch: 12
}, S = /* @__PURE__ */ l("$ZodType", (e, n) => {
  var t;
  var r;
  e ?? (e = {}), e._zod.def = n, e._zod.bag = e._zod.bag || {}, e._zod.version = Uo;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const i of o)
    for (const a of i._zod.onattach)
      a(e);
  if (o.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (t = e._zod.deferred) == null || t.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const i = (u, c, s) => {
      let m = ce(u), p;
      for (const b of c) {
        if (b._zod.def.when) {
          if (!b._zod.def.when(u))
            continue;
        } else if (m)
          continue;
        const _ = u.issues.length, g = b._zod.check(u);
        if (g instanceof Promise && (s == null ? void 0 : s.async) === !1)
          throw new we();
        if (p || g instanceof Promise)
          p = (p ?? Promise.resolve()).then(async () => {
            await g, u.issues.length !== _ && (m || (m = ce(u, _)));
          });
        else {
          if (u.issues.length === _)
            continue;
          m || (m = ce(u, _));
        }
      }
      return p ? p.then(() => u) : u;
    }, a = (u, c, s) => {
      if (ce(u))
        return u.aborted = !0, u;
      const m = i(c, o, s);
      if (m instanceof Promise) {
        if (s.async === !1)
          throw new we();
        return m.then((p) => e._zod.parse(p, s));
      }
      return e._zod.parse(m, s);
    };
    e._zod.run = (u, c) => {
      if (c.skipChecks)
        return e._zod.parse(u, c);
      if (c.direction === "backward") {
        const m = e._zod.parse({ value: u.value, issues: [] }, { ...c, skipChecks: !0 });
        return m instanceof Promise ? m.then((p) => a(p, u, c)) : a(m, u, c);
      }
      const s = e._zod.parse(u, c);
      if (s instanceof Promise) {
        if (c.async === !1)
          throw new we();
        return s.then((m) => i(m, o, c));
      }
      return i(s, o, c);
    };
  }
  e["~standard"] = {
    validate: (i) => {
      var a;
      try {
        const u = Pt(e, i);
        return u.success ? { value: u.data } : { issues: (a = u.error) == null ? void 0 : a.issues };
      } catch {
        return ti(e, i).then((c) => {
          var s;
          return c.success ? { value: c.data } : { issues: (s = c.error) == null ? void 0 : s.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  };
}), Pe = /* @__PURE__ */ l("$ZodString", (e, n) => {
  var r;
  S.init(e, n), e._zod.pattern = [...((r = e == null ? void 0 : e._zod.bag) == null ? void 0 : r.patterns) ?? []].pop() ?? eo(e._zod.bag), e._zod.parse = (o, t) => {
    if (n.coerce)
      try {
        o.value = String(o.value);
      } catch {
      }
    return typeof o.value == "string" || o.issues.push({
      expected: "string",
      code: "invalid_type",
      input: o.value,
      inst: e
    }), o;
  };
}), O = /* @__PURE__ */ l("$ZodStringFormat", (e, n) => {
  Ee.init(e, n), Pe.init(e, n);
}), To = /* @__PURE__ */ l("$ZodGUID", (e, n) => {
  n.pattern ?? (n.pattern = Zi), O.init(e, n);
}), Eo = /* @__PURE__ */ l("$ZodUUID", (e, n) => {
  if (n.version) {
    const o = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[n.version];
    if (o === void 0)
      throw new Error(`Invalid UUID version: "${n.version}"`);
    n.pattern ?? (n.pattern = le(o));
  } else
    n.pattern ?? (n.pattern = le());
  O.init(e, n);
}), Po = /* @__PURE__ */ l("$ZodEmail", (e, n) => {
  n.pattern ?? (n.pattern = Li), O.init(e, n);
}), Co = /* @__PURE__ */ l("$ZodURL", (e, n) => {
  O.init(e, n), e._zod.check = (r) => {
    try {
      const o = r.value.trim(), t = new URL(o);
      n.hostname && (n.hostname.lastIndex = 0, n.hostname.test(t.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Vt.source,
        input: r.value,
        inst: e,
        continue: !n.abort
      })), n.protocol && (n.protocol.lastIndex = 0, n.protocol.test(t.protocol.endsWith(":") ? t.protocol.slice(0, -1) : t.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: n.protocol.source,
        input: r.value,
        inst: e,
        continue: !n.abort
      })), n.normalize ? r.value = t.href : r.value = o;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !n.abort
      });
    }
  };
}), Do = /* @__PURE__ */ l("$ZodEmoji", (e, n) => {
  n.pattern ?? (n.pattern = Bi()), O.init(e, n);
}), Ao = /* @__PURE__ */ l("$ZodNanoID", (e, n) => {
  n.pattern ?? (n.pattern = Di), O.init(e, n);
}), Zo = /* @__PURE__ */ l("$ZodCUID", (e, n) => {
  n.pattern ?? (n.pattern = Ui), O.init(e, n);
}), Lo = /* @__PURE__ */ l("$ZodCUID2", (e, n) => {
  n.pattern ?? (n.pattern = Ti), O.init(e, n);
}), Mo = /* @__PURE__ */ l("$ZodULID", (e, n) => {
  n.pattern ?? (n.pattern = Ei), O.init(e, n);
}), Bo = /* @__PURE__ */ l("$ZodXID", (e, n) => {
  n.pattern ?? (n.pattern = Pi), O.init(e, n);
}), Ro = /* @__PURE__ */ l("$ZodKSUID", (e, n) => {
  n.pattern ?? (n.pattern = Ci), O.init(e, n);
}), Fo = /* @__PURE__ */ l("$ZodISODateTime", (e, n) => {
  n.pattern ?? (n.pattern = Qi(n)), O.init(e, n);
}), Vo = /* @__PURE__ */ l("$ZodISODate", (e, n) => {
  n.pattern ?? (n.pattern = Xi), O.init(e, n);
}), Ho = /* @__PURE__ */ l("$ZodISOTime", (e, n) => {
  n.pattern ?? (n.pattern = Yi(n)), O.init(e, n);
}), Wo = /* @__PURE__ */ l("$ZodISODuration", (e, n) => {
  n.pattern ?? (n.pattern = Ai), O.init(e, n);
}), Jo = /* @__PURE__ */ l("$ZodIPv4", (e, n) => {
  n.pattern ?? (n.pattern = Ri), O.init(e, n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.format = "ipv4";
  });
}), Go = /* @__PURE__ */ l("$ZodIPv6", (e, n) => {
  n.pattern ?? (n.pattern = Fi), O.init(e, n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.format = "ipv6";
  }), e._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: e,
        continue: !n.abort
      });
    }
  };
}), Ko = /* @__PURE__ */ l("$ZodCIDRv4", (e, n) => {
  n.pattern ?? (n.pattern = Vi), O.init(e, n);
}), Xo = /* @__PURE__ */ l("$ZodCIDRv6", (e, n) => {
  n.pattern ?? (n.pattern = Hi), O.init(e, n), e._zod.check = (r) => {
    const o = r.value.split("/");
    try {
      if (o.length !== 2)
        throw new Error();
      const [t, i] = o;
      if (!i)
        throw new Error();
      const a = Number(i);
      if (`${a}` !== i)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${t}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: e,
        continue: !n.abort
      });
    }
  };
});
function Gt(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const qo = /* @__PURE__ */ l("$ZodBase64", (e, n) => {
  n.pattern ?? (n.pattern = Wi), O.init(e, n), e._zod.onattach.push((r) => {
    r._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (r) => {
    Gt(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
});
function Yo(e) {
  if (!Ft.test(e))
    return !1;
  const n = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), r = n.padEnd(Math.ceil(n.length / 4) * 4, "=");
  return Gt(r);
}
const Qo = /* @__PURE__ */ l("$ZodBase64URL", (e, n) => {
  n.pattern ?? (n.pattern = Ft), O.init(e, n), e._zod.onattach.push((r) => {
    r._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (r) => {
    Yo(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
}), ea = /* @__PURE__ */ l("$ZodE164", (e, n) => {
  n.pattern ?? (n.pattern = Gi), O.init(e, n);
});
function ta(e, n = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3)
      return !1;
    const [o] = r;
    if (!o)
      return !1;
    const t = JSON.parse(atob(o));
    return !("typ" in t && (t == null ? void 0 : t.typ) !== "JWT" || !t.alg || n && (!("alg" in t) || t.alg !== n));
  } catch {
    return !1;
  }
}
const na = /* @__PURE__ */ l("$ZodJWT", (e, n) => {
  O.init(e, n), e._zod.check = (r) => {
    ta(r.value, n.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
}), ra = /* @__PURE__ */ l("$ZodCustomStringFormat", (e, n) => {
  O.init(e, n), e._zod.check = (r) => {
    n.fn(r.value) || r.issues.push({
      code: "invalid_format",
      format: n.format,
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
}), Kt = /* @__PURE__ */ l("$ZodNumber", (e, n) => {
  S.init(e, n), e._zod.pattern = e._zod.bag.pattern ?? ro, e._zod.parse = (r, o) => {
    if (n.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const t = r.value;
    if (typeof t == "number" && !Number.isNaN(t) && Number.isFinite(t))
      return r;
    const i = typeof t == "number" ? Number.isNaN(t) ? "NaN" : Number.isFinite(t) ? void 0 : "Infinity" : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: t,
      inst: e,
      ...i ? { received: i } : {}
    }), r;
  };
}), ia = /* @__PURE__ */ l("$ZodNumber", (e, n) => {
  fo.init(e, n), Kt.init(e, n);
}), Xt = /* @__PURE__ */ l("$ZodBoolean", (e, n) => {
  S.init(e, n), e._zod.pattern = io, e._zod.parse = (r, o) => {
    if (n.coerce)
      try {
        r.value = !!r.value;
      } catch {
      }
    const t = r.value;
    return typeof t == "boolean" || r.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), qt = /* @__PURE__ */ l("$ZodBigInt", (e, n) => {
  S.init(e, n), e._zod.pattern = to, e._zod.parse = (r, o) => {
    if (n.coerce)
      try {
        r.value = BigInt(r.value);
      } catch {
      }
    return typeof r.value == "bigint" || r.issues.push({
      expected: "bigint",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), oa = /* @__PURE__ */ l("$ZodBigInt", (e, n) => {
  po.init(e, n), qt.init(e, n);
}), aa = /* @__PURE__ */ l("$ZodSymbol", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    const t = r.value;
    return typeof t == "symbol" || r.issues.push({
      expected: "symbol",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), ua = /* @__PURE__ */ l("$ZodUndefined", (e, n) => {
  S.init(e, n), e._zod.pattern = ao, e._zod.values = /* @__PURE__ */ new Set([void 0]), e._zod.optin = "optional", e._zod.optout = "optional", e._zod.parse = (r, o) => {
    const t = r.value;
    return typeof t > "u" || r.issues.push({
      expected: "undefined",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), ca = /* @__PURE__ */ l("$ZodNull", (e, n) => {
  S.init(e, n), e._zod.pattern = oo, e._zod.values = /* @__PURE__ */ new Set([null]), e._zod.parse = (r, o) => {
    const t = r.value;
    return t === null || r.issues.push({
      expected: "null",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), sa = /* @__PURE__ */ l("$ZodAny", (e, n) => {
  S.init(e, n), e._zod.parse = (r) => r;
}), la = /* @__PURE__ */ l("$ZodUnknown", (e, n) => {
  S.init(e, n), e._zod.parse = (r) => r;
}), da = /* @__PURE__ */ l("$ZodNever", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
}), ma = /* @__PURE__ */ l("$ZodVoid", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    const t = r.value;
    return typeof t > "u" || r.issues.push({
      expected: "void",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), fa = /* @__PURE__ */ l("$ZodDate", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    if (n.coerce)
      try {
        r.value = new Date(r.value);
      } catch {
      }
    const t = r.value, i = t instanceof Date;
    return i && !Number.isNaN(t.getTime()) || r.issues.push({
      expected: "date",
      code: "invalid_type",
      input: t,
      ...i ? { received: "Invalid Date" } : {},
      inst: e
    }), r;
  };
});
function Ur(e, n, r) {
  e.issues.length && n.issues.push(...G(r, e.issues)), n.value[r] = e.value;
}
const pa = /* @__PURE__ */ l("$ZodArray", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    const t = r.value;
    if (!Array.isArray(t))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: t,
        inst: e
      }), r;
    r.value = Array(t.length);
    const i = [];
    for (let a = 0; a < t.length; a++) {
      const u = t[a], c = n.element._zod.run({
        value: u,
        issues: []
      }, o);
      c instanceof Promise ? i.push(c.then((s) => Ur(s, r, a))) : Ur(c, r, a);
    }
    return i.length ? Promise.all(i).then(() => r) : r;
  };
});
function We(e, n, r, o) {
  e.issues.length && n.issues.push(...G(r, e.issues)), e.value === void 0 ? r in o && (n.value[r] = void 0) : n.value[r] = e.value;
}
function ga(e) {
  var o, t, i, a;
  const n = Object.keys(e.shape);
  for (const u of n)
    if (!((a = (i = (t = (o = e.shape) == null ? void 0 : o[u]) == null ? void 0 : t._zod) == null ? void 0 : i.traits) != null && a.has("$ZodType")))
      throw new Error(`Invalid element at key "${u}": expected a Zod schema`);
  const r = us(e.shape);
  return {
    ...e,
    keys: n,
    keySet: new Set(n),
    numKeys: n.length,
    optionalKeys: new Set(r)
  };
}
function va(e, n, r, o, t, i) {
  const a = [], u = t.keySet, c = t.catchall._zod, s = c.def.type;
  for (const m of Object.keys(n)) {
    if (u.has(m))
      continue;
    if (s === "never") {
      a.push(m);
      continue;
    }
    const p = c.run({ value: n[m], issues: [] }, o);
    p instanceof Promise ? e.push(p.then((b) => We(b, r, m, n))) : We(p, r, m, n);
  }
  return a.length && r.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: n,
    inst: i
  }), e.length ? Promise.all(e).then(() => r) : r;
}
const ha = /* @__PURE__ */ l("$ZodObject", (e, n) => {
  S.init(e, n);
  const r = Object.getOwnPropertyDescriptor(n, "shape");
  if (!(r != null && r.get)) {
    const u = n.shape;
    Object.defineProperty(n, "shape", {
      get: () => {
        const c = { ...u };
        return Object.defineProperty(n, "shape", {
          value: c
        }), c;
      }
    });
  }
  const o = Ct(() => ga(n));
  x(e._zod, "propValues", () => {
    const u = n.shape, c = {};
    for (const s in u) {
      const m = u[s]._zod;
      if (m.values) {
        c[s] ?? (c[s] = /* @__PURE__ */ new Set());
        for (const p of m.values)
          c[s].add(p);
      }
    }
    return c;
  });
  const t = Dt, i = n.catchall;
  let a;
  e._zod.parse = (u, c) => {
    a ?? (a = o.value);
    const s = u.value;
    if (!t(s))
      return u.issues.push({
        expected: "object",
        code: "invalid_type",
        input: s,
        inst: e
      }), u;
    u.value = {};
    const m = [], p = a.shape;
    for (const b of a.keys) {
      const g = p[b]._zod.run({ value: s[b], issues: [] }, c);
      g instanceof Promise ? m.push(g.then((N) => We(N, u, b, s))) : We(g, u, b, s);
    }
    return i ? va(m, s, u, c, o.value, e) : m.length ? Promise.all(m).then(() => u) : u;
  };
}), ba = /* @__PURE__ */ l("$ZodObjectJIT", (e, n) => {
  ha.init(e, n);
  const r = e._zod.parse, o = Ct(() => ga(n)), t = (b) => {
    const _ = new Oo(["shape", "payload", "ctx"]), g = o.value, N = (v) => {
      const k = yr(v);
      return `shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
    };
    _.write("const input = payload.value;");
    const $ = /* @__PURE__ */ Object.create(null);
    let d = 0;
    for (const v of g.keys)
      $[v] = `key_${d++}`;
    _.write("const newResult = {};");
    for (const v of g.keys) {
      const k = $[v], w = yr(v);
      _.write(`const ${k} = ${N(v)};`), _.write(`
        if (${k}.issues.length) {
          payload.issues = payload.issues.concat(${k}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${w}, ...iss.path] : [${w}]
          })));
        }
        
        
        if (${k}.value === undefined) {
          if (${w} in input) {
            newResult[${w}] = undefined;
          }
        } else {
          newResult[${w}] = ${k}.value;
        }
        
      `);
    }
    _.write("payload.value = newResult;"), _.write("return payload;");
    const y = _.compile();
    return (v, k) => y(b, v, k);
  };
  let i;
  const a = Dt, u = !ni.jitless, s = u && os.value, m = n.catchall;
  let p;
  e._zod.parse = (b, _) => {
    p ?? (p = o.value);
    const g = b.value;
    return a(g) ? u && s && (_ == null ? void 0 : _.async) === !1 && _.jitless !== !0 ? (i || (i = t(n.shape)), b = i(b, _), m ? va([], g, b, _, p, e) : b) : r(b, _) : (b.issues.push({
      expected: "object",
      code: "invalid_type",
      input: g,
      inst: e
    }), b);
  };
});
function Tr(e, n, r, o) {
  for (const i of e)
    if (i.issues.length === 0)
      return n.value = i.value, n;
  const t = e.filter((i) => !ce(i));
  return t.length === 1 ? (n.value = t[0].value, t[0]) : (n.issues.push({
    code: "invalid_union",
    input: n.value,
    inst: r,
    errors: e.map((i) => i.issues.map((a) => se(a, o, W())))
  }), n);
}
const Yt = /* @__PURE__ */ l("$ZodUnion", (e, n) => {
  S.init(e, n), x(e._zod, "optin", () => n.options.some((t) => t._zod.optin === "optional") ? "optional" : void 0), x(e._zod, "optout", () => n.options.some((t) => t._zod.optout === "optional") ? "optional" : void 0), x(e._zod, "values", () => {
    if (n.options.every((t) => t._zod.values))
      return new Set(n.options.flatMap((t) => Array.from(t._zod.values)));
  }), x(e._zod, "pattern", () => {
    if (n.options.every((t) => t._zod.pattern)) {
      const t = n.options.map((i) => i._zod.pattern);
      return new RegExp(`^(${t.map((i) => At(i.source)).join("|")})$`);
    }
  });
  const r = n.options.length === 1, o = n.options[0]._zod.run;
  e._zod.parse = (t, i) => {
    if (r)
      return o(t, i);
    let a = !1;
    const u = [];
    for (const c of n.options) {
      const s = c._zod.run({
        value: t.value,
        issues: []
      }, i);
      if (s instanceof Promise)
        u.push(s), a = !0;
      else {
        if (s.issues.length === 0)
          return s;
        u.push(s);
      }
    }
    return a ? Promise.all(u).then((c) => Tr(c, t, e, i)) : Tr(u, t, e, i);
  };
}), $a = /* @__PURE__ */ l("$ZodDiscriminatedUnion", (e, n) => {
  Yt.init(e, n);
  const r = e._zod.parse;
  x(e._zod, "propValues", () => {
    const t = {};
    for (const i of n.options) {
      const a = i._zod.propValues;
      if (!a || Object.keys(a).length === 0)
        throw new Error(`Invalid discriminated union option at index "${n.options.indexOf(i)}"`);
      for (const [u, c] of Object.entries(a)) {
        t[u] || (t[u] = /* @__PURE__ */ new Set());
        for (const s of c)
          t[u].add(s);
      }
    }
    return t;
  });
  const o = Ct(() => {
    var a;
    const t = n.options, i = /* @__PURE__ */ new Map();
    for (const u of t) {
      const c = (a = u._zod.propValues) == null ? void 0 : a[n.discriminator];
      if (!c || c.size === 0)
        throw new Error(`Invalid discriminated union option at index "${n.options.indexOf(u)}"`);
      for (const s of c) {
        if (i.has(s))
          throw new Error(`Duplicate discriminator value "${String(s)}"`);
        i.set(s, u);
      }
    }
    return i;
  });
  e._zod.parse = (t, i) => {
    const a = t.value;
    if (!Dt(a))
      return t.issues.push({
        code: "invalid_type",
        expected: "object",
        input: a,
        inst: e
      }), t;
    const u = o.value.get(a == null ? void 0 : a[n.discriminator]);
    return u ? u._zod.run(t, i) : n.unionFallback ? r(t, i) : (t.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: n.discriminator,
      input: a,
      path: [n.discriminator],
      inst: e
    }), t);
  };
}), _a = /* @__PURE__ */ l("$ZodIntersection", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    const t = r.value, i = n.left._zod.run({ value: t, issues: [] }, o), a = n.right._zod.run({ value: t, issues: [] }, o);
    return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([c, s]) => Er(r, c, s)) : Er(r, i, a);
  };
});
function zt(e, n) {
  if (e === n)
    return { valid: !0, data: e };
  if (e instanceof Date && n instanceof Date && +e == +n)
    return { valid: !0, data: e };
  if (kt(e) && kt(n)) {
    const r = Object.keys(n), o = Object.keys(e).filter((i) => r.indexOf(i) !== -1), t = { ...e, ...n };
    for (const i of o) {
      const a = zt(e[i], n[i]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...a.mergeErrorPath]
        };
      t[i] = a.data;
    }
    return { valid: !0, data: t };
  }
  if (Array.isArray(e) && Array.isArray(n)) {
    if (e.length !== n.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let o = 0; o < e.length; o++) {
      const t = e[o], i = n[o], a = zt(t, i);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      r.push(a.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Er(e, n, r) {
  if (n.issues.length && e.issues.push(...n.issues), r.issues.length && e.issues.push(...r.issues), ce(e))
    return e;
  const o = zt(n.value, r.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const Qt = /* @__PURE__ */ l("$ZodTuple", (e, n) => {
  S.init(e, n);
  const r = n.items, o = r.length - [...r].reverse().findIndex((t) => t._zod.optin !== "optional");
  e._zod.parse = (t, i) => {
    const a = t.value;
    if (!Array.isArray(a))
      return t.issues.push({
        input: a,
        inst: e,
        expected: "tuple",
        code: "invalid_type"
      }), t;
    t.value = [];
    const u = [];
    if (!n.rest) {
      const s = a.length > r.length, m = a.length < o - 1;
      if (s || m)
        return t.issues.push({
          ...s ? { code: "too_big", maximum: r.length } : { code: "too_small", minimum: r.length },
          input: a,
          inst: e,
          origin: "array"
        }), t;
    }
    let c = -1;
    for (const s of r) {
      if (c++, c >= a.length && c >= o)
        continue;
      const m = s._zod.run({
        value: a[c],
        issues: []
      }, i);
      m instanceof Promise ? u.push(m.then((p) => Le(p, t, c))) : Le(m, t, c);
    }
    if (n.rest) {
      const s = a.slice(r.length);
      for (const m of s) {
        c++;
        const p = n.rest._zod.run({
          value: m,
          issues: []
        }, i);
        p instanceof Promise ? u.push(p.then((b) => Le(b, t, c))) : Le(p, t, c);
      }
    }
    return u.length ? Promise.all(u).then(() => t) : t;
  };
});
function Le(e, n, r) {
  e.issues.length && n.issues.push(...G(r, e.issues)), n.value[r] = e.value;
}
const ya = /* @__PURE__ */ l("$ZodRecord", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    const t = r.value;
    if (!kt(t))
      return r.issues.push({
        expected: "record",
        code: "invalid_type",
        input: t,
        inst: e
      }), r;
    const i = [];
    if (n.keyType._zod.values) {
      const a = n.keyType._zod.values;
      r.value = {};
      for (const c of a)
        if (typeof c == "string" || typeof c == "number" || typeof c == "symbol") {
          const s = n.valueType._zod.run({ value: t[c], issues: [] }, o);
          s instanceof Promise ? i.push(s.then((m) => {
            m.issues.length && r.issues.push(...G(c, m.issues)), r.value[c] = m.value;
          })) : (s.issues.length && r.issues.push(...G(c, s.issues)), r.value[c] = s.value);
        }
      let u;
      for (const c in t)
        a.has(c) || (u = u ?? [], u.push(c));
      u && u.length > 0 && r.issues.push({
        code: "unrecognized_keys",
        input: t,
        inst: e,
        keys: u
      });
    } else {
      r.value = {};
      for (const a of Reflect.ownKeys(t)) {
        if (a === "__proto__")
          continue;
        const u = n.keyType._zod.run({ value: a, issues: [] }, o);
        if (u instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (u.issues.length) {
          r.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: u.issues.map((s) => se(s, o, W())),
            input: a,
            path: [a],
            inst: e
          }), r.value[u.value] = u.value;
          continue;
        }
        const c = n.valueType._zod.run({ value: t[a], issues: [] }, o);
        c instanceof Promise ? i.push(c.then((s) => {
          s.issues.length && r.issues.push(...G(a, s.issues)), r.value[u.value] = s.value;
        })) : (c.issues.length && r.issues.push(...G(a, c.issues)), r.value[u.value] = c.value);
      }
    }
    return i.length ? Promise.all(i).then(() => r) : r;
  };
}), ka = /* @__PURE__ */ l("$ZodMap", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    const t = r.value;
    if (!(t instanceof Map))
      return r.issues.push({
        expected: "map",
        code: "invalid_type",
        input: t,
        inst: e
      }), r;
    const i = [];
    r.value = /* @__PURE__ */ new Map();
    for (const [a, u] of t) {
      const c = n.keyType._zod.run({ value: a, issues: [] }, o), s = n.valueType._zod.run({ value: u, issues: [] }, o);
      c instanceof Promise || s instanceof Promise ? i.push(Promise.all([c, s]).then(([m, p]) => {
        Pr(m, p, r, a, t, e, o);
      })) : Pr(c, s, r, a, t, e, o);
    }
    return i.length ? Promise.all(i).then(() => r) : r;
  };
});
function Pr(e, n, r, o, t, i, a) {
  e.issues.length && (wt.has(typeof o) ? r.issues.push(...G(o, e.issues)) : r.issues.push({
    code: "invalid_key",
    origin: "map",
    input: t,
    inst: i,
    issues: e.issues.map((u) => se(u, a, W()))
  })), n.issues.length && (wt.has(typeof o) ? r.issues.push(...G(o, n.issues)) : r.issues.push({
    origin: "map",
    code: "invalid_element",
    input: t,
    inst: i,
    key: o,
    issues: n.issues.map((u) => se(u, a, W()))
  })), r.value.set(e.value, n.value);
}
const wa = /* @__PURE__ */ l("$ZodSet", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    const t = r.value;
    if (!(t instanceof Set))
      return r.issues.push({
        input: t,
        inst: e,
        expected: "set",
        code: "invalid_type"
      }), r;
    const i = [];
    r.value = /* @__PURE__ */ new Set();
    for (const a of t) {
      const u = n.valueType._zod.run({ value: a, issues: [] }, o);
      u instanceof Promise ? i.push(u.then((c) => Cr(c, r))) : Cr(u, r);
    }
    return i.length ? Promise.all(i).then(() => r) : r;
  };
});
function Cr(e, n) {
  e.issues.length && n.issues.push(...e.issues), n.value.add(e.value);
}
const Ia = /* @__PURE__ */ l("$ZodEnum", (e, n) => {
  S.init(e, n);
  const r = ri(n.entries), o = new Set(r);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${r.filter((t) => wt.has(typeof t)).map((t) => typeof t == "string" ? re(t) : t.toString()).join("|")})$`), e._zod.parse = (t, i) => {
    const a = t.value;
    return o.has(a) || t.issues.push({
      code: "invalid_value",
      values: r,
      input: a,
      inst: e
    }), t;
  };
}), Sa = /* @__PURE__ */ l("$ZodLiteral", (e, n) => {
  if (S.init(e, n), n.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  e._zod.values = new Set(n.values), e._zod.pattern = new RegExp(`^(${n.values.map((r) => typeof r == "string" ? re(r) : r ? re(r.toString()) : String(r)).join("|")})$`), e._zod.parse = (r, o) => {
    const t = r.value;
    return e._zod.values.has(t) || r.issues.push({
      code: "invalid_value",
      values: n.values,
      input: t,
      inst: e
    }), r;
  };
}), za = /* @__PURE__ */ l("$ZodFile", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    const t = r.value;
    return t instanceof File || r.issues.push({
      expected: "file",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), xa = /* @__PURE__ */ l("$ZodTransform", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    if (o.direction === "backward")
      throw new Ye(e.constructor.name);
    const t = n.transform(r.value, r);
    if (o.async)
      return (t instanceof Promise ? t : Promise.resolve(t)).then((a) => (r.value = a, r));
    if (t instanceof Promise)
      throw new we();
    return r.value = t, r;
  };
});
function Dr(e, n) {
  return e.issues.length && n === void 0 ? { issues: [], value: void 0 } : e;
}
const en = /* @__PURE__ */ l("$ZodOptional", (e, n) => {
  S.init(e, n), e._zod.optin = "optional", e._zod.optout = "optional", x(e._zod, "values", () => n.innerType._zod.values ? /* @__PURE__ */ new Set([...n.innerType._zod.values, void 0]) : void 0), x(e._zod, "pattern", () => {
    const r = n.innerType._zod.pattern;
    return r ? new RegExp(`^(${At(r.source)})?$`) : void 0;
  }), e._zod.parse = (r, o) => {
    if (n.innerType._zod.optin === "optional") {
      const t = n.innerType._zod.run(r, o);
      return t instanceof Promise ? t.then((i) => Dr(i, r.value)) : Dr(t, r.value);
    }
    return r.value === void 0 ? r : n.innerType._zod.run(r, o);
  };
}), Na = /* @__PURE__ */ l("$ZodNullable", (e, n) => {
  S.init(e, n), x(e._zod, "optin", () => n.innerType._zod.optin), x(e._zod, "optout", () => n.innerType._zod.optout), x(e._zod, "pattern", () => {
    const r = n.innerType._zod.pattern;
    return r ? new RegExp(`^(${At(r.source)}|null)$`) : void 0;
  }), x(e._zod, "values", () => n.innerType._zod.values ? /* @__PURE__ */ new Set([...n.innerType._zod.values, null]) : void 0), e._zod.parse = (r, o) => r.value === null ? r : n.innerType._zod.run(r, o);
}), ge = /* @__PURE__ */ l("$ZodDefault", (e, n) => {
  S.init(e, n), e._zod.optin = "optional", x(e._zod, "values", () => n.innerType._zod.values), e._zod.parse = (r, o) => {
    if (o.direction === "backward")
      return n.innerType._zod.run(r, o);
    if (r.value === void 0)
      return r.value = n.defaultValue, r;
    const t = n.innerType._zod.run(r, o);
    return t instanceof Promise ? t.then((i) => Ar(i, n)) : Ar(t, n);
  };
});
function Ar(e, n) {
  return e.value === void 0 && (e.value = n.defaultValue), e;
}
const ja = /* @__PURE__ */ l("$ZodPrefault", (e, n) => {
  S.init(e, n), e._zod.optin = "optional", x(e._zod, "values", () => n.innerType._zod.values), e._zod.parse = (r, o) => (o.direction === "backward" || r.value === void 0 && (r.value = n.defaultValue), n.innerType._zod.run(r, o));
}), Oa = /* @__PURE__ */ l("$ZodNonOptional", (e, n) => {
  S.init(e, n), x(e._zod, "values", () => {
    const r = n.innerType._zod.values;
    return r ? new Set([...r].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (r, o) => {
    const t = n.innerType._zod.run(r, o);
    return t instanceof Promise ? t.then((i) => Zr(i, e)) : Zr(t, e);
  };
});
function Zr(e, n) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: n
  }), e;
}
const Ua = /* @__PURE__ */ l("$ZodSuccess", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => {
    if (o.direction === "backward")
      throw new Ye("ZodSuccess");
    const t = n.innerType._zod.run(r, o);
    return t instanceof Promise ? t.then((i) => (r.value = i.issues.length === 0, r)) : (r.value = t.issues.length === 0, r);
  };
}), Ta = /* @__PURE__ */ l("$ZodCatch", (e, n) => {
  S.init(e, n), x(e._zod, "optin", () => n.innerType._zod.optin), x(e._zod, "optout", () => n.innerType._zod.optout), x(e._zod, "values", () => n.innerType._zod.values), e._zod.parse = (r, o) => {
    if (o.direction === "backward")
      return n.innerType._zod.run(r, o);
    const t = n.innerType._zod.run(r, o);
    return t instanceof Promise ? t.then((i) => (r.value = i.value, i.issues.length && (r.value = n.catchValue({
      ...r,
      error: {
        issues: i.issues.map((a) => se(a, o, W()))
      },
      input: r.value
    }), r.issues = []), r)) : (r.value = t.value, t.issues.length && (r.value = n.catchValue({
      ...r,
      error: {
        issues: t.issues.map((i) => se(i, o, W()))
      },
      input: r.value
    }), r.issues = []), r);
  };
}), Ea = /* @__PURE__ */ l("$ZodNaN", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => ((typeof r.value != "number" || !Number.isNaN(r.value)) && r.issues.push({
    input: r.value,
    inst: e,
    expected: "nan",
    code: "invalid_type"
  }), r);
}), Pa = /* @__PURE__ */ l("$ZodPipe", (e, n) => {
  S.init(e, n), x(e._zod, "values", () => n.in._zod.values), x(e._zod, "optin", () => n.in._zod.optin), x(e._zod, "optout", () => n.out._zod.optout), x(e._zod, "propValues", () => n.in._zod.propValues), e._zod.parse = (r, o) => {
    if (o.direction === "backward") {
      const i = n.out._zod.run(r, o);
      return i instanceof Promise ? i.then((a) => Me(a, n.in, o)) : Me(i, n.in, o);
    }
    const t = n.in._zod.run(r, o);
    return t instanceof Promise ? t.then((i) => Me(i, n.out, o)) : Me(t, n.out, o);
  };
});
function Me(e, n, r) {
  return e.issues.length ? (e.aborted = !0, e) : n._zod.run({ value: e.value, issues: e.issues }, r);
}
const tn = /* @__PURE__ */ l("$ZodCodec", (e, n) => {
  S.init(e, n), x(e._zod, "values", () => n.in._zod.values), x(e._zod, "optin", () => n.in._zod.optin), x(e._zod, "optout", () => n.out._zod.optout), x(e._zod, "propValues", () => n.in._zod.propValues), e._zod.parse = (r, o) => {
    if ((o.direction || "forward") === "forward") {
      const i = n.in._zod.run(r, o);
      return i instanceof Promise ? i.then((a) => Be(a, n, o)) : Be(i, n, o);
    } else {
      const i = n.out._zod.run(r, o);
      return i instanceof Promise ? i.then((a) => Be(a, n, o)) : Be(i, n, o);
    }
  };
});
function Be(e, n, r) {
  if (e.issues.length)
    return e.aborted = !0, e;
  if ((r.direction || "forward") === "forward") {
    const t = n.transform(e.value, e);
    return t instanceof Promise ? t.then((i) => Re(e, i, n.out, r)) : Re(e, t, n.out, r);
  } else {
    const t = n.reverseTransform(e.value, e);
    return t instanceof Promise ? t.then((i) => Re(e, i, n.in, r)) : Re(e, t, n.in, r);
  }
}
function Re(e, n, r, o) {
  return e.issues.length ? (e.aborted = !0, e) : r._zod.run({ value: n, issues: e.issues }, o);
}
const Ca = /* @__PURE__ */ l("$ZodReadonly", (e, n) => {
  S.init(e, n), x(e._zod, "propValues", () => n.innerType._zod.propValues), x(e._zod, "values", () => n.innerType._zod.values), x(e._zod, "optin", () => n.innerType._zod.optin), x(e._zod, "optout", () => n.innerType._zod.optout), e._zod.parse = (r, o) => {
    if (o.direction === "backward")
      return n.innerType._zod.run(r, o);
    const t = n.innerType._zod.run(r, o);
    return t instanceof Promise ? t.then(Lr) : Lr(t);
  };
});
function Lr(e) {
  return e.value = Object.freeze(e.value), e;
}
const Da = /* @__PURE__ */ l("$ZodTemplateLiteral", (e, n) => {
  S.init(e, n);
  const r = [];
  for (const o of n.parts)
    if (typeof o == "object" && o !== null) {
      if (!o._zod.pattern)
        throw new Error(`Invalid template literal part, no pattern found: ${[...o._zod.traits].shift()}`);
      const t = o._zod.pattern instanceof RegExp ? o._zod.pattern.source : o._zod.pattern;
      if (!t)
        throw new Error(`Invalid template literal part: ${o._zod.traits}`);
      const i = t.startsWith("^") ? 1 : 0, a = t.endsWith("$") ? t.length - 1 : t.length;
      r.push(t.slice(i, a));
    } else if (o === null || as.has(typeof o))
      r.push(re(`${o}`));
    else
      throw new Error(`Invalid template literal part: ${o}`);
  e._zod.pattern = new RegExp(`^${r.join("")}$`), e._zod.parse = (o, t) => typeof o.value != "string" ? (o.issues.push({
    input: o.value,
    inst: e,
    expected: "template_literal",
    code: "invalid_type"
  }), o) : (e._zod.pattern.lastIndex = 0, e._zod.pattern.test(o.value) || o.issues.push({
    input: o.value,
    inst: e,
    code: "invalid_format",
    format: n.format ?? "template_literal",
    pattern: e._zod.pattern.source
  }), o);
}), Aa = /* @__PURE__ */ l("$ZodFunction", (e, n) => (S.init(e, n), e._def = n, e._zod.def = n, e.implement = (r) => {
  if (typeof r != "function")
    throw new Error("implement() must be called with a function");
  return function(...o) {
    const t = e._def.input ? Ie(e._def.input, o) : o, i = Reflect.apply(r, this, t);
    return e._def.output ? Ie(e._def.output, i) : i;
  };
}, e.implementAsync = (r) => {
  if (typeof r != "function")
    throw new Error("implementAsync() must be called with a function");
  return async function(...o) {
    const t = e._def.input ? await It(e._def.input, o) : o, i = await Reflect.apply(r, this, t);
    return e._def.output ? await It(e._def.output, i) : i;
  };
}, e._zod.parse = (r, o) => typeof r.value != "function" ? (r.issues.push({
  code: "invalid_type",
  expected: "function",
  input: r.value,
  inst: e
}), r) : (e._def.output && e._def.output._zod.def.type === "promise" ? r.value = e.implementAsync(r.value) : r.value = e.implement(r.value), r), e.input = (...r) => {
  const o = e.constructor;
  return Array.isArray(r[0]) ? new o({
    type: "function",
    input: new Qt({
      type: "tuple",
      items: r[0],
      rest: r[1]
    }),
    output: e._def.output
  }) : new o({
    type: "function",
    input: r[0],
    output: e._def.output
  });
}, e.output = (r) => {
  const o = e.constructor;
  return new o({
    type: "function",
    input: e._def.input,
    output: r
  });
}, e)), Za = /* @__PURE__ */ l("$ZodPromise", (e, n) => {
  S.init(e, n), e._zod.parse = (r, o) => Promise.resolve(r.value).then((t) => n.innerType._zod.run({ value: t, issues: [] }, o));
}), La = /* @__PURE__ */ l("$ZodLazy", (e, n) => {
  S.init(e, n), x(e._zod, "innerType", () => n.getter()), x(e._zod, "pattern", () => e._zod.innerType._zod.pattern), x(e._zod, "propValues", () => e._zod.innerType._zod.propValues), x(e._zod, "optin", () => e._zod.innerType._zod.optin ?? void 0), x(e._zod, "optout", () => e._zod.innerType._zod.optout ?? void 0), e._zod.parse = (r, o) => e._zod.innerType._zod.run(r, o);
}), Ma = /* @__PURE__ */ l("$ZodCustom", (e, n) => {
  T.init(e, n), S.init(e, n), e._zod.parse = (r, o) => r, e._zod.check = (r) => {
    const o = r.value, t = n.fn(o);
    if (t instanceof Promise)
      return t.then((i) => Mr(i, r, o, e));
    Mr(t, r, o, e);
  };
});
function Mr(e, n, r, o) {
  if (!e) {
    const t = {
      code: "custom",
      input: r,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (t.params = o._zod.def.params), n.issues.push(Se(t));
  }
}
const Nl = () => {
  const e = {
    string: { unit: "حرف", verb: "أن يحوي" },
    file: { unit: "بايت", verb: "أن يحوي" },
    array: { unit: "عنصر", verb: "أن يحوي" },
    set: { unit: "عنصر", verb: "أن يحوي" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "مدخل",
    email: "بريد إلكتروني",
    url: "رابط",
    emoji: "إيموجي",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "تاريخ ووقت بمعيار ISO",
    date: "تاريخ بمعيار ISO",
    time: "وقت بمعيار ISO",
    duration: "مدة بمعيار ISO",
    ipv4: "عنوان IPv4",
    ipv6: "عنوان IPv6",
    cidrv4: "مدى عناوين بصيغة IPv4",
    cidrv6: "مدى عناوين بصيغة IPv6",
    base64: "نَص بترميز base64-encoded",
    base64url: "نَص بترميز base64url-encoded",
    json_string: "نَص على هيئة JSON",
    e164: "رقم هاتف بمعيار E.164",
    jwt: "JWT",
    template_literal: "مدخل"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `مدخلات غير مقبولة: يفترض إدخال ${t.expected}، ولكن تم إدخال ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `مدخلات غير مقبولة: يفترض إدخال ${I(t.values[0])}` : `اختيار غير مقبول: يتوقع انتقاء أحد هذه الخيارات: ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? ` أكبر من اللازم: يفترض أن تكون ${t.origin ?? "القيمة"} ${i} ${t.maximum.toString()} ${a.unit ?? "عنصر"}` : `أكبر من اللازم: يفترض أن تكون ${t.origin ?? "القيمة"} ${i} ${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `أصغر من اللازم: يفترض لـ ${t.origin} أن يكون ${i} ${t.minimum.toString()} ${a.unit}` : `أصغر من اللازم: يفترض لـ ${t.origin} أن يكون ${i} ${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `نَص غير مقبول: يجب أن يبدأ بـ "${t.prefix}"` : i.format === "ends_with" ? `نَص غير مقبول: يجب أن ينتهي بـ "${i.suffix}"` : i.format === "includes" ? `نَص غير مقبول: يجب أن يتضمَّن "${i.includes}"` : i.format === "regex" ? `نَص غير مقبول: يجب أن يطابق النمط ${i.pattern}` : `${o[i.format] ?? t.format} غير مقبول`;
      }
      case "not_multiple_of":
        return `رقم غير مقبول: يجب أن يكون من مضاعفات ${t.divisor}`;
      case "unrecognized_keys":
        return `معرف${t.keys.length > 1 ? "ات" : ""} غريب${t.keys.length > 1 ? "ة" : ""}: ${h(t.keys, "، ")}`;
      case "invalid_key":
        return `معرف غير مقبول في ${t.origin}`;
      case "invalid_union":
        return "مدخل غير مقبول";
      case "invalid_element":
        return `مدخل غير مقبول في ${t.origin}`;
      default:
        return "مدخل غير مقبول";
    }
  };
};
function jl() {
  return {
    localeError: Nl()
  };
}
const Ol = () => {
  const e = {
    string: { unit: "simvol", verb: "olmalıdır" },
    file: { unit: "bayt", verb: "olmalıdır" },
    array: { unit: "element", verb: "olmalıdır" },
    set: { unit: "element", verb: "olmalıdır" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Yanlış dəyər: gözlənilən ${t.expected}, daxil olan ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Yanlış dəyər: gözlənilən ${I(t.values[0])}` : `Yanlış seçim: aşağıdakılardan biri olmalıdır: ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Çox böyük: gözlənilən ${t.origin ?? "dəyər"} ${i}${t.maximum.toString()} ${a.unit ?? "element"}` : `Çox böyük: gözlənilən ${t.origin ?? "dəyər"} ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Çox kiçik: gözlənilən ${t.origin} ${i}${t.minimum.toString()} ${a.unit}` : `Çox kiçik: gözlənilən ${t.origin} ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Yanlış mətn: "${i.prefix}" ilə başlamalıdır` : i.format === "ends_with" ? `Yanlış mətn: "${i.suffix}" ilə bitməlidir` : i.format === "includes" ? `Yanlış mətn: "${i.includes}" daxil olmalıdır` : i.format === "regex" ? `Yanlış mətn: ${i.pattern} şablonuna uyğun olmalıdır` : `Yanlış ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Yanlış ədəd: ${t.divisor} ilə bölünə bilən olmalıdır`;
      case "unrecognized_keys":
        return `Tanınmayan açar${t.keys.length > 1 ? "lar" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `${t.origin} daxilində yanlış açar`;
      case "invalid_union":
        return "Yanlış dəyər";
      case "invalid_element":
        return `${t.origin} daxilində yanlış dəyər`;
      default:
        return "Yanlış dəyər";
    }
  };
};
function Ul() {
  return {
    localeError: Ol()
  };
}
function Br(e, n, r, o) {
  const t = Math.abs(e), i = t % 10, a = t % 100;
  return a >= 11 && a <= 19 ? o : i === 1 ? n : i >= 2 && i <= 4 ? r : o;
}
const Tl = () => {
  const e = {
    string: {
      unit: {
        one: "сімвал",
        few: "сімвалы",
        many: "сімвалаў"
      },
      verb: "мець"
    },
    array: {
      unit: {
        one: "элемент",
        few: "элементы",
        many: "элементаў"
      },
      verb: "мець"
    },
    set: {
      unit: {
        one: "элемент",
        few: "элементы",
        many: "элементаў"
      },
      verb: "мець"
    },
    file: {
      unit: {
        one: "байт",
        few: "байты",
        many: "байтаў"
      },
      verb: "мець"
    }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "лік";
      case "object": {
        if (Array.isArray(t))
          return "масіў";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "увод",
    email: "email адрас",
    url: "URL",
    emoji: "эмодзі",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO дата і час",
    date: "ISO дата",
    time: "ISO час",
    duration: "ISO працягласць",
    ipv4: "IPv4 адрас",
    ipv6: "IPv6 адрас",
    cidrv4: "IPv4 дыяпазон",
    cidrv6: "IPv6 дыяпазон",
    base64: "радок у фармаце base64",
    base64url: "радок у фармаце base64url",
    json_string: "JSON радок",
    e164: "нумар E.164",
    jwt: "JWT",
    template_literal: "увод"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Няправільны ўвод: чакаўся ${t.expected}, атрымана ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Няправільны ўвод: чакалася ${I(t.values[0])}` : `Няправільны варыянт: чакаўся адзін з ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        if (a) {
          const u = Number(t.maximum), c = Br(u, a.unit.one, a.unit.few, a.unit.many);
          return `Занадта вялікі: чакалася, што ${t.origin ?? "значэнне"} павінна ${a.verb} ${i}${t.maximum.toString()} ${c}`;
        }
        return `Занадта вялікі: чакалася, што ${t.origin ?? "значэнне"} павінна быць ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        if (a) {
          const u = Number(t.minimum), c = Br(u, a.unit.one, a.unit.few, a.unit.many);
          return `Занадта малы: чакалася, што ${t.origin} павінна ${a.verb} ${i}${t.minimum.toString()} ${c}`;
        }
        return `Занадта малы: чакалася, што ${t.origin} павінна быць ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Няправільны радок: павінен пачынацца з "${i.prefix}"` : i.format === "ends_with" ? `Няправільны радок: павінен заканчвацца на "${i.suffix}"` : i.format === "includes" ? `Няправільны радок: павінен змяшчаць "${i.includes}"` : i.format === "regex" ? `Няправільны радок: павінен адпавядаць шаблону ${i.pattern}` : `Няправільны ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Няправільны лік: павінен быць кратным ${t.divisor}`;
      case "unrecognized_keys":
        return `Нераспазнаны ${t.keys.length > 1 ? "ключы" : "ключ"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Няправільны ключ у ${t.origin}`;
      case "invalid_union":
        return "Няправільны ўвод";
      case "invalid_element":
        return `Няправільнае значэнне ў ${t.origin}`;
      default:
        return "Няправільны ўвод";
    }
  };
};
function El() {
  return {
    localeError: Tl()
  };
}
const Pl = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "число";
    case "object": {
      if (Array.isArray(e))
        return "масив";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, Cl = () => {
  const e = {
    string: { unit: "символа", verb: "да съдържа" },
    file: { unit: "байта", verb: "да съдържа" },
    array: { unit: "елемента", verb: "да съдържа" },
    set: { unit: "елемента", verb: "да съдържа" }
  };
  function n(o) {
    return e[o] ?? null;
  }
  const r = {
    regex: "вход",
    email: "имейл адрес",
    url: "URL",
    emoji: "емоджи",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO време",
    date: "ISO дата",
    time: "ISO време",
    duration: "ISO продължителност",
    ipv4: "IPv4 адрес",
    ipv6: "IPv6 адрес",
    cidrv4: "IPv4 диапазон",
    cidrv6: "IPv6 диапазон",
    base64: "base64-кодиран низ",
    base64url: "base64url-кодиран низ",
    json_string: "JSON низ",
    e164: "E.164 номер",
    jwt: "JWT",
    template_literal: "вход"
  };
  return (o) => {
    switch (o.code) {
      case "invalid_type":
        return `Невалиден вход: очакван ${o.expected}, получен ${Pl(o.input)}`;
      case "invalid_value":
        return o.values.length === 1 ? `Невалиден вход: очакван ${I(o.values[0])}` : `Невалидна опция: очаквано едно от ${h(o.values, "|")}`;
      case "too_big": {
        const t = o.inclusive ? "<=" : "<", i = n(o.origin);
        return i ? `Твърде голямо: очаква се ${o.origin ?? "стойност"} да съдържа ${t}${o.maximum.toString()} ${i.unit ?? "елемента"}` : `Твърде голямо: очаква се ${o.origin ?? "стойност"} да бъде ${t}${o.maximum.toString()}`;
      }
      case "too_small": {
        const t = o.inclusive ? ">=" : ">", i = n(o.origin);
        return i ? `Твърде малко: очаква се ${o.origin} да съдържа ${t}${o.minimum.toString()} ${i.unit}` : `Твърде малко: очаква се ${o.origin} да бъде ${t}${o.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = o;
        if (t.format === "starts_with")
          return `Невалиден низ: трябва да започва с "${t.prefix}"`;
        if (t.format === "ends_with")
          return `Невалиден низ: трябва да завършва с "${t.suffix}"`;
        if (t.format === "includes")
          return `Невалиден низ: трябва да включва "${t.includes}"`;
        if (t.format === "regex")
          return `Невалиден низ: трябва да съвпада с ${t.pattern}`;
        let i = "Невалиден";
        return t.format === "emoji" && (i = "Невалидно"), t.format === "datetime" && (i = "Невалидно"), t.format === "date" && (i = "Невалидна"), t.format === "time" && (i = "Невалидно"), t.format === "duration" && (i = "Невалидна"), `${i} ${r[t.format] ?? o.format}`;
      }
      case "not_multiple_of":
        return `Невалидно число: трябва да бъде кратно на ${o.divisor}`;
      case "unrecognized_keys":
        return `Неразпознат${o.keys.length > 1 ? "и" : ""} ключ${o.keys.length > 1 ? "ове" : ""}: ${h(o.keys, ", ")}`;
      case "invalid_key":
        return `Невалиден ключ в ${o.origin}`;
      case "invalid_union":
        return "Невалиден вход";
      case "invalid_element":
        return `Невалидна стойност в ${o.origin}`;
      default:
        return "Невалиден вход";
    }
  };
};
function Dl() {
  return {
    localeError: Cl()
  };
}
const Al = () => {
  const e = {
    string: { unit: "caràcters", verb: "contenir" },
    file: { unit: "bytes", verb: "contenir" },
    array: { unit: "elements", verb: "contenir" },
    set: { unit: "elements", verb: "contenir" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "entrada",
    email: "adreça electrònica",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data i hora ISO",
    date: "data ISO",
    time: "hora ISO",
    duration: "durada ISO",
    ipv4: "adreça IPv4",
    ipv6: "adreça IPv6",
    cidrv4: "rang IPv4",
    cidrv6: "rang IPv6",
    base64: "cadena codificada en base64",
    base64url: "cadena codificada en base64url",
    json_string: "cadena JSON",
    e164: "número E.164",
    jwt: "JWT",
    template_literal: "entrada"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Tipus invàlid: s'esperava ${t.expected}, s'ha rebut ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Valor invàlid: s'esperava ${I(t.values[0])}` : `Opció invàlida: s'esperava una de ${h(t.values, " o ")}`;
      case "too_big": {
        const i = t.inclusive ? "com a màxim" : "menys de", a = n(t.origin);
        return a ? `Massa gran: s'esperava que ${t.origin ?? "el valor"} contingués ${i} ${t.maximum.toString()} ${a.unit ?? "elements"}` : `Massa gran: s'esperava que ${t.origin ?? "el valor"} fos ${i} ${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? "com a mínim" : "més de", a = n(t.origin);
        return a ? `Massa petit: s'esperava que ${t.origin} contingués ${i} ${t.minimum.toString()} ${a.unit}` : `Massa petit: s'esperava que ${t.origin} fos ${i} ${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Format invàlid: ha de començar amb "${i.prefix}"` : i.format === "ends_with" ? `Format invàlid: ha d'acabar amb "${i.suffix}"` : i.format === "includes" ? `Format invàlid: ha d'incloure "${i.includes}"` : i.format === "regex" ? `Format invàlid: ha de coincidir amb el patró ${i.pattern}` : `Format invàlid per a ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Número invàlid: ha de ser múltiple de ${t.divisor}`;
      case "unrecognized_keys":
        return `Clau${t.keys.length > 1 ? "s" : ""} no reconeguda${t.keys.length > 1 ? "s" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Clau invàlida a ${t.origin}`;
      case "invalid_union":
        return "Entrada invàlida";
      case "invalid_element":
        return `Element invàlid a ${t.origin}`;
      default:
        return "Entrada invàlida";
    }
  };
};
function Zl() {
  return {
    localeError: Al()
  };
}
const Ll = () => {
  const e = {
    string: { unit: "znaků", verb: "mít" },
    file: { unit: "bajtů", verb: "mít" },
    array: { unit: "prvků", verb: "mít" },
    set: { unit: "prvků", verb: "mít" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "číslo";
      case "string":
        return "řetězec";
      case "boolean":
        return "boolean";
      case "bigint":
        return "bigint";
      case "function":
        return "funkce";
      case "symbol":
        return "symbol";
      case "undefined":
        return "undefined";
      case "object": {
        if (Array.isArray(t))
          return "pole";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "regulární výraz",
    email: "e-mailová adresa",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "datum a čas ve formátu ISO",
    date: "datum ve formátu ISO",
    time: "čas ve formátu ISO",
    duration: "doba trvání ISO",
    ipv4: "IPv4 adresa",
    ipv6: "IPv6 adresa",
    cidrv4: "rozsah IPv4",
    cidrv6: "rozsah IPv6",
    base64: "řetězec zakódovaný ve formátu base64",
    base64url: "řetězec zakódovaný ve formátu base64url",
    json_string: "řetězec ve formátu JSON",
    e164: "číslo E.164",
    jwt: "JWT",
    template_literal: "vstup"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Neplatný vstup: očekáváno ${t.expected}, obdrženo ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Neplatný vstup: očekáváno ${I(t.values[0])}` : `Neplatná možnost: očekávána jedna z hodnot ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Hodnota je příliš velká: ${t.origin ?? "hodnota"} musí mít ${i}${t.maximum.toString()} ${a.unit ?? "prvků"}` : `Hodnota je příliš velká: ${t.origin ?? "hodnota"} musí být ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Hodnota je příliš malá: ${t.origin ?? "hodnota"} musí mít ${i}${t.minimum.toString()} ${a.unit ?? "prvků"}` : `Hodnota je příliš malá: ${t.origin ?? "hodnota"} musí být ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Neplatný řetězec: musí začínat na "${i.prefix}"` : i.format === "ends_with" ? `Neplatný řetězec: musí končit na "${i.suffix}"` : i.format === "includes" ? `Neplatný řetězec: musí obsahovat "${i.includes}"` : i.format === "regex" ? `Neplatný řetězec: musí odpovídat vzoru ${i.pattern}` : `Neplatný formát ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Neplatné číslo: musí být násobkem ${t.divisor}`;
      case "unrecognized_keys":
        return `Neznámé klíče: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Neplatný klíč v ${t.origin}`;
      case "invalid_union":
        return "Neplatný vstup";
      case "invalid_element":
        return `Neplatná hodnota v ${t.origin}`;
      default:
        return "Neplatný vstup";
    }
  };
};
function Ml() {
  return {
    localeError: Ll()
  };
}
const Bl = () => {
  const e = {
    string: { unit: "tegn", verb: "havde" },
    file: { unit: "bytes", verb: "havde" },
    array: { unit: "elementer", verb: "indeholdt" },
    set: { unit: "elementer", verb: "indeholdt" }
  }, n = {
    string: "streng",
    number: "tal",
    boolean: "boolean",
    array: "liste",
    object: "objekt",
    set: "sæt",
    file: "fil"
  };
  function r(a) {
    return e[a] ?? null;
  }
  function o(a) {
    return n[a] ?? a;
  }
  const t = (a) => {
    const u = typeof a;
    switch (u) {
      case "number":
        return Number.isNaN(a) ? "NaN" : "tal";
      case "object":
        return Array.isArray(a) ? "liste" : a === null ? "null" : Object.getPrototypeOf(a) !== Object.prototype && a.constructor ? a.constructor.name : "objekt";
    }
    return u;
  }, i = {
    regex: "input",
    email: "e-mailadresse",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO dato- og klokkeslæt",
    date: "ISO-dato",
    time: "ISO-klokkeslæt",
    duration: "ISO-varighed",
    ipv4: "IPv4-område",
    ipv6: "IPv6-område",
    cidrv4: "IPv4-spektrum",
    cidrv6: "IPv6-spektrum",
    base64: "base64-kodet streng",
    base64url: "base64url-kodet streng",
    json_string: "JSON-streng",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "input"
  };
  return (a) => {
    switch (a.code) {
      case "invalid_type":
        return `Ugyldigt input: forventede ${o(a.expected)}, fik ${o(t(a.input))}`;
      case "invalid_value":
        return a.values.length === 1 ? `Ugyldig værdi: forventede ${I(a.values[0])}` : `Ugyldigt valg: forventede en af følgende ${h(a.values, "|")}`;
      case "too_big": {
        const u = a.inclusive ? "<=" : "<", c = r(a.origin), s = o(a.origin);
        return c ? `For stor: forventede ${s ?? "value"} ${c.verb} ${u} ${a.maximum.toString()} ${c.unit ?? "elementer"}` : `For stor: forventede ${s ?? "value"} havde ${u} ${a.maximum.toString()}`;
      }
      case "too_small": {
        const u = a.inclusive ? ">=" : ">", c = r(a.origin), s = o(a.origin);
        return c ? `For lille: forventede ${s} ${c.verb} ${u} ${a.minimum.toString()} ${c.unit}` : `For lille: forventede ${s} havde ${u} ${a.minimum.toString()}`;
      }
      case "invalid_format": {
        const u = a;
        return u.format === "starts_with" ? `Ugyldig streng: skal starte med "${u.prefix}"` : u.format === "ends_with" ? `Ugyldig streng: skal ende med "${u.suffix}"` : u.format === "includes" ? `Ugyldig streng: skal indeholde "${u.includes}"` : u.format === "regex" ? `Ugyldig streng: skal matche mønsteret ${u.pattern}` : `Ugyldig ${i[u.format] ?? a.format}`;
      }
      case "not_multiple_of":
        return `Ugyldigt tal: skal være deleligt med ${a.divisor}`;
      case "unrecognized_keys":
        return `${a.keys.length > 1 ? "Ukendte nøgler" : "Ukendt nøgle"}: ${h(a.keys, ", ")}`;
      case "invalid_key":
        return `Ugyldig nøgle i ${a.origin}`;
      case "invalid_union":
        return "Ugyldigt input: matcher ingen af de tilladte typer";
      case "invalid_element":
        return `Ugyldig værdi i ${a.origin}`;
      default:
        return "Ugyldigt input";
    }
  };
};
function Rl() {
  return {
    localeError: Bl()
  };
}
const Fl = () => {
  const e = {
    string: { unit: "Zeichen", verb: "zu haben" },
    file: { unit: "Bytes", verb: "zu haben" },
    array: { unit: "Elemente", verb: "zu haben" },
    set: { unit: "Elemente", verb: "zu haben" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "Zahl";
      case "object": {
        if (Array.isArray(t))
          return "Array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "Eingabe",
    email: "E-Mail-Adresse",
    url: "URL",
    emoji: "Emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-Datum und -Uhrzeit",
    date: "ISO-Datum",
    time: "ISO-Uhrzeit",
    duration: "ISO-Dauer",
    ipv4: "IPv4-Adresse",
    ipv6: "IPv6-Adresse",
    cidrv4: "IPv4-Bereich",
    cidrv6: "IPv6-Bereich",
    base64: "Base64-codierter String",
    base64url: "Base64-URL-codierter String",
    json_string: "JSON-String",
    e164: "E.164-Nummer",
    jwt: "JWT",
    template_literal: "Eingabe"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ungültige Eingabe: erwartet ${t.expected}, erhalten ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ungültige Eingabe: erwartet ${I(t.values[0])}` : `Ungültige Option: erwartet eine von ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Zu groß: erwartet, dass ${t.origin ?? "Wert"} ${i}${t.maximum.toString()} ${a.unit ?? "Elemente"} hat` : `Zu groß: erwartet, dass ${t.origin ?? "Wert"} ${i}${t.maximum.toString()} ist`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Zu klein: erwartet, dass ${t.origin} ${i}${t.minimum.toString()} ${a.unit} hat` : `Zu klein: erwartet, dass ${t.origin} ${i}${t.minimum.toString()} ist`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Ungültiger String: muss mit "${i.prefix}" beginnen` : i.format === "ends_with" ? `Ungültiger String: muss mit "${i.suffix}" enden` : i.format === "includes" ? `Ungültiger String: muss "${i.includes}" enthalten` : i.format === "regex" ? `Ungültiger String: muss dem Muster ${i.pattern} entsprechen` : `Ungültig: ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Ungültige Zahl: muss ein Vielfaches von ${t.divisor} sein`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Unbekannte Schlüssel" : "Unbekannter Schlüssel"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Ungültiger Schlüssel in ${t.origin}`;
      case "invalid_union":
        return "Ungültige Eingabe";
      case "invalid_element":
        return `Ungültiger Wert in ${t.origin}`;
      default:
        return "Ungültige Eingabe";
    }
  };
};
function Vl() {
  return {
    localeError: Fl()
  };
}
const Hl = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "number";
    case "object": {
      if (Array.isArray(e))
        return "array";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, Wl = () => {
  const e = {
    string: { unit: "characters", verb: "to have" },
    file: { unit: "bytes", verb: "to have" },
    array: { unit: "items", verb: "to have" },
    set: { unit: "items", verb: "to have" }
  };
  function n(o) {
    return e[o] ?? null;
  }
  const r = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    jwt: "JWT",
    template_literal: "input"
  };
  return (o) => {
    switch (o.code) {
      case "invalid_type":
        return `Invalid input: expected ${o.expected}, received ${Hl(o.input)}`;
      case "invalid_value":
        return o.values.length === 1 ? `Invalid input: expected ${I(o.values[0])}` : `Invalid option: expected one of ${h(o.values, "|")}`;
      case "too_big": {
        const t = o.inclusive ? "<=" : "<", i = n(o.origin);
        return i ? `Too big: expected ${o.origin ?? "value"} to have ${t}${o.maximum.toString()} ${i.unit ?? "elements"}` : `Too big: expected ${o.origin ?? "value"} to be ${t}${o.maximum.toString()}`;
      }
      case "too_small": {
        const t = o.inclusive ? ">=" : ">", i = n(o.origin);
        return i ? `Too small: expected ${o.origin} to have ${t}${o.minimum.toString()} ${i.unit}` : `Too small: expected ${o.origin} to be ${t}${o.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = o;
        return t.format === "starts_with" ? `Invalid string: must start with "${t.prefix}"` : t.format === "ends_with" ? `Invalid string: must end with "${t.suffix}"` : t.format === "includes" ? `Invalid string: must include "${t.includes}"` : t.format === "regex" ? `Invalid string: must match pattern ${t.pattern}` : `Invalid ${r[t.format] ?? o.format}`;
      }
      case "not_multiple_of":
        return `Invalid number: must be a multiple of ${o.divisor}`;
      case "unrecognized_keys":
        return `Unrecognized key${o.keys.length > 1 ? "s" : ""}: ${h(o.keys, ", ")}`;
      case "invalid_key":
        return `Invalid key in ${o.origin}`;
      case "invalid_union":
        return "Invalid input";
      case "invalid_element":
        return `Invalid value in ${o.origin}`;
      default:
        return "Invalid input";
    }
  };
};
function Ba() {
  return {
    localeError: Wl()
  };
}
const Jl = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "nombro";
    case "object": {
      if (Array.isArray(e))
        return "tabelo";
      if (e === null)
        return "senvalora";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, Gl = () => {
  const e = {
    string: { unit: "karaktrojn", verb: "havi" },
    file: { unit: "bajtojn", verb: "havi" },
    array: { unit: "elementojn", verb: "havi" },
    set: { unit: "elementojn", verb: "havi" }
  };
  function n(o) {
    return e[o] ?? null;
  }
  const r = {
    regex: "enigo",
    email: "retadreso",
    url: "URL",
    emoji: "emoĝio",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-datotempo",
    date: "ISO-dato",
    time: "ISO-tempo",
    duration: "ISO-daŭro",
    ipv4: "IPv4-adreso",
    ipv6: "IPv6-adreso",
    cidrv4: "IPv4-rango",
    cidrv6: "IPv6-rango",
    base64: "64-ume kodita karaktraro",
    base64url: "URL-64-ume kodita karaktraro",
    json_string: "JSON-karaktraro",
    e164: "E.164-nombro",
    jwt: "JWT",
    template_literal: "enigo"
  };
  return (o) => {
    switch (o.code) {
      case "invalid_type":
        return `Nevalida enigo: atendiĝis ${o.expected}, riceviĝis ${Jl(o.input)}`;
      case "invalid_value":
        return o.values.length === 1 ? `Nevalida enigo: atendiĝis ${I(o.values[0])}` : `Nevalida opcio: atendiĝis unu el ${h(o.values, "|")}`;
      case "too_big": {
        const t = o.inclusive ? "<=" : "<", i = n(o.origin);
        return i ? `Tro granda: atendiĝis ke ${o.origin ?? "valoro"} havu ${t}${o.maximum.toString()} ${i.unit ?? "elementojn"}` : `Tro granda: atendiĝis ke ${o.origin ?? "valoro"} havu ${t}${o.maximum.toString()}`;
      }
      case "too_small": {
        const t = o.inclusive ? ">=" : ">", i = n(o.origin);
        return i ? `Tro malgranda: atendiĝis ke ${o.origin} havu ${t}${o.minimum.toString()} ${i.unit}` : `Tro malgranda: atendiĝis ke ${o.origin} estu ${t}${o.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = o;
        return t.format === "starts_with" ? `Nevalida karaktraro: devas komenciĝi per "${t.prefix}"` : t.format === "ends_with" ? `Nevalida karaktraro: devas finiĝi per "${t.suffix}"` : t.format === "includes" ? `Nevalida karaktraro: devas inkluzivi "${t.includes}"` : t.format === "regex" ? `Nevalida karaktraro: devas kongrui kun la modelo ${t.pattern}` : `Nevalida ${r[t.format] ?? o.format}`;
      }
      case "not_multiple_of":
        return `Nevalida nombro: devas esti oblo de ${o.divisor}`;
      case "unrecognized_keys":
        return `Nekonata${o.keys.length > 1 ? "j" : ""} ŝlosilo${o.keys.length > 1 ? "j" : ""}: ${h(o.keys, ", ")}`;
      case "invalid_key":
        return `Nevalida ŝlosilo en ${o.origin}`;
      case "invalid_union":
        return "Nevalida enigo";
      case "invalid_element":
        return `Nevalida valoro en ${o.origin}`;
      default:
        return "Nevalida enigo";
    }
  };
};
function Kl() {
  return {
    localeError: Gl()
  };
}
const Xl = () => {
  const e = {
    string: { unit: "caracteres", verb: "tener" },
    file: { unit: "bytes", verb: "tener" },
    array: { unit: "elementos", verb: "tener" },
    set: { unit: "elementos", verb: "tener" }
  }, n = {
    string: "texto",
    number: "número",
    boolean: "booleano",
    array: "arreglo",
    object: "objeto",
    set: "conjunto",
    file: "archivo",
    date: "fecha",
    bigint: "número grande",
    symbol: "símbolo",
    undefined: "indefinido",
    null: "nulo",
    function: "función",
    map: "mapa",
    record: "registro",
    tuple: "tupla",
    enum: "enumeración",
    union: "unión",
    literal: "literal",
    promise: "promesa",
    void: "vacío",
    never: "nunca",
    unknown: "desconocido",
    any: "cualquiera"
  };
  function r(a) {
    return e[a] ?? null;
  }
  function o(a) {
    return n[a] ?? a;
  }
  const t = (a) => {
    const u = typeof a;
    switch (u) {
      case "number":
        return Number.isNaN(a) ? "NaN" : "number";
      case "object":
        return Array.isArray(a) ? "array" : a === null ? "null" : Object.getPrototypeOf(a) !== Object.prototype ? a.constructor.name : "object";
    }
    return u;
  }, i = {
    regex: "entrada",
    email: "dirección de correo electrónico",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "fecha y hora ISO",
    date: "fecha ISO",
    time: "hora ISO",
    duration: "duración ISO",
    ipv4: "dirección IPv4",
    ipv6: "dirección IPv6",
    cidrv4: "rango IPv4",
    cidrv6: "rango IPv6",
    base64: "cadena codificada en base64",
    base64url: "URL codificada en base64",
    json_string: "cadena JSON",
    e164: "número E.164",
    jwt: "JWT",
    template_literal: "entrada"
  };
  return (a) => {
    switch (a.code) {
      case "invalid_type":
        return `Entrada inválida: se esperaba ${o(a.expected)}, recibido ${o(t(a.input))}`;
      case "invalid_value":
        return a.values.length === 1 ? `Entrada inválida: se esperaba ${I(a.values[0])}` : `Opción inválida: se esperaba una de ${h(a.values, "|")}`;
      case "too_big": {
        const u = a.inclusive ? "<=" : "<", c = r(a.origin), s = o(a.origin);
        return c ? `Demasiado grande: se esperaba que ${s ?? "valor"} tuviera ${u}${a.maximum.toString()} ${c.unit ?? "elementos"}` : `Demasiado grande: se esperaba que ${s ?? "valor"} fuera ${u}${a.maximum.toString()}`;
      }
      case "too_small": {
        const u = a.inclusive ? ">=" : ">", c = r(a.origin), s = o(a.origin);
        return c ? `Demasiado pequeño: se esperaba que ${s} tuviera ${u}${a.minimum.toString()} ${c.unit}` : `Demasiado pequeño: se esperaba que ${s} fuera ${u}${a.minimum.toString()}`;
      }
      case "invalid_format": {
        const u = a;
        return u.format === "starts_with" ? `Cadena inválida: debe comenzar con "${u.prefix}"` : u.format === "ends_with" ? `Cadena inválida: debe terminar en "${u.suffix}"` : u.format === "includes" ? `Cadena inválida: debe incluir "${u.includes}"` : u.format === "regex" ? `Cadena inválida: debe coincidir con el patrón ${u.pattern}` : `Inválido ${i[u.format] ?? a.format}`;
      }
      case "not_multiple_of":
        return `Número inválido: debe ser múltiplo de ${a.divisor}`;
      case "unrecognized_keys":
        return `Llave${a.keys.length > 1 ? "s" : ""} desconocida${a.keys.length > 1 ? "s" : ""}: ${h(a.keys, ", ")}`;
      case "invalid_key":
        return `Llave inválida en ${o(a.origin)}`;
      case "invalid_union":
        return "Entrada inválida";
      case "invalid_element":
        return `Valor inválido en ${o(a.origin)}`;
      default:
        return "Entrada inválida";
    }
  };
};
function ql() {
  return {
    localeError: Xl()
  };
}
const Yl = () => {
  const e = {
    string: { unit: "کاراکتر", verb: "داشته باشد" },
    file: { unit: "بایت", verb: "داشته باشد" },
    array: { unit: "آیتم", verb: "داشته باشد" },
    set: { unit: "آیتم", verb: "داشته باشد" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "عدد";
      case "object": {
        if (Array.isArray(t))
          return "آرایه";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "ورودی",
    email: "آدرس ایمیل",
    url: "URL",
    emoji: "ایموجی",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "تاریخ و زمان ایزو",
    date: "تاریخ ایزو",
    time: "زمان ایزو",
    duration: "مدت زمان ایزو",
    ipv4: "IPv4 آدرس",
    ipv6: "IPv6 آدرس",
    cidrv4: "IPv4 دامنه",
    cidrv6: "IPv6 دامنه",
    base64: "base64-encoded رشته",
    base64url: "base64url-encoded رشته",
    json_string: "JSON رشته",
    e164: "E.164 عدد",
    jwt: "JWT",
    template_literal: "ورودی"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `ورودی نامعتبر: می‌بایست ${t.expected} می‌بود، ${r(t.input)} دریافت شد`;
      case "invalid_value":
        return t.values.length === 1 ? `ورودی نامعتبر: می‌بایست ${I(t.values[0])} می‌بود` : `گزینه نامعتبر: می‌بایست یکی از ${h(t.values, "|")} می‌بود`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `خیلی بزرگ: ${t.origin ?? "مقدار"} باید ${i}${t.maximum.toString()} ${a.unit ?? "عنصر"} باشد` : `خیلی بزرگ: ${t.origin ?? "مقدار"} باید ${i}${t.maximum.toString()} باشد`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `خیلی کوچک: ${t.origin} باید ${i}${t.minimum.toString()} ${a.unit} باشد` : `خیلی کوچک: ${t.origin} باید ${i}${t.minimum.toString()} باشد`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `رشته نامعتبر: باید با "${i.prefix}" شروع شود` : i.format === "ends_with" ? `رشته نامعتبر: باید با "${i.suffix}" تمام شود` : i.format === "includes" ? `رشته نامعتبر: باید شامل "${i.includes}" باشد` : i.format === "regex" ? `رشته نامعتبر: باید با الگوی ${i.pattern} مطابقت داشته باشد` : `${o[i.format] ?? t.format} نامعتبر`;
      }
      case "not_multiple_of":
        return `عدد نامعتبر: باید مضرب ${t.divisor} باشد`;
      case "unrecognized_keys":
        return `کلید${t.keys.length > 1 ? "های" : ""} ناشناس: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `کلید ناشناس در ${t.origin}`;
      case "invalid_union":
        return "ورودی نامعتبر";
      case "invalid_element":
        return `مقدار نامعتبر در ${t.origin}`;
      default:
        return "ورودی نامعتبر";
    }
  };
};
function Ql() {
  return {
    localeError: Yl()
  };
}
const ed = () => {
  const e = {
    string: { unit: "merkkiä", subject: "merkkijonon" },
    file: { unit: "tavua", subject: "tiedoston" },
    array: { unit: "alkiota", subject: "listan" },
    set: { unit: "alkiota", subject: "joukon" },
    number: { unit: "", subject: "luvun" },
    bigint: { unit: "", subject: "suuren kokonaisluvun" },
    int: { unit: "", subject: "kokonaisluvun" },
    date: { unit: "", subject: "päivämäärän" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "säännöllinen lauseke",
    email: "sähköpostiosoite",
    url: "URL-osoite",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-aikaleima",
    date: "ISO-päivämäärä",
    time: "ISO-aika",
    duration: "ISO-kesto",
    ipv4: "IPv4-osoite",
    ipv6: "IPv6-osoite",
    cidrv4: "IPv4-alue",
    cidrv6: "IPv6-alue",
    base64: "base64-koodattu merkkijono",
    base64url: "base64url-koodattu merkkijono",
    json_string: "JSON-merkkijono",
    e164: "E.164-luku",
    jwt: "JWT",
    template_literal: "templaattimerkkijono"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Virheellinen tyyppi: odotettiin ${t.expected}, oli ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Virheellinen syöte: täytyy olla ${I(t.values[0])}` : `Virheellinen valinta: täytyy olla yksi seuraavista: ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Liian suuri: ${a.subject} täytyy olla ${i}${t.maximum.toString()} ${a.unit}`.trim() : `Liian suuri: arvon täytyy olla ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Liian pieni: ${a.subject} täytyy olla ${i}${t.minimum.toString()} ${a.unit}`.trim() : `Liian pieni: arvon täytyy olla ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Virheellinen syöte: täytyy alkaa "${i.prefix}"` : i.format === "ends_with" ? `Virheellinen syöte: täytyy loppua "${i.suffix}"` : i.format === "includes" ? `Virheellinen syöte: täytyy sisältää "${i.includes}"` : i.format === "regex" ? `Virheellinen syöte: täytyy vastata säännöllistä lauseketta ${i.pattern}` : `Virheellinen ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Virheellinen luku: täytyy olla luvun ${t.divisor} monikerta`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return "Virheellinen avain tietueessa";
      case "invalid_union":
        return "Virheellinen unioni";
      case "invalid_element":
        return "Virheellinen arvo joukossa";
      default:
        return "Virheellinen syöte";
    }
  };
};
function td() {
  return {
    localeError: ed()
  };
}
const nd = () => {
  const e = {
    string: { unit: "caractères", verb: "avoir" },
    file: { unit: "octets", verb: "avoir" },
    array: { unit: "éléments", verb: "avoir" },
    set: { unit: "éléments", verb: "avoir" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "nombre";
      case "object": {
        if (Array.isArray(t))
          return "tableau";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "entrée",
    email: "adresse e-mail",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "date et heure ISO",
    date: "date ISO",
    time: "heure ISO",
    duration: "durée ISO",
    ipv4: "adresse IPv4",
    ipv6: "adresse IPv6",
    cidrv4: "plage IPv4",
    cidrv6: "plage IPv6",
    base64: "chaîne encodée en base64",
    base64url: "chaîne encodée en base64url",
    json_string: "chaîne JSON",
    e164: "numéro E.164",
    jwt: "JWT",
    template_literal: "entrée"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Entrée invalide : ${t.expected} attendu, ${r(t.input)} reçu`;
      case "invalid_value":
        return t.values.length === 1 ? `Entrée invalide : ${I(t.values[0])} attendu` : `Option invalide : une valeur parmi ${h(t.values, "|")} attendue`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Trop grand : ${t.origin ?? "valeur"} doit ${a.verb} ${i}${t.maximum.toString()} ${a.unit ?? "élément(s)"}` : `Trop grand : ${t.origin ?? "valeur"} doit être ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Trop petit : ${t.origin} doit ${a.verb} ${i}${t.minimum.toString()} ${a.unit}` : `Trop petit : ${t.origin} doit être ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Chaîne invalide : doit commencer par "${i.prefix}"` : i.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${i.suffix}"` : i.format === "includes" ? `Chaîne invalide : doit inclure "${i.includes}"` : i.format === "regex" ? `Chaîne invalide : doit correspondre au modèle ${i.pattern}` : `${o[i.format] ?? t.format} invalide`;
      }
      case "not_multiple_of":
        return `Nombre invalide : doit être un multiple de ${t.divisor}`;
      case "unrecognized_keys":
        return `Clé${t.keys.length > 1 ? "s" : ""} non reconnue${t.keys.length > 1 ? "s" : ""} : ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Clé invalide dans ${t.origin}`;
      case "invalid_union":
        return "Entrée invalide";
      case "invalid_element":
        return `Valeur invalide dans ${t.origin}`;
      default:
        return "Entrée invalide";
    }
  };
};
function rd() {
  return {
    localeError: nd()
  };
}
const id = () => {
  const e = {
    string: { unit: "caractères", verb: "avoir" },
    file: { unit: "octets", verb: "avoir" },
    array: { unit: "éléments", verb: "avoir" },
    set: { unit: "éléments", verb: "avoir" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "entrée",
    email: "adresse courriel",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "date-heure ISO",
    date: "date ISO",
    time: "heure ISO",
    duration: "durée ISO",
    ipv4: "adresse IPv4",
    ipv6: "adresse IPv6",
    cidrv4: "plage IPv4",
    cidrv6: "plage IPv6",
    base64: "chaîne encodée en base64",
    base64url: "chaîne encodée en base64url",
    json_string: "chaîne JSON",
    e164: "numéro E.164",
    jwt: "JWT",
    template_literal: "entrée"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Entrée invalide : attendu ${t.expected}, reçu ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Entrée invalide : attendu ${I(t.values[0])}` : `Option invalide : attendu l'une des valeurs suivantes ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "≤" : "<", a = n(t.origin);
        return a ? `Trop grand : attendu que ${t.origin ?? "la valeur"} ait ${i}${t.maximum.toString()} ${a.unit}` : `Trop grand : attendu que ${t.origin ?? "la valeur"} soit ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? "≥" : ">", a = n(t.origin);
        return a ? `Trop petit : attendu que ${t.origin} ait ${i}${t.minimum.toString()} ${a.unit}` : `Trop petit : attendu que ${t.origin} soit ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Chaîne invalide : doit commencer par "${i.prefix}"` : i.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${i.suffix}"` : i.format === "includes" ? `Chaîne invalide : doit inclure "${i.includes}"` : i.format === "regex" ? `Chaîne invalide : doit correspondre au motif ${i.pattern}` : `${o[i.format] ?? t.format} invalide`;
      }
      case "not_multiple_of":
        return `Nombre invalide : doit être un multiple de ${t.divisor}`;
      case "unrecognized_keys":
        return `Clé${t.keys.length > 1 ? "s" : ""} non reconnue${t.keys.length > 1 ? "s" : ""} : ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Clé invalide dans ${t.origin}`;
      case "invalid_union":
        return "Entrée invalide";
      case "invalid_element":
        return `Valeur invalide dans ${t.origin}`;
      default:
        return "Entrée invalide";
    }
  };
};
function od() {
  return {
    localeError: id()
  };
}
const ad = () => {
  const e = {
    string: { unit: "אותיות", verb: "לכלול" },
    file: { unit: "בייטים", verb: "לכלול" },
    array: { unit: "פריטים", verb: "לכלול" },
    set: { unit: "פריטים", verb: "לכלול" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "קלט",
    email: "כתובת אימייל",
    url: "כתובת רשת",
    emoji: "אימוג'י",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "תאריך וזמן ISO",
    date: "תאריך ISO",
    time: "זמן ISO",
    duration: "משך זמן ISO",
    ipv4: "כתובת IPv4",
    ipv6: "כתובת IPv6",
    cidrv4: "טווח IPv4",
    cidrv6: "טווח IPv6",
    base64: "מחרוזת בבסיס 64",
    base64url: "מחרוזת בבסיס 64 לכתובות רשת",
    json_string: "מחרוזת JSON",
    e164: "מספר E.164",
    jwt: "JWT",
    template_literal: "קלט"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `קלט לא תקין: צריך ${t.expected}, התקבל ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `קלט לא תקין: צריך ${I(t.values[0])}` : `קלט לא תקין: צריך אחת מהאפשרויות  ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `גדול מדי: ${t.origin ?? "value"} צריך להיות ${i}${t.maximum.toString()} ${a.unit ?? "elements"}` : `גדול מדי: ${t.origin ?? "value"} צריך להיות ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `קטן מדי: ${t.origin} צריך להיות ${i}${t.minimum.toString()} ${a.unit}` : `קטן מדי: ${t.origin} צריך להיות ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `מחרוזת לא תקינה: חייבת להתחיל ב"${i.prefix}"` : i.format === "ends_with" ? `מחרוזת לא תקינה: חייבת להסתיים ב "${i.suffix}"` : i.format === "includes" ? `מחרוזת לא תקינה: חייבת לכלול "${i.includes}"` : i.format === "regex" ? `מחרוזת לא תקינה: חייבת להתאים לתבנית ${i.pattern}` : `${o[i.format] ?? t.format} לא תקין`;
      }
      case "not_multiple_of":
        return `מספר לא תקין: חייב להיות מכפלה של ${t.divisor}`;
      case "unrecognized_keys":
        return `מפתח${t.keys.length > 1 ? "ות" : ""} לא מזוה${t.keys.length > 1 ? "ים" : "ה"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `מפתח לא תקין ב${t.origin}`;
      case "invalid_union":
        return "קלט לא תקין";
      case "invalid_element":
        return `ערך לא תקין ב${t.origin}`;
      default:
        return "קלט לא תקין";
    }
  };
};
function ud() {
  return {
    localeError: ad()
  };
}
const cd = () => {
  const e = {
    string: { unit: "karakter", verb: "legyen" },
    file: { unit: "byte", verb: "legyen" },
    array: { unit: "elem", verb: "legyen" },
    set: { unit: "elem", verb: "legyen" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "szám";
      case "object": {
        if (Array.isArray(t))
          return "tömb";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "bemenet",
    email: "email cím",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO időbélyeg",
    date: "ISO dátum",
    time: "ISO idő",
    duration: "ISO időintervallum",
    ipv4: "IPv4 cím",
    ipv6: "IPv6 cím",
    cidrv4: "IPv4 tartomány",
    cidrv6: "IPv6 tartomány",
    base64: "base64-kódolt string",
    base64url: "base64url-kódolt string",
    json_string: "JSON string",
    e164: "E.164 szám",
    jwt: "JWT",
    template_literal: "bemenet"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Érvénytelen bemenet: a várt érték ${t.expected}, a kapott érték ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Érvénytelen bemenet: a várt érték ${I(t.values[0])}` : `Érvénytelen opció: valamelyik érték várt ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Túl nagy: ${t.origin ?? "érték"} mérete túl nagy ${i}${t.maximum.toString()} ${a.unit ?? "elem"}` : `Túl nagy: a bemeneti érték ${t.origin ?? "érték"} túl nagy: ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Túl kicsi: a bemeneti érték ${t.origin} mérete túl kicsi ${i}${t.minimum.toString()} ${a.unit}` : `Túl kicsi: a bemeneti érték ${t.origin} túl kicsi ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Érvénytelen string: "${i.prefix}" értékkel kell kezdődnie` : i.format === "ends_with" ? `Érvénytelen string: "${i.suffix}" értékkel kell végződnie` : i.format === "includes" ? `Érvénytelen string: "${i.includes}" értéket kell tartalmaznia` : i.format === "regex" ? `Érvénytelen string: ${i.pattern} mintának kell megfelelnie` : `Érvénytelen ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Érvénytelen szám: ${t.divisor} többszörösének kell lennie`;
      case "unrecognized_keys":
        return `Ismeretlen kulcs${t.keys.length > 1 ? "s" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Érvénytelen kulcs ${t.origin}`;
      case "invalid_union":
        return "Érvénytelen bemenet";
      case "invalid_element":
        return `Érvénytelen érték: ${t.origin}`;
      default:
        return "Érvénytelen bemenet";
    }
  };
};
function sd() {
  return {
    localeError: cd()
  };
}
const ld = () => {
  const e = {
    string: { unit: "karakter", verb: "memiliki" },
    file: { unit: "byte", verb: "memiliki" },
    array: { unit: "item", verb: "memiliki" },
    set: { unit: "item", verb: "memiliki" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "input",
    email: "alamat email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "tanggal dan waktu format ISO",
    date: "tanggal format ISO",
    time: "jam format ISO",
    duration: "durasi format ISO",
    ipv4: "alamat IPv4",
    ipv6: "alamat IPv6",
    cidrv4: "rentang alamat IPv4",
    cidrv6: "rentang alamat IPv6",
    base64: "string dengan enkode base64",
    base64url: "string dengan enkode base64url",
    json_string: "string JSON",
    e164: "angka E.164",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Input tidak valid: diharapkan ${t.expected}, diterima ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Input tidak valid: diharapkan ${I(t.values[0])}` : `Pilihan tidak valid: diharapkan salah satu dari ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Terlalu besar: diharapkan ${t.origin ?? "value"} memiliki ${i}${t.maximum.toString()} ${a.unit ?? "elemen"}` : `Terlalu besar: diharapkan ${t.origin ?? "value"} menjadi ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Terlalu kecil: diharapkan ${t.origin} memiliki ${i}${t.minimum.toString()} ${a.unit}` : `Terlalu kecil: diharapkan ${t.origin} menjadi ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `String tidak valid: harus dimulai dengan "${i.prefix}"` : i.format === "ends_with" ? `String tidak valid: harus berakhir dengan "${i.suffix}"` : i.format === "includes" ? `String tidak valid: harus menyertakan "${i.includes}"` : i.format === "regex" ? `String tidak valid: harus sesuai pola ${i.pattern}` : `${o[i.format] ?? t.format} tidak valid`;
      }
      case "not_multiple_of":
        return `Angka tidak valid: harus kelipatan dari ${t.divisor}`;
      case "unrecognized_keys":
        return `Kunci tidak dikenali ${t.keys.length > 1 ? "s" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Kunci tidak valid di ${t.origin}`;
      case "invalid_union":
        return "Input tidak valid";
      case "invalid_element":
        return `Nilai tidak valid di ${t.origin}`;
      default:
        return "Input tidak valid";
    }
  };
};
function dd() {
  return {
    localeError: ld()
  };
}
const md = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "númer";
    case "object": {
      if (Array.isArray(e))
        return "fylki";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, fd = () => {
  const e = {
    string: { unit: "stafi", verb: "að hafa" },
    file: { unit: "bæti", verb: "að hafa" },
    array: { unit: "hluti", verb: "að hafa" },
    set: { unit: "hluti", verb: "að hafa" }
  };
  function n(o) {
    return e[o] ?? null;
  }
  const r = {
    regex: "gildi",
    email: "netfang",
    url: "vefslóð",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO dagsetning og tími",
    date: "ISO dagsetning",
    time: "ISO tími",
    duration: "ISO tímalengd",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded strengur",
    base64url: "base64url-encoded strengur",
    json_string: "JSON strengur",
    e164: "E.164 tölugildi",
    jwt: "JWT",
    template_literal: "gildi"
  };
  return (o) => {
    switch (o.code) {
      case "invalid_type":
        return `Rangt gildi: Þú slóst inn ${md(o.input)} þar sem á að vera ${o.expected}`;
      case "invalid_value":
        return o.values.length === 1 ? `Rangt gildi: gert ráð fyrir ${I(o.values[0])}` : `Ógilt val: má vera eitt af eftirfarandi ${h(o.values, "|")}`;
      case "too_big": {
        const t = o.inclusive ? "<=" : "<", i = n(o.origin);
        return i ? `Of stórt: gert er ráð fyrir að ${o.origin ?? "gildi"} hafi ${t}${o.maximum.toString()} ${i.unit ?? "hluti"}` : `Of stórt: gert er ráð fyrir að ${o.origin ?? "gildi"} sé ${t}${o.maximum.toString()}`;
      }
      case "too_small": {
        const t = o.inclusive ? ">=" : ">", i = n(o.origin);
        return i ? `Of lítið: gert er ráð fyrir að ${o.origin} hafi ${t}${o.minimum.toString()} ${i.unit}` : `Of lítið: gert er ráð fyrir að ${o.origin} sé ${t}${o.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = o;
        return t.format === "starts_with" ? `Ógildur strengur: verður að byrja á "${t.prefix}"` : t.format === "ends_with" ? `Ógildur strengur: verður að enda á "${t.suffix}"` : t.format === "includes" ? `Ógildur strengur: verður að innihalda "${t.includes}"` : t.format === "regex" ? `Ógildur strengur: verður að fylgja mynstri ${t.pattern}` : `Rangt ${r[t.format] ?? o.format}`;
      }
      case "not_multiple_of":
        return `Röng tala: verður að vera margfeldi af ${o.divisor}`;
      case "unrecognized_keys":
        return `Óþekkt ${o.keys.length > 1 ? "ir lyklar" : "ur lykill"}: ${h(o.keys, ", ")}`;
      case "invalid_key":
        return `Rangur lykill í ${o.origin}`;
      case "invalid_union":
        return "Rangt gildi";
      case "invalid_element":
        return `Rangt gildi í ${o.origin}`;
      default:
        return "Rangt gildi";
    }
  };
};
function pd() {
  return {
    localeError: fd()
  };
}
const gd = () => {
  const e = {
    string: { unit: "caratteri", verb: "avere" },
    file: { unit: "byte", verb: "avere" },
    array: { unit: "elementi", verb: "avere" },
    set: { unit: "elementi", verb: "avere" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "numero";
      case "object": {
        if (Array.isArray(t))
          return "vettore";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "input",
    email: "indirizzo email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data e ora ISO",
    date: "data ISO",
    time: "ora ISO",
    duration: "durata ISO",
    ipv4: "indirizzo IPv4",
    ipv6: "indirizzo IPv6",
    cidrv4: "intervallo IPv4",
    cidrv6: "intervallo IPv6",
    base64: "stringa codificata in base64",
    base64url: "URL codificata in base64",
    json_string: "stringa JSON",
    e164: "numero E.164",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Input non valido: atteso ${t.expected}, ricevuto ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Input non valido: atteso ${I(t.values[0])}` : `Opzione non valida: atteso uno tra ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Troppo grande: ${t.origin ?? "valore"} deve avere ${i}${t.maximum.toString()} ${a.unit ?? "elementi"}` : `Troppo grande: ${t.origin ?? "valore"} deve essere ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Troppo piccolo: ${t.origin} deve avere ${i}${t.minimum.toString()} ${a.unit}` : `Troppo piccolo: ${t.origin} deve essere ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Stringa non valida: deve iniziare con "${i.prefix}"` : i.format === "ends_with" ? `Stringa non valida: deve terminare con "${i.suffix}"` : i.format === "includes" ? `Stringa non valida: deve includere "${i.includes}"` : i.format === "regex" ? `Stringa non valida: deve corrispondere al pattern ${i.pattern}` : `Invalid ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Numero non valido: deve essere un multiplo di ${t.divisor}`;
      case "unrecognized_keys":
        return `Chiav${t.keys.length > 1 ? "i" : "e"} non riconosciut${t.keys.length > 1 ? "e" : "a"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Chiave non valida in ${t.origin}`;
      case "invalid_union":
        return "Input non valido";
      case "invalid_element":
        return `Valore non valido in ${t.origin}`;
      default:
        return "Input non valido";
    }
  };
};
function vd() {
  return {
    localeError: gd()
  };
}
const hd = () => {
  const e = {
    string: { unit: "文字", verb: "である" },
    file: { unit: "バイト", verb: "である" },
    array: { unit: "要素", verb: "である" },
    set: { unit: "要素", verb: "である" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "数値";
      case "object": {
        if (Array.isArray(t))
          return "配列";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "入力値",
    email: "メールアドレス",
    url: "URL",
    emoji: "絵文字",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO日時",
    date: "ISO日付",
    time: "ISO時刻",
    duration: "ISO期間",
    ipv4: "IPv4アドレス",
    ipv6: "IPv6アドレス",
    cidrv4: "IPv4範囲",
    cidrv6: "IPv6範囲",
    base64: "base64エンコード文字列",
    base64url: "base64urlエンコード文字列",
    json_string: "JSON文字列",
    e164: "E.164番号",
    jwt: "JWT",
    template_literal: "入力値"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `無効な入力: ${t.expected}が期待されましたが、${r(t.input)}が入力されました`;
      case "invalid_value":
        return t.values.length === 1 ? `無効な入力: ${I(t.values[0])}が期待されました` : `無効な選択: ${h(t.values, "、")}のいずれかである必要があります`;
      case "too_big": {
        const i = t.inclusive ? "以下である" : "より小さい", a = n(t.origin);
        return a ? `大きすぎる値: ${t.origin ?? "値"}は${t.maximum.toString()}${a.unit ?? "要素"}${i}必要があります` : `大きすぎる値: ${t.origin ?? "値"}は${t.maximum.toString()}${i}必要があります`;
      }
      case "too_small": {
        const i = t.inclusive ? "以上である" : "より大きい", a = n(t.origin);
        return a ? `小さすぎる値: ${t.origin}は${t.minimum.toString()}${a.unit}${i}必要があります` : `小さすぎる値: ${t.origin}は${t.minimum.toString()}${i}必要があります`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `無効な文字列: "${i.prefix}"で始まる必要があります` : i.format === "ends_with" ? `無効な文字列: "${i.suffix}"で終わる必要があります` : i.format === "includes" ? `無効な文字列: "${i.includes}"を含む必要があります` : i.format === "regex" ? `無効な文字列: パターン${i.pattern}に一致する必要があります` : `無効な${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `無効な数値: ${t.divisor}の倍数である必要があります`;
      case "unrecognized_keys":
        return `認識されていないキー${t.keys.length > 1 ? "群" : ""}: ${h(t.keys, "、")}`;
      case "invalid_key":
        return `${t.origin}内の無効なキー`;
      case "invalid_union":
        return "無効な入力";
      case "invalid_element":
        return `${t.origin}内の無効な値`;
      default:
        return "無効な入力";
    }
  };
};
function bd() {
  return {
    localeError: hd()
  };
}
const $d = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "რიცხვი";
    case "object": {
      if (Array.isArray(e))
        return "მასივი";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return {
    string: "სტრინგი",
    boolean: "ბულეანი",
    undefined: "undefined",
    bigint: "bigint",
    symbol: "symbol",
    function: "ფუნქცია"
  }[n] ?? n;
}, _d = () => {
  const e = {
    string: { unit: "სიმბოლო", verb: "უნდა შეიცავდეს" },
    file: { unit: "ბაიტი", verb: "უნდა შეიცავდეს" },
    array: { unit: "ელემენტი", verb: "უნდა შეიცავდეს" },
    set: { unit: "ელემენტი", verb: "უნდა შეიცავდეს" }
  };
  function n(o) {
    return e[o] ?? null;
  }
  const r = {
    regex: "შეყვანა",
    email: "ელ-ფოსტის მისამართი",
    url: "URL",
    emoji: "ემოჯი",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "თარიღი-დრო",
    date: "თარიღი",
    time: "დრო",
    duration: "ხანგრძლივობა",
    ipv4: "IPv4 მისამართი",
    ipv6: "IPv6 მისამართი",
    cidrv4: "IPv4 დიაპაზონი",
    cidrv6: "IPv6 დიაპაზონი",
    base64: "base64-კოდირებული სტრინგი",
    base64url: "base64url-კოდირებული სტრინგი",
    json_string: "JSON სტრინგი",
    e164: "E.164 ნომერი",
    jwt: "JWT",
    template_literal: "შეყვანა"
  };
  return (o) => {
    switch (o.code) {
      case "invalid_type":
        return `არასწორი შეყვანა: მოსალოდნელი ${o.expected}, მიღებული ${$d(o.input)}`;
      case "invalid_value":
        return o.values.length === 1 ? `არასწორი შეყვანა: მოსალოდნელი ${I(o.values[0])}` : `არასწორი ვარიანტი: მოსალოდნელია ერთ-ერთი ${h(o.values, "|")}-დან`;
      case "too_big": {
        const t = o.inclusive ? "<=" : "<", i = n(o.origin);
        return i ? `ზედმეტად დიდი: მოსალოდნელი ${o.origin ?? "მნიშვნელობა"} ${i.verb} ${t}${o.maximum.toString()} ${i.unit}` : `ზედმეტად დიდი: მოსალოდნელი ${o.origin ?? "მნიშვნელობა"} იყოს ${t}${o.maximum.toString()}`;
      }
      case "too_small": {
        const t = o.inclusive ? ">=" : ">", i = n(o.origin);
        return i ? `ზედმეტად პატარა: მოსალოდნელი ${o.origin} ${i.verb} ${t}${o.minimum.toString()} ${i.unit}` : `ზედმეტად პატარა: მოსალოდნელი ${o.origin} იყოს ${t}${o.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = o;
        return t.format === "starts_with" ? `არასწორი სტრინგი: უნდა იწყებოდეს "${t.prefix}"-ით` : t.format === "ends_with" ? `არასწორი სტრინგი: უნდა მთავრდებოდეს "${t.suffix}"-ით` : t.format === "includes" ? `არასწორი სტრინგი: უნდა შეიცავდეს "${t.includes}"-ს` : t.format === "regex" ? `არასწორი სტრინგი: უნდა შეესაბამებოდეს შაბლონს ${t.pattern}` : `არასწორი ${r[t.format] ?? o.format}`;
      }
      case "not_multiple_of":
        return `არასწორი რიცხვი: უნდა იყოს ${o.divisor}-ის ჯერადი`;
      case "unrecognized_keys":
        return `უცნობი გასაღებ${o.keys.length > 1 ? "ები" : "ი"}: ${h(o.keys, ", ")}`;
      case "invalid_key":
        return `არასწორი გასაღები ${o.origin}-ში`;
      case "invalid_union":
        return "არასწორი შეყვანა";
      case "invalid_element":
        return `არასწორი მნიშვნელობა ${o.origin}-ში`;
      default:
        return "არასწორი შეყვანა";
    }
  };
};
function yd() {
  return {
    localeError: _d()
  };
}
const kd = () => {
  const e = {
    string: { unit: "តួអក្សរ", verb: "គួរមាន" },
    file: { unit: "បៃ", verb: "គួរមាន" },
    array: { unit: "ធាតុ", verb: "គួរមាន" },
    set: { unit: "ធាតុ", verb: "គួរមាន" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "មិនមែនជាលេខ (NaN)" : "លេខ";
      case "object": {
        if (Array.isArray(t))
          return "អារេ (Array)";
        if (t === null)
          return "គ្មានតម្លៃ (null)";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "ទិន្នន័យបញ្ចូល",
    email: "អាសយដ្ឋានអ៊ីមែល",
    url: "URL",
    emoji: "សញ្ញាអារម្មណ៍",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "កាលបរិច្ឆេទ និងម៉ោង ISO",
    date: "កាលបរិច្ឆេទ ISO",
    time: "ម៉ោង ISO",
    duration: "រយៈពេល ISO",
    ipv4: "អាសយដ្ឋាន IPv4",
    ipv6: "អាសយដ្ឋាន IPv6",
    cidrv4: "ដែនអាសយដ្ឋាន IPv4",
    cidrv6: "ដែនអាសយដ្ឋាន IPv6",
    base64: "ខ្សែអក្សរអ៊ិកូដ base64",
    base64url: "ខ្សែអក្សរអ៊ិកូដ base64url",
    json_string: "ខ្សែអក្សរ JSON",
    e164: "លេខ E.164",
    jwt: "JWT",
    template_literal: "ទិន្នន័យបញ្ចូល"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${t.expected} ប៉ុន្តែទទួលបាន ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${I(t.values[0])}` : `ជម្រើសមិនត្រឹមត្រូវ៖ ត្រូវជាមួយក្នុងចំណោម ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `ធំពេក៖ ត្រូវការ ${t.origin ?? "តម្លៃ"} ${i} ${t.maximum.toString()} ${a.unit ?? "ធាតុ"}` : `ធំពេក៖ ត្រូវការ ${t.origin ?? "តម្លៃ"} ${i} ${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `តូចពេក៖ ត្រូវការ ${t.origin} ${i} ${t.minimum.toString()} ${a.unit}` : `តូចពេក៖ ត្រូវការ ${t.origin} ${i} ${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវចាប់ផ្តើមដោយ "${i.prefix}"` : i.format === "ends_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវបញ្ចប់ដោយ "${i.suffix}"` : i.format === "includes" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវមាន "${i.includes}"` : i.format === "regex" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវតែផ្គូផ្គងនឹងទម្រង់ដែលបានកំណត់ ${i.pattern}` : `មិនត្រឹមត្រូវ៖ ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `លេខមិនត្រឹមត្រូវ៖ ត្រូវតែជាពហុគុណនៃ ${t.divisor}`;
      case "unrecognized_keys":
        return `រកឃើញសោមិនស្គាល់៖ ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `សោមិនត្រឹមត្រូវនៅក្នុង ${t.origin}`;
      case "invalid_union":
        return "ទិន្នន័យមិនត្រឹមត្រូវ";
      case "invalid_element":
        return `ទិន្នន័យមិនត្រឹមត្រូវនៅក្នុង ${t.origin}`;
      default:
        return "ទិន្នន័យមិនត្រឹមត្រូវ";
    }
  };
};
function Ra() {
  return {
    localeError: kd()
  };
}
function wd() {
  return Ra();
}
const Id = () => {
  const e = {
    string: { unit: "문자", verb: "to have" },
    file: { unit: "바이트", verb: "to have" },
    array: { unit: "개", verb: "to have" },
    set: { unit: "개", verb: "to have" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "입력",
    email: "이메일 주소",
    url: "URL",
    emoji: "이모지",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO 날짜시간",
    date: "ISO 날짜",
    time: "ISO 시간",
    duration: "ISO 기간",
    ipv4: "IPv4 주소",
    ipv6: "IPv6 주소",
    cidrv4: "IPv4 범위",
    cidrv6: "IPv6 범위",
    base64: "base64 인코딩 문자열",
    base64url: "base64url 인코딩 문자열",
    json_string: "JSON 문자열",
    e164: "E.164 번호",
    jwt: "JWT",
    template_literal: "입력"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `잘못된 입력: 예상 타입은 ${t.expected}, 받은 타입은 ${r(t.input)}입니다`;
      case "invalid_value":
        return t.values.length === 1 ? `잘못된 입력: 값은 ${I(t.values[0])} 이어야 합니다` : `잘못된 옵션: ${h(t.values, "또는 ")} 중 하나여야 합니다`;
      case "too_big": {
        const i = t.inclusive ? "이하" : "미만", a = i === "미만" ? "이어야 합니다" : "여야 합니다", u = n(t.origin), c = (u == null ? void 0 : u.unit) ?? "요소";
        return u ? `${t.origin ?? "값"}이 너무 큽니다: ${t.maximum.toString()}${c} ${i}${a}` : `${t.origin ?? "값"}이 너무 큽니다: ${t.maximum.toString()} ${i}${a}`;
      }
      case "too_small": {
        const i = t.inclusive ? "이상" : "초과", a = i === "이상" ? "이어야 합니다" : "여야 합니다", u = n(t.origin), c = (u == null ? void 0 : u.unit) ?? "요소";
        return u ? `${t.origin ?? "값"}이 너무 작습니다: ${t.minimum.toString()}${c} ${i}${a}` : `${t.origin ?? "값"}이 너무 작습니다: ${t.minimum.toString()} ${i}${a}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `잘못된 문자열: "${i.prefix}"(으)로 시작해야 합니다` : i.format === "ends_with" ? `잘못된 문자열: "${i.suffix}"(으)로 끝나야 합니다` : i.format === "includes" ? `잘못된 문자열: "${i.includes}"을(를) 포함해야 합니다` : i.format === "regex" ? `잘못된 문자열: 정규식 ${i.pattern} 패턴과 일치해야 합니다` : `잘못된 ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `잘못된 숫자: ${t.divisor}의 배수여야 합니다`;
      case "unrecognized_keys":
        return `인식할 수 없는 키: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `잘못된 키: ${t.origin}`;
      case "invalid_union":
        return "잘못된 입력";
      case "invalid_element":
        return `잘못된 값: ${t.origin}`;
      default:
        return "잘못된 입력";
    }
  };
};
function Sd() {
  return {
    localeError: Id()
  };
}
const zd = (e) => ye(typeof e, e), ye = (e, n = void 0) => {
  switch (e) {
    case "number":
      return Number.isNaN(n) ? "NaN" : "skaičius";
    case "bigint":
      return "sveikasis skaičius";
    case "string":
      return "eilutė";
    case "boolean":
      return "loginė reikšmė";
    case "undefined":
    case "void":
      return "neapibrėžta reikšmė";
    case "function":
      return "funkcija";
    case "symbol":
      return "simbolis";
    case "object":
      return n === void 0 ? "nežinomas objektas" : n === null ? "nulinė reikšmė" : Array.isArray(n) ? "masyvas" : Object.getPrototypeOf(n) !== Object.prototype && n.constructor ? n.constructor.name : "objektas";
    case "null":
      return "nulinė reikšmė";
  }
  return e;
}, $e = (e) => e.charAt(0).toUpperCase() + e.slice(1);
function Rr(e) {
  const n = Math.abs(e), r = n % 10, o = n % 100;
  return o >= 11 && o <= 19 || r === 0 ? "many" : r === 1 ? "one" : "few";
}
const xd = () => {
  const e = {
    string: {
      unit: {
        one: "simbolis",
        few: "simboliai",
        many: "simbolių"
      },
      verb: {
        smaller: {
          inclusive: "turi būti ne ilgesnė kaip",
          notInclusive: "turi būti trumpesnė kaip"
        },
        bigger: {
          inclusive: "turi būti ne trumpesnė kaip",
          notInclusive: "turi būti ilgesnė kaip"
        }
      }
    },
    file: {
      unit: {
        one: "baitas",
        few: "baitai",
        many: "baitų"
      },
      verb: {
        smaller: {
          inclusive: "turi būti ne didesnis kaip",
          notInclusive: "turi būti mažesnis kaip"
        },
        bigger: {
          inclusive: "turi būti ne mažesnis kaip",
          notInclusive: "turi būti didesnis kaip"
        }
      }
    },
    array: {
      unit: {
        one: "elementą",
        few: "elementus",
        many: "elementų"
      },
      verb: {
        smaller: {
          inclusive: "turi turėti ne daugiau kaip",
          notInclusive: "turi turėti mažiau kaip"
        },
        bigger: {
          inclusive: "turi turėti ne mažiau kaip",
          notInclusive: "turi turėti daugiau kaip"
        }
      }
    },
    set: {
      unit: {
        one: "elementą",
        few: "elementus",
        many: "elementų"
      },
      verb: {
        smaller: {
          inclusive: "turi turėti ne daugiau kaip",
          notInclusive: "turi turėti mažiau kaip"
        },
        bigger: {
          inclusive: "turi turėti ne mažiau kaip",
          notInclusive: "turi turėti daugiau kaip"
        }
      }
    }
  };
  function n(o, t, i, a) {
    const u = e[o] ?? null;
    return u === null ? u : {
      unit: u.unit[t],
      verb: u.verb[a][i ? "inclusive" : "notInclusive"]
    };
  }
  const r = {
    regex: "įvestis",
    email: "el. pašto adresas",
    url: "URL",
    emoji: "jaustukas",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO data ir laikas",
    date: "ISO data",
    time: "ISO laikas",
    duration: "ISO trukmė",
    ipv4: "IPv4 adresas",
    ipv6: "IPv6 adresas",
    cidrv4: "IPv4 tinklo prefiksas (CIDR)",
    cidrv6: "IPv6 tinklo prefiksas (CIDR)",
    base64: "base64 užkoduota eilutė",
    base64url: "base64url užkoduota eilutė",
    json_string: "JSON eilutė",
    e164: "E.164 numeris",
    jwt: "JWT",
    template_literal: "įvestis"
  };
  return (o) => {
    switch (o.code) {
      case "invalid_type":
        return `Gautas tipas ${zd(o.input)}, o tikėtasi - ${ye(o.expected)}`;
      case "invalid_value":
        return o.values.length === 1 ? `Privalo būti ${I(o.values[0])}` : `Privalo būti vienas iš ${h(o.values, "|")} pasirinkimų`;
      case "too_big": {
        const t = ye(o.origin), i = n(o.origin, Rr(Number(o.maximum)), o.inclusive ?? !1, "smaller");
        if (i != null && i.verb)
          return `${$e(t ?? o.origin ?? "reikšmė")} ${i.verb} ${o.maximum.toString()} ${i.unit ?? "elementų"}`;
        const a = o.inclusive ? "ne didesnis kaip" : "mažesnis kaip";
        return `${$e(t ?? o.origin ?? "reikšmė")} turi būti ${a} ${o.maximum.toString()} ${i == null ? void 0 : i.unit}`;
      }
      case "too_small": {
        const t = ye(o.origin), i = n(o.origin, Rr(Number(o.minimum)), o.inclusive ?? !1, "bigger");
        if (i != null && i.verb)
          return `${$e(t ?? o.origin ?? "reikšmė")} ${i.verb} ${o.minimum.toString()} ${i.unit ?? "elementų"}`;
        const a = o.inclusive ? "ne mažesnis kaip" : "didesnis kaip";
        return `${$e(t ?? o.origin ?? "reikšmė")} turi būti ${a} ${o.minimum.toString()} ${i == null ? void 0 : i.unit}`;
      }
      case "invalid_format": {
        const t = o;
        return t.format === "starts_with" ? `Eilutė privalo prasidėti "${t.prefix}"` : t.format === "ends_with" ? `Eilutė privalo pasibaigti "${t.suffix}"` : t.format === "includes" ? `Eilutė privalo įtraukti "${t.includes}"` : t.format === "regex" ? `Eilutė privalo atitikti ${t.pattern}` : `Neteisingas ${r[t.format] ?? o.format}`;
      }
      case "not_multiple_of":
        return `Skaičius privalo būti ${o.divisor} kartotinis.`;
      case "unrecognized_keys":
        return `Neatpažint${o.keys.length > 1 ? "i" : "as"} rakt${o.keys.length > 1 ? "ai" : "as"}: ${h(o.keys, ", ")}`;
      case "invalid_key":
        return "Rastas klaidingas raktas";
      case "invalid_union":
        return "Klaidinga įvestis";
      case "invalid_element": {
        const t = ye(o.origin);
        return `${$e(t ?? o.origin ?? "reikšmė")} turi klaidingą įvestį`;
      }
      default:
        return "Klaidinga įvestis";
    }
  };
};
function Nd() {
  return {
    localeError: xd()
  };
}
const jd = () => {
  const e = {
    string: { unit: "знаци", verb: "да имаат" },
    file: { unit: "бајти", verb: "да имаат" },
    array: { unit: "ставки", verb: "да имаат" },
    set: { unit: "ставки", verb: "да имаат" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "број";
      case "object": {
        if (Array.isArray(t))
          return "низа";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "внес",
    email: "адреса на е-пошта",
    url: "URL",
    emoji: "емоџи",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO датум и време",
    date: "ISO датум",
    time: "ISO време",
    duration: "ISO времетраење",
    ipv4: "IPv4 адреса",
    ipv6: "IPv6 адреса",
    cidrv4: "IPv4 опсег",
    cidrv6: "IPv6 опсег",
    base64: "base64-енкодирана низа",
    base64url: "base64url-енкодирана низа",
    json_string: "JSON низа",
    e164: "E.164 број",
    jwt: "JWT",
    template_literal: "внес"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Грешен внес: се очекува ${t.expected}, примено ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Invalid input: expected ${I(t.values[0])}` : `Грешана опција: се очекува една ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Премногу голем: се очекува ${t.origin ?? "вредноста"} да има ${i}${t.maximum.toString()} ${a.unit ?? "елементи"}` : `Премногу голем: се очекува ${t.origin ?? "вредноста"} да биде ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Премногу мал: се очекува ${t.origin} да има ${i}${t.minimum.toString()} ${a.unit}` : `Премногу мал: се очекува ${t.origin} да биде ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Неважечка низа: мора да започнува со "${i.prefix}"` : i.format === "ends_with" ? `Неважечка низа: мора да завршува со "${i.suffix}"` : i.format === "includes" ? `Неважечка низа: мора да вклучува "${i.includes}"` : i.format === "regex" ? `Неважечка низа: мора да одгоара на патернот ${i.pattern}` : `Invalid ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Грешен број: мора да биде делив со ${t.divisor}`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Непрепознаени клучеви" : "Непрепознаен клуч"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Грешен клуч во ${t.origin}`;
      case "invalid_union":
        return "Грешен внес";
      case "invalid_element":
        return `Грешна вредност во ${t.origin}`;
      default:
        return "Грешен внес";
    }
  };
};
function Od() {
  return {
    localeError: jd()
  };
}
const Ud = () => {
  const e = {
    string: { unit: "aksara", verb: "mempunyai" },
    file: { unit: "bait", verb: "mempunyai" },
    array: { unit: "elemen", verb: "mempunyai" },
    set: { unit: "elemen", verb: "mempunyai" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "nombor";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "input",
    email: "alamat e-mel",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "tarikh masa ISO",
    date: "tarikh ISO",
    time: "masa ISO",
    duration: "tempoh ISO",
    ipv4: "alamat IPv4",
    ipv6: "alamat IPv6",
    cidrv4: "julat IPv4",
    cidrv6: "julat IPv6",
    base64: "string dikodkan base64",
    base64url: "string dikodkan base64url",
    json_string: "string JSON",
    e164: "nombor E.164",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Input tidak sah: dijangka ${t.expected}, diterima ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Input tidak sah: dijangka ${I(t.values[0])}` : `Pilihan tidak sah: dijangka salah satu daripada ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Terlalu besar: dijangka ${t.origin ?? "nilai"} ${a.verb} ${i}${t.maximum.toString()} ${a.unit ?? "elemen"}` : `Terlalu besar: dijangka ${t.origin ?? "nilai"} adalah ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Terlalu kecil: dijangka ${t.origin} ${a.verb} ${i}${t.minimum.toString()} ${a.unit}` : `Terlalu kecil: dijangka ${t.origin} adalah ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `String tidak sah: mesti bermula dengan "${i.prefix}"` : i.format === "ends_with" ? `String tidak sah: mesti berakhir dengan "${i.suffix}"` : i.format === "includes" ? `String tidak sah: mesti mengandungi "${i.includes}"` : i.format === "regex" ? `String tidak sah: mesti sepadan dengan corak ${i.pattern}` : `${o[i.format] ?? t.format} tidak sah`;
      }
      case "not_multiple_of":
        return `Nombor tidak sah: perlu gandaan ${t.divisor}`;
      case "unrecognized_keys":
        return `Kunci tidak dikenali: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Kunci tidak sah dalam ${t.origin}`;
      case "invalid_union":
        return "Input tidak sah";
      case "invalid_element":
        return `Nilai tidak sah dalam ${t.origin}`;
      default:
        return "Input tidak sah";
    }
  };
};
function Td() {
  return {
    localeError: Ud()
  };
}
const Ed = () => {
  const e = {
    string: { unit: "tekens" },
    file: { unit: "bytes" },
    array: { unit: "elementen" },
    set: { unit: "elementen" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "getal";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "invoer",
    email: "emailadres",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datum en tijd",
    date: "ISO datum",
    time: "ISO tijd",
    duration: "ISO duur",
    ipv4: "IPv4-adres",
    ipv6: "IPv6-adres",
    cidrv4: "IPv4-bereik",
    cidrv6: "IPv6-bereik",
    base64: "base64-gecodeerde tekst",
    base64url: "base64 URL-gecodeerde tekst",
    json_string: "JSON string",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "invoer"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ongeldige invoer: verwacht ${t.expected}, ontving ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ongeldige invoer: verwacht ${I(t.values[0])}` : `Ongeldige optie: verwacht één van ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Te lang: verwacht dat ${t.origin ?? "waarde"} ${i}${t.maximum.toString()} ${a.unit ?? "elementen"} bevat` : `Te lang: verwacht dat ${t.origin ?? "waarde"} ${i}${t.maximum.toString()} is`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Te kort: verwacht dat ${t.origin} ${i}${t.minimum.toString()} ${a.unit} bevat` : `Te kort: verwacht dat ${t.origin} ${i}${t.minimum.toString()} is`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Ongeldige tekst: moet met "${i.prefix}" beginnen` : i.format === "ends_with" ? `Ongeldige tekst: moet op "${i.suffix}" eindigen` : i.format === "includes" ? `Ongeldige tekst: moet "${i.includes}" bevatten` : i.format === "regex" ? `Ongeldige tekst: moet overeenkomen met patroon ${i.pattern}` : `Ongeldig: ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Ongeldig getal: moet een veelvoud van ${t.divisor} zijn`;
      case "unrecognized_keys":
        return `Onbekende key${t.keys.length > 1 ? "s" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Ongeldige key in ${t.origin}`;
      case "invalid_union":
        return "Ongeldige invoer";
      case "invalid_element":
        return `Ongeldige waarde in ${t.origin}`;
      default:
        return "Ongeldige invoer";
    }
  };
};
function Pd() {
  return {
    localeError: Ed()
  };
}
const Cd = () => {
  const e = {
    string: { unit: "tegn", verb: "å ha" },
    file: { unit: "bytes", verb: "å ha" },
    array: { unit: "elementer", verb: "å inneholde" },
    set: { unit: "elementer", verb: "å inneholde" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "tall";
      case "object": {
        if (Array.isArray(t))
          return "liste";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "input",
    email: "e-postadresse",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO dato- og klokkeslett",
    date: "ISO-dato",
    time: "ISO-klokkeslett",
    duration: "ISO-varighet",
    ipv4: "IPv4-område",
    ipv6: "IPv6-område",
    cidrv4: "IPv4-spekter",
    cidrv6: "IPv6-spekter",
    base64: "base64-enkodet streng",
    base64url: "base64url-enkodet streng",
    json_string: "JSON-streng",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ugyldig input: forventet ${t.expected}, fikk ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ugyldig verdi: forventet ${I(t.values[0])}` : `Ugyldig valg: forventet en av ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `For stor(t): forventet ${t.origin ?? "value"} til å ha ${i}${t.maximum.toString()} ${a.unit ?? "elementer"}` : `For stor(t): forventet ${t.origin ?? "value"} til å ha ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `For lite(n): forventet ${t.origin} til å ha ${i}${t.minimum.toString()} ${a.unit}` : `For lite(n): forventet ${t.origin} til å ha ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Ugyldig streng: må starte med "${i.prefix}"` : i.format === "ends_with" ? `Ugyldig streng: må ende med "${i.suffix}"` : i.format === "includes" ? `Ugyldig streng: må inneholde "${i.includes}"` : i.format === "regex" ? `Ugyldig streng: må matche mønsteret ${i.pattern}` : `Ugyldig ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Ugyldig tall: må være et multiplum av ${t.divisor}`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Ukjente nøkler" : "Ukjent nøkkel"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Ugyldig nøkkel i ${t.origin}`;
      case "invalid_union":
        return "Ugyldig input";
      case "invalid_element":
        return `Ugyldig verdi i ${t.origin}`;
      default:
        return "Ugyldig input";
    }
  };
};
function Dd() {
  return {
    localeError: Cd()
  };
}
const Ad = () => {
  const e = {
    string: { unit: "harf", verb: "olmalıdır" },
    file: { unit: "bayt", verb: "olmalıdır" },
    array: { unit: "unsur", verb: "olmalıdır" },
    set: { unit: "unsur", verb: "olmalıdır" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "numara";
      case "object": {
        if (Array.isArray(t))
          return "saf";
        if (t === null)
          return "gayb";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "giren",
    email: "epostagâh",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO hengâmı",
    date: "ISO tarihi",
    time: "ISO zamanı",
    duration: "ISO müddeti",
    ipv4: "IPv4 nişânı",
    ipv6: "IPv6 nişânı",
    cidrv4: "IPv4 menzili",
    cidrv6: "IPv6 menzili",
    base64: "base64-şifreli metin",
    base64url: "base64url-şifreli metin",
    json_string: "JSON metin",
    e164: "E.164 sayısı",
    jwt: "JWT",
    template_literal: "giren"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Fâsit giren: umulan ${t.expected}, alınan ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Fâsit giren: umulan ${I(t.values[0])}` : `Fâsit tercih: mûteberler ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Fazla büyük: ${t.origin ?? "value"}, ${i}${t.maximum.toString()} ${a.unit ?? "elements"} sahip olmalıydı.` : `Fazla büyük: ${t.origin ?? "value"}, ${i}${t.maximum.toString()} olmalıydı.`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Fazla küçük: ${t.origin}, ${i}${t.minimum.toString()} ${a.unit} sahip olmalıydı.` : `Fazla küçük: ${t.origin}, ${i}${t.minimum.toString()} olmalıydı.`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Fâsit metin: "${i.prefix}" ile başlamalı.` : i.format === "ends_with" ? `Fâsit metin: "${i.suffix}" ile bitmeli.` : i.format === "includes" ? `Fâsit metin: "${i.includes}" ihtivâ etmeli.` : i.format === "regex" ? `Fâsit metin: ${i.pattern} nakşına uymalı.` : `Fâsit ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Fâsit sayı: ${t.divisor} katı olmalıydı.`;
      case "unrecognized_keys":
        return `Tanınmayan anahtar ${t.keys.length > 1 ? "s" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `${t.origin} için tanınmayan anahtar var.`;
      case "invalid_union":
        return "Giren tanınamadı.";
      case "invalid_element":
        return `${t.origin} için tanınmayan kıymet var.`;
      default:
        return "Kıymet tanınamadı.";
    }
  };
};
function Zd() {
  return {
    localeError: Ad()
  };
}
const Ld = () => {
  const e = {
    string: { unit: "توکي", verb: "ولري" },
    file: { unit: "بایټس", verb: "ولري" },
    array: { unit: "توکي", verb: "ولري" },
    set: { unit: "توکي", verb: "ولري" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "عدد";
      case "object": {
        if (Array.isArray(t))
          return "ارې";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "ورودي",
    email: "بریښنالیک",
    url: "یو آر ال",
    emoji: "ایموجي",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "نیټه او وخت",
    date: "نېټه",
    time: "وخت",
    duration: "موده",
    ipv4: "د IPv4 پته",
    ipv6: "د IPv6 پته",
    cidrv4: "د IPv4 ساحه",
    cidrv6: "د IPv6 ساحه",
    base64: "base64-encoded متن",
    base64url: "base64url-encoded متن",
    json_string: "JSON متن",
    e164: "د E.164 شمېره",
    jwt: "JWT",
    template_literal: "ورودي"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `ناسم ورودي: باید ${t.expected} وای, مګر ${r(t.input)} ترلاسه شو`;
      case "invalid_value":
        return t.values.length === 1 ? `ناسم ورودي: باید ${I(t.values[0])} وای` : `ناسم انتخاب: باید یو له ${h(t.values, "|")} څخه وای`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `ډیر لوی: ${t.origin ?? "ارزښت"} باید ${i}${t.maximum.toString()} ${a.unit ?? "عنصرونه"} ولري` : `ډیر لوی: ${t.origin ?? "ارزښت"} باید ${i}${t.maximum.toString()} وي`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `ډیر کوچنی: ${t.origin} باید ${i}${t.minimum.toString()} ${a.unit} ولري` : `ډیر کوچنی: ${t.origin} باید ${i}${t.minimum.toString()} وي`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `ناسم متن: باید د "${i.prefix}" سره پیل شي` : i.format === "ends_with" ? `ناسم متن: باید د "${i.suffix}" سره پای ته ورسيږي` : i.format === "includes" ? `ناسم متن: باید "${i.includes}" ولري` : i.format === "regex" ? `ناسم متن: باید د ${i.pattern} سره مطابقت ولري` : `${o[i.format] ?? t.format} ناسم دی`;
      }
      case "not_multiple_of":
        return `ناسم عدد: باید د ${t.divisor} مضرب وي`;
      case "unrecognized_keys":
        return `ناسم ${t.keys.length > 1 ? "کلیډونه" : "کلیډ"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `ناسم کلیډ په ${t.origin} کې`;
      case "invalid_union":
        return "ناسمه ورودي";
      case "invalid_element":
        return `ناسم عنصر په ${t.origin} کې`;
      default:
        return "ناسمه ورودي";
    }
  };
};
function Md() {
  return {
    localeError: Ld()
  };
}
const Bd = () => {
  const e = {
    string: { unit: "znaków", verb: "mieć" },
    file: { unit: "bajtów", verb: "mieć" },
    array: { unit: "elementów", verb: "mieć" },
    set: { unit: "elementów", verb: "mieć" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "liczba";
      case "object": {
        if (Array.isArray(t))
          return "tablica";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "wyrażenie",
    email: "adres email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data i godzina w formacie ISO",
    date: "data w formacie ISO",
    time: "godzina w formacie ISO",
    duration: "czas trwania ISO",
    ipv4: "adres IPv4",
    ipv6: "adres IPv6",
    cidrv4: "zakres IPv4",
    cidrv6: "zakres IPv6",
    base64: "ciąg znaków zakodowany w formacie base64",
    base64url: "ciąg znaków zakodowany w formacie base64url",
    json_string: "ciąg znaków w formacie JSON",
    e164: "liczba E.164",
    jwt: "JWT",
    template_literal: "wejście"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Nieprawidłowe dane wejściowe: oczekiwano ${t.expected}, otrzymano ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Nieprawidłowe dane wejściowe: oczekiwano ${I(t.values[0])}` : `Nieprawidłowa opcja: oczekiwano jednej z wartości ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Za duża wartość: oczekiwano, że ${t.origin ?? "wartość"} będzie mieć ${i}${t.maximum.toString()} ${a.unit ?? "elementów"}` : `Zbyt duż(y/a/e): oczekiwano, że ${t.origin ?? "wartość"} będzie wynosić ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Za mała wartość: oczekiwano, że ${t.origin ?? "wartość"} będzie mieć ${i}${t.minimum.toString()} ${a.unit ?? "elementów"}` : `Zbyt mał(y/a/e): oczekiwano, że ${t.origin ?? "wartość"} będzie wynosić ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Nieprawidłowy ciąg znaków: musi zaczynać się od "${i.prefix}"` : i.format === "ends_with" ? `Nieprawidłowy ciąg znaków: musi kończyć się na "${i.suffix}"` : i.format === "includes" ? `Nieprawidłowy ciąg znaków: musi zawierać "${i.includes}"` : i.format === "regex" ? `Nieprawidłowy ciąg znaków: musi odpowiadać wzorcowi ${i.pattern}` : `Nieprawidłow(y/a/e) ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Nieprawidłowa liczba: musi być wielokrotnością ${t.divisor}`;
      case "unrecognized_keys":
        return `Nierozpoznane klucze${t.keys.length > 1 ? "s" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Nieprawidłowy klucz w ${t.origin}`;
      case "invalid_union":
        return "Nieprawidłowe dane wejściowe";
      case "invalid_element":
        return `Nieprawidłowa wartość w ${t.origin}`;
      default:
        return "Nieprawidłowe dane wejściowe";
    }
  };
};
function Rd() {
  return {
    localeError: Bd()
  };
}
const Fd = () => {
  const e = {
    string: { unit: "caracteres", verb: "ter" },
    file: { unit: "bytes", verb: "ter" },
    array: { unit: "itens", verb: "ter" },
    set: { unit: "itens", verb: "ter" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "número";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "nulo";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "padrão",
    email: "endereço de e-mail",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data e hora ISO",
    date: "data ISO",
    time: "hora ISO",
    duration: "duração ISO",
    ipv4: "endereço IPv4",
    ipv6: "endereço IPv6",
    cidrv4: "faixa de IPv4",
    cidrv6: "faixa de IPv6",
    base64: "texto codificado em base64",
    base64url: "URL codificada em base64",
    json_string: "texto JSON",
    e164: "número E.164",
    jwt: "JWT",
    template_literal: "entrada"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Tipo inválido: esperado ${t.expected}, recebido ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Entrada inválida: esperado ${I(t.values[0])}` : `Opção inválida: esperada uma das ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Muito grande: esperado que ${t.origin ?? "valor"} tivesse ${i}${t.maximum.toString()} ${a.unit ?? "elementos"}` : `Muito grande: esperado que ${t.origin ?? "valor"} fosse ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Muito pequeno: esperado que ${t.origin} tivesse ${i}${t.minimum.toString()} ${a.unit}` : `Muito pequeno: esperado que ${t.origin} fosse ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Texto inválido: deve começar com "${i.prefix}"` : i.format === "ends_with" ? `Texto inválido: deve terminar com "${i.suffix}"` : i.format === "includes" ? `Texto inválido: deve incluir "${i.includes}"` : i.format === "regex" ? `Texto inválido: deve corresponder ao padrão ${i.pattern}` : `${o[i.format] ?? t.format} inválido`;
      }
      case "not_multiple_of":
        return `Número inválido: deve ser múltiplo de ${t.divisor}`;
      case "unrecognized_keys":
        return `Chave${t.keys.length > 1 ? "s" : ""} desconhecida${t.keys.length > 1 ? "s" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Chave inválida em ${t.origin}`;
      case "invalid_union":
        return "Entrada inválida";
      case "invalid_element":
        return `Valor inválido em ${t.origin}`;
      default:
        return "Campo inválido";
    }
  };
};
function Vd() {
  return {
    localeError: Fd()
  };
}
function Fr(e, n, r, o) {
  const t = Math.abs(e), i = t % 10, a = t % 100;
  return a >= 11 && a <= 19 ? o : i === 1 ? n : i >= 2 && i <= 4 ? r : o;
}
const Hd = () => {
  const e = {
    string: {
      unit: {
        one: "символ",
        few: "символа",
        many: "символов"
      },
      verb: "иметь"
    },
    file: {
      unit: {
        one: "байт",
        few: "байта",
        many: "байт"
      },
      verb: "иметь"
    },
    array: {
      unit: {
        one: "элемент",
        few: "элемента",
        many: "элементов"
      },
      verb: "иметь"
    },
    set: {
      unit: {
        one: "элемент",
        few: "элемента",
        many: "элементов"
      },
      verb: "иметь"
    }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "число";
      case "object": {
        if (Array.isArray(t))
          return "массив";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "ввод",
    email: "email адрес",
    url: "URL",
    emoji: "эмодзи",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO дата и время",
    date: "ISO дата",
    time: "ISO время",
    duration: "ISO длительность",
    ipv4: "IPv4 адрес",
    ipv6: "IPv6 адрес",
    cidrv4: "IPv4 диапазон",
    cidrv6: "IPv6 диапазон",
    base64: "строка в формате base64",
    base64url: "строка в формате base64url",
    json_string: "JSON строка",
    e164: "номер E.164",
    jwt: "JWT",
    template_literal: "ввод"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Неверный ввод: ожидалось ${t.expected}, получено ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Неверный ввод: ожидалось ${I(t.values[0])}` : `Неверный вариант: ожидалось одно из ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        if (a) {
          const u = Number(t.maximum), c = Fr(u, a.unit.one, a.unit.few, a.unit.many);
          return `Слишком большое значение: ожидалось, что ${t.origin ?? "значение"} будет иметь ${i}${t.maximum.toString()} ${c}`;
        }
        return `Слишком большое значение: ожидалось, что ${t.origin ?? "значение"} будет ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        if (a) {
          const u = Number(t.minimum), c = Fr(u, a.unit.one, a.unit.few, a.unit.many);
          return `Слишком маленькое значение: ожидалось, что ${t.origin} будет иметь ${i}${t.minimum.toString()} ${c}`;
        }
        return `Слишком маленькое значение: ожидалось, что ${t.origin} будет ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Неверная строка: должна начинаться с "${i.prefix}"` : i.format === "ends_with" ? `Неверная строка: должна заканчиваться на "${i.suffix}"` : i.format === "includes" ? `Неверная строка: должна содержать "${i.includes}"` : i.format === "regex" ? `Неверная строка: должна соответствовать шаблону ${i.pattern}` : `Неверный ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Неверное число: должно быть кратным ${t.divisor}`;
      case "unrecognized_keys":
        return `Нераспознанн${t.keys.length > 1 ? "ые" : "ый"} ключ${t.keys.length > 1 ? "и" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Неверный ключ в ${t.origin}`;
      case "invalid_union":
        return "Неверные входные данные";
      case "invalid_element":
        return `Неверное значение в ${t.origin}`;
      default:
        return "Неверные входные данные";
    }
  };
};
function Wd() {
  return {
    localeError: Hd()
  };
}
const Jd = () => {
  const e = {
    string: { unit: "znakov", verb: "imeti" },
    file: { unit: "bajtov", verb: "imeti" },
    array: { unit: "elementov", verb: "imeti" },
    set: { unit: "elementov", verb: "imeti" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "število";
      case "object": {
        if (Array.isArray(t))
          return "tabela";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "vnos",
    email: "e-poštni naslov",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datum in čas",
    date: "ISO datum",
    time: "ISO čas",
    duration: "ISO trajanje",
    ipv4: "IPv4 naslov",
    ipv6: "IPv6 naslov",
    cidrv4: "obseg IPv4",
    cidrv6: "obseg IPv6",
    base64: "base64 kodiran niz",
    base64url: "base64url kodiran niz",
    json_string: "JSON niz",
    e164: "E.164 številka",
    jwt: "JWT",
    template_literal: "vnos"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Neveljaven vnos: pričakovano ${t.expected}, prejeto ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Neveljaven vnos: pričakovano ${I(t.values[0])}` : `Neveljavna možnost: pričakovano eno izmed ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Preveliko: pričakovano, da bo ${t.origin ?? "vrednost"} imelo ${i}${t.maximum.toString()} ${a.unit ?? "elementov"}` : `Preveliko: pričakovano, da bo ${t.origin ?? "vrednost"} ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Premajhno: pričakovano, da bo ${t.origin} imelo ${i}${t.minimum.toString()} ${a.unit}` : `Premajhno: pričakovano, da bo ${t.origin} ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Neveljaven niz: mora se začeti z "${i.prefix}"` : i.format === "ends_with" ? `Neveljaven niz: mora se končati z "${i.suffix}"` : i.format === "includes" ? `Neveljaven niz: mora vsebovati "${i.includes}"` : i.format === "regex" ? `Neveljaven niz: mora ustrezati vzorcu ${i.pattern}` : `Neveljaven ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Neveljavno število: mora biti večkratnik ${t.divisor}`;
      case "unrecognized_keys":
        return `Neprepoznan${t.keys.length > 1 ? "i ključi" : " ključ"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Neveljaven ključ v ${t.origin}`;
      case "invalid_union":
        return "Neveljaven vnos";
      case "invalid_element":
        return `Neveljavna vrednost v ${t.origin}`;
      default:
        return "Neveljaven vnos";
    }
  };
};
function Gd() {
  return {
    localeError: Jd()
  };
}
const Kd = () => {
  const e = {
    string: { unit: "tecken", verb: "att ha" },
    file: { unit: "bytes", verb: "att ha" },
    array: { unit: "objekt", verb: "att innehålla" },
    set: { unit: "objekt", verb: "att innehålla" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "antal";
      case "object": {
        if (Array.isArray(t))
          return "lista";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "reguljärt uttryck",
    email: "e-postadress",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-datum och tid",
    date: "ISO-datum",
    time: "ISO-tid",
    duration: "ISO-varaktighet",
    ipv4: "IPv4-intervall",
    ipv6: "IPv6-intervall",
    cidrv4: "IPv4-spektrum",
    cidrv6: "IPv6-spektrum",
    base64: "base64-kodad sträng",
    base64url: "base64url-kodad sträng",
    json_string: "JSON-sträng",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "mall-literal"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ogiltig inmatning: förväntat ${t.expected}, fick ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ogiltig inmatning: förväntat ${I(t.values[0])}` : `Ogiltigt val: förväntade en av ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `För stor(t): förväntade ${t.origin ?? "värdet"} att ha ${i}${t.maximum.toString()} ${a.unit ?? "element"}` : `För stor(t): förväntat ${t.origin ?? "värdet"} att ha ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `För lite(t): förväntade ${t.origin ?? "värdet"} att ha ${i}${t.minimum.toString()} ${a.unit}` : `För lite(t): förväntade ${t.origin ?? "värdet"} att ha ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Ogiltig sträng: måste börja med "${i.prefix}"` : i.format === "ends_with" ? `Ogiltig sträng: måste sluta med "${i.suffix}"` : i.format === "includes" ? `Ogiltig sträng: måste innehålla "${i.includes}"` : i.format === "regex" ? `Ogiltig sträng: måste matcha mönstret "${i.pattern}"` : `Ogiltig(t) ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Ogiltigt tal: måste vara en multipel av ${t.divisor}`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Okända nycklar" : "Okänd nyckel"}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Ogiltig nyckel i ${t.origin ?? "värdet"}`;
      case "invalid_union":
        return "Ogiltig input";
      case "invalid_element":
        return `Ogiltigt värde i ${t.origin ?? "värdet"}`;
      default:
        return "Ogiltig input";
    }
  };
};
function Xd() {
  return {
    localeError: Kd()
  };
}
const qd = () => {
  const e = {
    string: { unit: "எழுத்துக்கள்", verb: "கொண்டிருக்க வேண்டும்" },
    file: { unit: "பைட்டுகள்", verb: "கொண்டிருக்க வேண்டும்" },
    array: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" },
    set: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "எண் அல்லாதது" : "எண்";
      case "object": {
        if (Array.isArray(t))
          return "அணி";
        if (t === null)
          return "வெறுமை";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "உள்ளீடு",
    email: "மின்னஞ்சல் முகவரி",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO தேதி நேரம்",
    date: "ISO தேதி",
    time: "ISO நேரம்",
    duration: "ISO கால அளவு",
    ipv4: "IPv4 முகவரி",
    ipv6: "IPv6 முகவரி",
    cidrv4: "IPv4 வரம்பு",
    cidrv6: "IPv6 வரம்பு",
    base64: "base64-encoded சரம்",
    base64url: "base64url-encoded சரம்",
    json_string: "JSON சரம்",
    e164: "E.164 எண்",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${t.expected}, பெறப்பட்டது ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${I(t.values[0])}` : `தவறான விருப்பம்: எதிர்பார்க்கப்பட்டது ${h(t.values, "|")} இல் ஒன்று`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${t.origin ?? "மதிப்பு"} ${i}${t.maximum.toString()} ${a.unit ?? "உறுப்புகள்"} ஆக இருக்க வேண்டும்` : `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${t.origin ?? "மதிப்பு"} ${i}${t.maximum.toString()} ஆக இருக்க வேண்டும்`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${t.origin} ${i}${t.minimum.toString()} ${a.unit} ஆக இருக்க வேண்டும்` : `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${t.origin} ${i}${t.minimum.toString()} ஆக இருக்க வேண்டும்`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `தவறான சரம்: "${i.prefix}" இல் தொடங்க வேண்டும்` : i.format === "ends_with" ? `தவறான சரம்: "${i.suffix}" இல் முடிவடைய வேண்டும்` : i.format === "includes" ? `தவறான சரம்: "${i.includes}" ஐ உள்ளடக்க வேண்டும்` : i.format === "regex" ? `தவறான சரம்: ${i.pattern} முறைபாட்டுடன் பொருந்த வேண்டும்` : `தவறான ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `தவறான எண்: ${t.divisor} இன் பலமாக இருக்க வேண்டும்`;
      case "unrecognized_keys":
        return `அடையாளம் தெரியாத விசை${t.keys.length > 1 ? "கள்" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `${t.origin} இல் தவறான விசை`;
      case "invalid_union":
        return "தவறான உள்ளீடு";
      case "invalid_element":
        return `${t.origin} இல் தவறான மதிப்பு`;
      default:
        return "தவறான உள்ளீடு";
    }
  };
};
function Yd() {
  return {
    localeError: qd()
  };
}
const Qd = () => {
  const e = {
    string: { unit: "ตัวอักษร", verb: "ควรมี" },
    file: { unit: "ไบต์", verb: "ควรมี" },
    array: { unit: "รายการ", verb: "ควรมี" },
    set: { unit: "รายการ", verb: "ควรมี" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "ไม่ใช่ตัวเลข (NaN)" : "ตัวเลข";
      case "object": {
        if (Array.isArray(t))
          return "อาร์เรย์ (Array)";
        if (t === null)
          return "ไม่มีค่า (null)";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "ข้อมูลที่ป้อน",
    email: "ที่อยู่อีเมล",
    url: "URL",
    emoji: "อิโมจิ",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "วันที่เวลาแบบ ISO",
    date: "วันที่แบบ ISO",
    time: "เวลาแบบ ISO",
    duration: "ช่วงเวลาแบบ ISO",
    ipv4: "ที่อยู่ IPv4",
    ipv6: "ที่อยู่ IPv6",
    cidrv4: "ช่วง IP แบบ IPv4",
    cidrv6: "ช่วง IP แบบ IPv6",
    base64: "ข้อความแบบ Base64",
    base64url: "ข้อความแบบ Base64 สำหรับ URL",
    json_string: "ข้อความแบบ JSON",
    e164: "เบอร์โทรศัพท์ระหว่างประเทศ (E.164)",
    jwt: "โทเคน JWT",
    template_literal: "ข้อมูลที่ป้อน"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `ประเภทข้อมูลไม่ถูกต้อง: ควรเป็น ${t.expected} แต่ได้รับ ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `ค่าไม่ถูกต้อง: ควรเป็น ${I(t.values[0])}` : `ตัวเลือกไม่ถูกต้อง: ควรเป็นหนึ่งใน ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "ไม่เกิน" : "น้อยกว่า", a = n(t.origin);
        return a ? `เกินกำหนด: ${t.origin ?? "ค่า"} ควรมี${i} ${t.maximum.toString()} ${a.unit ?? "รายการ"}` : `เกินกำหนด: ${t.origin ?? "ค่า"} ควรมี${i} ${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? "อย่างน้อย" : "มากกว่า", a = n(t.origin);
        return a ? `น้อยกว่ากำหนด: ${t.origin} ควรมี${i} ${t.minimum.toString()} ${a.unit}` : `น้อยกว่ากำหนด: ${t.origin} ควรมี${i} ${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องขึ้นต้นด้วย "${i.prefix}"` : i.format === "ends_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องลงท้ายด้วย "${i.suffix}"` : i.format === "includes" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องมี "${i.includes}" อยู่ในข้อความ` : i.format === "regex" ? `รูปแบบไม่ถูกต้อง: ต้องตรงกับรูปแบบที่กำหนด ${i.pattern}` : `รูปแบบไม่ถูกต้อง: ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `ตัวเลขไม่ถูกต้อง: ต้องเป็นจำนวนที่หารด้วย ${t.divisor} ได้ลงตัว`;
      case "unrecognized_keys":
        return `พบคีย์ที่ไม่รู้จัก: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `คีย์ไม่ถูกต้องใน ${t.origin}`;
      case "invalid_union":
        return "ข้อมูลไม่ถูกต้อง: ไม่ตรงกับรูปแบบยูเนียนที่กำหนดไว้";
      case "invalid_element":
        return `ข้อมูลไม่ถูกต้องใน ${t.origin}`;
      default:
        return "ข้อมูลไม่ถูกต้อง";
    }
  };
};
function em() {
  return {
    localeError: Qd()
  };
}
const tm = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "number";
    case "object": {
      if (Array.isArray(e))
        return "array";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, nm = () => {
  const e = {
    string: { unit: "karakter", verb: "olmalı" },
    file: { unit: "bayt", verb: "olmalı" },
    array: { unit: "öğe", verb: "olmalı" },
    set: { unit: "öğe", verb: "olmalı" }
  };
  function n(o) {
    return e[o] ?? null;
  }
  const r = {
    regex: "girdi",
    email: "e-posta adresi",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO tarih ve saat",
    date: "ISO tarih",
    time: "ISO saat",
    duration: "ISO süre",
    ipv4: "IPv4 adresi",
    ipv6: "IPv6 adresi",
    cidrv4: "IPv4 aralığı",
    cidrv6: "IPv6 aralığı",
    base64: "base64 ile şifrelenmiş metin",
    base64url: "base64url ile şifrelenmiş metin",
    json_string: "JSON dizesi",
    e164: "E.164 sayısı",
    jwt: "JWT",
    template_literal: "Şablon dizesi"
  };
  return (o) => {
    switch (o.code) {
      case "invalid_type":
        return `Geçersiz değer: beklenen ${o.expected}, alınan ${tm(o.input)}`;
      case "invalid_value":
        return o.values.length === 1 ? `Geçersiz değer: beklenen ${I(o.values[0])}` : `Geçersiz seçenek: aşağıdakilerden biri olmalı: ${h(o.values, "|")}`;
      case "too_big": {
        const t = o.inclusive ? "<=" : "<", i = n(o.origin);
        return i ? `Çok büyük: beklenen ${o.origin ?? "değer"} ${t}${o.maximum.toString()} ${i.unit ?? "öğe"}` : `Çok büyük: beklenen ${o.origin ?? "değer"} ${t}${o.maximum.toString()}`;
      }
      case "too_small": {
        const t = o.inclusive ? ">=" : ">", i = n(o.origin);
        return i ? `Çok küçük: beklenen ${o.origin} ${t}${o.minimum.toString()} ${i.unit}` : `Çok küçük: beklenen ${o.origin} ${t}${o.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = o;
        return t.format === "starts_with" ? `Geçersiz metin: "${t.prefix}" ile başlamalı` : t.format === "ends_with" ? `Geçersiz metin: "${t.suffix}" ile bitmeli` : t.format === "includes" ? `Geçersiz metin: "${t.includes}" içermeli` : t.format === "regex" ? `Geçersiz metin: ${t.pattern} desenine uymalı` : `Geçersiz ${r[t.format] ?? o.format}`;
      }
      case "not_multiple_of":
        return `Geçersiz sayı: ${o.divisor} ile tam bölünebilmeli`;
      case "unrecognized_keys":
        return `Tanınmayan anahtar${o.keys.length > 1 ? "lar" : ""}: ${h(o.keys, ", ")}`;
      case "invalid_key":
        return `${o.origin} içinde geçersiz anahtar`;
      case "invalid_union":
        return "Geçersiz değer";
      case "invalid_element":
        return `${o.origin} içinde geçersiz değer`;
      default:
        return "Geçersiz değer";
    }
  };
};
function rm() {
  return {
    localeError: nm()
  };
}
const im = () => {
  const e = {
    string: { unit: "символів", verb: "матиме" },
    file: { unit: "байтів", verb: "матиме" },
    array: { unit: "елементів", verb: "матиме" },
    set: { unit: "елементів", verb: "матиме" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "число";
      case "object": {
        if (Array.isArray(t))
          return "масив";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "вхідні дані",
    email: "адреса електронної пошти",
    url: "URL",
    emoji: "емодзі",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "дата та час ISO",
    date: "дата ISO",
    time: "час ISO",
    duration: "тривалість ISO",
    ipv4: "адреса IPv4",
    ipv6: "адреса IPv6",
    cidrv4: "діапазон IPv4",
    cidrv6: "діапазон IPv6",
    base64: "рядок у кодуванні base64",
    base64url: "рядок у кодуванні base64url",
    json_string: "рядок JSON",
    e164: "номер E.164",
    jwt: "JWT",
    template_literal: "вхідні дані"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Неправильні вхідні дані: очікується ${t.expected}, отримано ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Неправильні вхідні дані: очікується ${I(t.values[0])}` : `Неправильна опція: очікується одне з ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Занадто велике: очікується, що ${t.origin ?? "значення"} ${a.verb} ${i}${t.maximum.toString()} ${a.unit ?? "елементів"}` : `Занадто велике: очікується, що ${t.origin ?? "значення"} буде ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Занадто мале: очікується, що ${t.origin} ${a.verb} ${i}${t.minimum.toString()} ${a.unit}` : `Занадто мале: очікується, що ${t.origin} буде ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Неправильний рядок: повинен починатися з "${i.prefix}"` : i.format === "ends_with" ? `Неправильний рядок: повинен закінчуватися на "${i.suffix}"` : i.format === "includes" ? `Неправильний рядок: повинен містити "${i.includes}"` : i.format === "regex" ? `Неправильний рядок: повинен відповідати шаблону ${i.pattern}` : `Неправильний ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Неправильне число: повинно бути кратним ${t.divisor}`;
      case "unrecognized_keys":
        return `Нерозпізнаний ключ${t.keys.length > 1 ? "і" : ""}: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Неправильний ключ у ${t.origin}`;
      case "invalid_union":
        return "Неправильні вхідні дані";
      case "invalid_element":
        return `Неправильне значення у ${t.origin}`;
      default:
        return "Неправильні вхідні дані";
    }
  };
};
function Fa() {
  return {
    localeError: im()
  };
}
function om() {
  return Fa();
}
const am = () => {
  const e = {
    string: { unit: "حروف", verb: "ہونا" },
    file: { unit: "بائٹس", verb: "ہونا" },
    array: { unit: "آئٹمز", verb: "ہونا" },
    set: { unit: "آئٹمز", verb: "ہونا" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "نمبر";
      case "object": {
        if (Array.isArray(t))
          return "آرے";
        if (t === null)
          return "نل";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "ان پٹ",
    email: "ای میل ایڈریس",
    url: "یو آر ایل",
    emoji: "ایموجی",
    uuid: "یو یو آئی ڈی",
    uuidv4: "یو یو آئی ڈی وی 4",
    uuidv6: "یو یو آئی ڈی وی 6",
    nanoid: "نینو آئی ڈی",
    guid: "جی یو آئی ڈی",
    cuid: "سی یو آئی ڈی",
    cuid2: "سی یو آئی ڈی 2",
    ulid: "یو ایل آئی ڈی",
    xid: "ایکس آئی ڈی",
    ksuid: "کے ایس یو آئی ڈی",
    datetime: "آئی ایس او ڈیٹ ٹائم",
    date: "آئی ایس او تاریخ",
    time: "آئی ایس او وقت",
    duration: "آئی ایس او مدت",
    ipv4: "آئی پی وی 4 ایڈریس",
    ipv6: "آئی پی وی 6 ایڈریس",
    cidrv4: "آئی پی وی 4 رینج",
    cidrv6: "آئی پی وی 6 رینج",
    base64: "بیس 64 ان کوڈڈ سٹرنگ",
    base64url: "بیس 64 یو آر ایل ان کوڈڈ سٹرنگ",
    json_string: "جے ایس او این سٹرنگ",
    e164: "ای 164 نمبر",
    jwt: "جے ڈبلیو ٹی",
    template_literal: "ان پٹ"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `غلط ان پٹ: ${t.expected} متوقع تھا، ${r(t.input)} موصول ہوا`;
      case "invalid_value":
        return t.values.length === 1 ? `غلط ان پٹ: ${I(t.values[0])} متوقع تھا` : `غلط آپشن: ${h(t.values, "|")} میں سے ایک متوقع تھا`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `بہت بڑا: ${t.origin ?? "ویلیو"} کے ${i}${t.maximum.toString()} ${a.unit ?? "عناصر"} ہونے متوقع تھے` : `بہت بڑا: ${t.origin ?? "ویلیو"} کا ${i}${t.maximum.toString()} ہونا متوقع تھا`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `بہت چھوٹا: ${t.origin} کے ${i}${t.minimum.toString()} ${a.unit} ہونے متوقع تھے` : `بہت چھوٹا: ${t.origin} کا ${i}${t.minimum.toString()} ہونا متوقع تھا`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `غلط سٹرنگ: "${i.prefix}" سے شروع ہونا چاہیے` : i.format === "ends_with" ? `غلط سٹرنگ: "${i.suffix}" پر ختم ہونا چاہیے` : i.format === "includes" ? `غلط سٹرنگ: "${i.includes}" شامل ہونا چاہیے` : i.format === "regex" ? `غلط سٹرنگ: پیٹرن ${i.pattern} سے میچ ہونا چاہیے` : `غلط ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `غلط نمبر: ${t.divisor} کا مضاعف ہونا چاہیے`;
      case "unrecognized_keys":
        return `غیر تسلیم شدہ کی${t.keys.length > 1 ? "ز" : ""}: ${h(t.keys, "، ")}`;
      case "invalid_key":
        return `${t.origin} میں غلط کی`;
      case "invalid_union":
        return "غلط ان پٹ";
      case "invalid_element":
        return `${t.origin} میں غلط ویلیو`;
      default:
        return "غلط ان پٹ";
    }
  };
};
function um() {
  return {
    localeError: am()
  };
}
const cm = () => {
  const e = {
    string: { unit: "ký tự", verb: "có" },
    file: { unit: "byte", verb: "có" },
    array: { unit: "phần tử", verb: "có" },
    set: { unit: "phần tử", verb: "có" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "số";
      case "object": {
        if (Array.isArray(t))
          return "mảng";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "đầu vào",
    email: "địa chỉ email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ngày giờ ISO",
    date: "ngày ISO",
    time: "giờ ISO",
    duration: "khoảng thời gian ISO",
    ipv4: "địa chỉ IPv4",
    ipv6: "địa chỉ IPv6",
    cidrv4: "dải IPv4",
    cidrv6: "dải IPv6",
    base64: "chuỗi mã hóa base64",
    base64url: "chuỗi mã hóa base64url",
    json_string: "chuỗi JSON",
    e164: "số E.164",
    jwt: "JWT",
    template_literal: "đầu vào"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Đầu vào không hợp lệ: mong đợi ${t.expected}, nhận được ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Đầu vào không hợp lệ: mong đợi ${I(t.values[0])}` : `Tùy chọn không hợp lệ: mong đợi một trong các giá trị ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Quá lớn: mong đợi ${t.origin ?? "giá trị"} ${a.verb} ${i}${t.maximum.toString()} ${a.unit ?? "phần tử"}` : `Quá lớn: mong đợi ${t.origin ?? "giá trị"} ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Quá nhỏ: mong đợi ${t.origin} ${a.verb} ${i}${t.minimum.toString()} ${a.unit}` : `Quá nhỏ: mong đợi ${t.origin} ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Chuỗi không hợp lệ: phải bắt đầu bằng "${i.prefix}"` : i.format === "ends_with" ? `Chuỗi không hợp lệ: phải kết thúc bằng "${i.suffix}"` : i.format === "includes" ? `Chuỗi không hợp lệ: phải bao gồm "${i.includes}"` : i.format === "regex" ? `Chuỗi không hợp lệ: phải khớp với mẫu ${i.pattern}` : `${o[i.format] ?? t.format} không hợp lệ`;
      }
      case "not_multiple_of":
        return `Số không hợp lệ: phải là bội số của ${t.divisor}`;
      case "unrecognized_keys":
        return `Khóa không được nhận dạng: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Khóa không hợp lệ trong ${t.origin}`;
      case "invalid_union":
        return "Đầu vào không hợp lệ";
      case "invalid_element":
        return `Giá trị không hợp lệ trong ${t.origin}`;
      default:
        return "Đầu vào không hợp lệ";
    }
  };
};
function sm() {
  return {
    localeError: cm()
  };
}
const lm = () => {
  const e = {
    string: { unit: "字符", verb: "包含" },
    file: { unit: "字节", verb: "包含" },
    array: { unit: "项", verb: "包含" },
    set: { unit: "项", verb: "包含" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "非数字(NaN)" : "数字";
      case "object": {
        if (Array.isArray(t))
          return "数组";
        if (t === null)
          return "空值(null)";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "输入",
    email: "电子邮件",
    url: "URL",
    emoji: "表情符号",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO日期时间",
    date: "ISO日期",
    time: "ISO时间",
    duration: "ISO时长",
    ipv4: "IPv4地址",
    ipv6: "IPv6地址",
    cidrv4: "IPv4网段",
    cidrv6: "IPv6网段",
    base64: "base64编码字符串",
    base64url: "base64url编码字符串",
    json_string: "JSON字符串",
    e164: "E.164号码",
    jwt: "JWT",
    template_literal: "输入"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `无效输入：期望 ${t.expected}，实际接收 ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `无效输入：期望 ${I(t.values[0])}` : `无效选项：期望以下之一 ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `数值过大：期望 ${t.origin ?? "值"} ${i}${t.maximum.toString()} ${a.unit ?? "个元素"}` : `数值过大：期望 ${t.origin ?? "值"} ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `数值过小：期望 ${t.origin} ${i}${t.minimum.toString()} ${a.unit}` : `数值过小：期望 ${t.origin} ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `无效字符串：必须以 "${i.prefix}" 开头` : i.format === "ends_with" ? `无效字符串：必须以 "${i.suffix}" 结尾` : i.format === "includes" ? `无效字符串：必须包含 "${i.includes}"` : i.format === "regex" ? `无效字符串：必须满足正则表达式 ${i.pattern}` : `无效${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `无效数字：必须是 ${t.divisor} 的倍数`;
      case "unrecognized_keys":
        return `出现未知的键(key): ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `${t.origin} 中的键(key)无效`;
      case "invalid_union":
        return "无效输入";
      case "invalid_element":
        return `${t.origin} 中包含无效值(value)`;
      default:
        return "无效输入";
    }
  };
};
function dm() {
  return {
    localeError: lm()
  };
}
const mm = () => {
  const e = {
    string: { unit: "字元", verb: "擁有" },
    file: { unit: "位元組", verb: "擁有" },
    array: { unit: "項目", verb: "擁有" },
    set: { unit: "項目", verb: "擁有" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "輸入",
    email: "郵件地址",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO 日期時間",
    date: "ISO 日期",
    time: "ISO 時間",
    duration: "ISO 期間",
    ipv4: "IPv4 位址",
    ipv6: "IPv6 位址",
    cidrv4: "IPv4 範圍",
    cidrv6: "IPv6 範圍",
    base64: "base64 編碼字串",
    base64url: "base64url 編碼字串",
    json_string: "JSON 字串",
    e164: "E.164 數值",
    jwt: "JWT",
    template_literal: "輸入"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `無效的輸入值：預期為 ${t.expected}，但收到 ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `無效的輸入值：預期為 ${I(t.values[0])}` : `無效的選項：預期為以下其中之一 ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `數值過大：預期 ${t.origin ?? "值"} 應為 ${i}${t.maximum.toString()} ${a.unit ?? "個元素"}` : `數值過大：預期 ${t.origin ?? "值"} 應為 ${i}${t.maximum.toString()}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `數值過小：預期 ${t.origin} 應為 ${i}${t.minimum.toString()} ${a.unit}` : `數值過小：預期 ${t.origin} 應為 ${i}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `無效的字串：必須以 "${i.prefix}" 開頭` : i.format === "ends_with" ? `無效的字串：必須以 "${i.suffix}" 結尾` : i.format === "includes" ? `無效的字串：必須包含 "${i.includes}"` : i.format === "regex" ? `無效的字串：必須符合格式 ${i.pattern}` : `無效的 ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `無效的數字：必須為 ${t.divisor} 的倍數`;
      case "unrecognized_keys":
        return `無法識別的鍵值${t.keys.length > 1 ? "們" : ""}：${h(t.keys, "、")}`;
      case "invalid_key":
        return `${t.origin} 中有無效的鍵值`;
      case "invalid_union":
        return "無效的輸入值";
      case "invalid_element":
        return `${t.origin} 中有無效的值`;
      default:
        return "無效的輸入值";
    }
  };
};
function fm() {
  return {
    localeError: mm()
  };
}
const pm = () => {
  const e = {
    string: { unit: "àmi", verb: "ní" },
    file: { unit: "bytes", verb: "ní" },
    array: { unit: "nkan", verb: "ní" },
    set: { unit: "nkan", verb: "ní" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const i = typeof t;
    switch (i) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "nọ́mbà";
      case "object": {
        if (Array.isArray(t))
          return "akopọ";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return i;
  }, o = {
    regex: "ẹ̀rọ ìbáwọlé",
    email: "àdírẹ́sì ìmẹ́lì",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "àkókò ISO",
    date: "ọjọ́ ISO",
    time: "àkókò ISO",
    duration: "àkókò tó pé ISO",
    ipv4: "àdírẹ́sì IPv4",
    ipv6: "àdírẹ́sì IPv6",
    cidrv4: "àgbègbè IPv4",
    cidrv6: "àgbègbè IPv6",
    base64: "ọ̀rọ̀ tí a kọ́ ní base64",
    base64url: "ọ̀rọ̀ base64url",
    json_string: "ọ̀rọ̀ JSON",
    e164: "nọ́mbà E.164",
    jwt: "JWT",
    template_literal: "ẹ̀rọ ìbáwọlé"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ìbáwọlé aṣìṣe: a ní láti fi ${t.expected}, àmọ̀ a rí ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ìbáwọlé aṣìṣe: a ní láti fi ${I(t.values[0])}` : `Àṣàyàn aṣìṣe: yan ọ̀kan lára ${h(t.values, "|")}`;
      case "too_big": {
        const i = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Tó pọ̀ jù: a ní láti jẹ́ pé ${t.origin ?? "iye"} ${a.verb} ${i}${t.maximum} ${a.unit}` : `Tó pọ̀ jù: a ní láti jẹ́ ${i}${t.maximum}`;
      }
      case "too_small": {
        const i = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Kéré ju: a ní láti jẹ́ pé ${t.origin} ${a.verb} ${i}${t.minimum} ${a.unit}` : `Kéré ju: a ní láti jẹ́ ${i}${t.minimum}`;
      }
      case "invalid_format": {
        const i = t;
        return i.format === "starts_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bẹ̀rẹ̀ pẹ̀lú "${i.prefix}"` : i.format === "ends_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ parí pẹ̀lú "${i.suffix}"` : i.format === "includes" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ ní "${i.includes}"` : i.format === "regex" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bá àpẹẹrẹ mu ${i.pattern}` : `Aṣìṣe: ${o[i.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Nọ́mbà aṣìṣe: gbọ́dọ̀ jẹ́ èyà pípín ti ${t.divisor}`;
      case "unrecognized_keys":
        return `Bọtìnì àìmọ̀: ${h(t.keys, ", ")}`;
      case "invalid_key":
        return `Bọtìnì aṣìṣe nínú ${t.origin}`;
      case "invalid_union":
        return "Ìbáwọlé aṣìṣe";
      case "invalid_element":
        return `Iye aṣìṣe nínú ${t.origin}`;
      default:
        return "Ìbáwọlé aṣìṣe";
    }
  };
};
function gm() {
  return {
    localeError: pm()
  };
}
const Va = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ar: jl,
  az: Ul,
  be: El,
  bg: Dl,
  ca: Zl,
  cs: Ml,
  da: Rl,
  de: Vl,
  en: Ba,
  eo: Kl,
  es: ql,
  fa: Ql,
  fi: td,
  fr: rd,
  frCA: od,
  he: ud,
  hu: sd,
  id: dd,
  is: pd,
  it: vd,
  ja: bd,
  ka: yd,
  kh: wd,
  km: Ra,
  ko: Sd,
  lt: Nd,
  mk: Od,
  ms: Td,
  nl: Pd,
  no: Dd,
  ota: Zd,
  pl: Rd,
  ps: Md,
  pt: Vd,
  ru: Wd,
  sl: Gd,
  sv: Xd,
  ta: Yd,
  th: em,
  tr: rm,
  ua: om,
  uk: Fa,
  ur: um,
  vi: sm,
  yo: gm,
  zhCN: dm,
  zhTW: fm
}, Symbol.toStringTag, { value: "Module" })), Ha = Symbol("ZodOutput"), Wa = Symbol("ZodInput");
class nn {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(n, ...r) {
    const o = r[0];
    if (this._map.set(n, o), o && typeof o == "object" && "id" in o) {
      if (this._idmap.has(o.id))
        throw new Error(`ID ${o.id} already exists in the registry`);
      this._idmap.set(o.id, n);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(n) {
    const r = this._map.get(n);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(n), this;
  }
  get(n) {
    const r = n._zod.parent;
    if (r) {
      const o = { ...this.get(r) ?? {} };
      delete o.id;
      const t = { ...o, ...this._map.get(n) };
      return Object.keys(t).length ? t : void 0;
    }
    return this._map.get(n);
  }
  has(n) {
    return this._map.has(n);
  }
}
function rn() {
  return new nn();
}
const ee = /* @__PURE__ */ rn();
function Ja(e, n) {
  return new e({
    type: "string",
    ...f(n)
  });
}
function Ga(e, n) {
  return new e({
    type: "string",
    coerce: !0,
    ...f(n)
  });
}
function on(e, n) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function Je(e, n) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function an(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function un(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...f(n)
  });
}
function cn(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...f(n)
  });
}
function sn(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...f(n)
  });
}
function tt(e, n) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function ln(e, n) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function dn(e, n) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function mn(e, n) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function fn(e, n) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function pn(e, n) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function gn(e, n) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function vn(e, n) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function hn(e, n) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function bn(e, n) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function $n(e, n) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function _n(e, n) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function yn(e, n) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function kn(e, n) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function wn(e, n) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
function In(e, n) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...f(n)
  });
}
const Ka = {
  Any: null,
  Minute: -1,
  Second: 0,
  Millisecond: 3,
  Microsecond: 6
};
function Xa(e, n) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...f(n)
  });
}
function qa(e, n) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...f(n)
  });
}
function Ya(e, n) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...f(n)
  });
}
function Qa(e, n) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...f(n)
  });
}
function eu(e, n) {
  return new e({
    type: "number",
    checks: [],
    ...f(n)
  });
}
function tu(e, n) {
  return new e({
    type: "number",
    coerce: !0,
    checks: [],
    ...f(n)
  });
}
function nu(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...f(n)
  });
}
function ru(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "float32",
    ...f(n)
  });
}
function iu(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "float64",
    ...f(n)
  });
}
function ou(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "int32",
    ...f(n)
  });
}
function au(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "uint32",
    ...f(n)
  });
}
function uu(e, n) {
  return new e({
    type: "boolean",
    ...f(n)
  });
}
function cu(e, n) {
  return new e({
    type: "boolean",
    coerce: !0,
    ...f(n)
  });
}
function su(e, n) {
  return new e({
    type: "bigint",
    ...f(n)
  });
}
function lu(e, n) {
  return new e({
    type: "bigint",
    coerce: !0,
    ...f(n)
  });
}
function du(e, n) {
  return new e({
    type: "bigint",
    check: "bigint_format",
    abort: !1,
    format: "int64",
    ...f(n)
  });
}
function mu(e, n) {
  return new e({
    type: "bigint",
    check: "bigint_format",
    abort: !1,
    format: "uint64",
    ...f(n)
  });
}
function fu(e, n) {
  return new e({
    type: "symbol",
    ...f(n)
  });
}
function pu(e, n) {
  return new e({
    type: "undefined",
    ...f(n)
  });
}
function gu(e, n) {
  return new e({
    type: "null",
    ...f(n)
  });
}
function vu(e) {
  return new e({
    type: "any"
  });
}
function hu(e) {
  return new e({
    type: "unknown"
  });
}
function bu(e, n) {
  return new e({
    type: "never",
    ...f(n)
  });
}
function $u(e, n) {
  return new e({
    type: "void",
    ...f(n)
  });
}
function _u(e, n) {
  return new e({
    type: "date",
    ...f(n)
  });
}
function yu(e, n) {
  return new e({
    type: "date",
    coerce: !0,
    ...f(n)
  });
}
function ku(e, n) {
  return new e({
    type: "nan",
    ...f(n)
  });
}
function ie(e, n) {
  return new Wt({
    check: "less_than",
    ...f(n),
    value: e,
    inclusive: !1
  });
}
function H(e, n) {
  return new Wt({
    check: "less_than",
    ...f(n),
    value: e,
    inclusive: !0
  });
}
function oe(e, n) {
  return new Jt({
    check: "greater_than",
    ...f(n),
    value: e,
    inclusive: !1
  });
}
function M(e, n) {
  return new Jt({
    check: "greater_than",
    ...f(n),
    value: e,
    inclusive: !0
  });
}
function wu(e) {
  return oe(0, e);
}
function Iu(e) {
  return ie(0, e);
}
function Su(e) {
  return H(0, e);
}
function zu(e) {
  return M(0, e);
}
function xe(e, n) {
  return new mo({
    check: "multiple_of",
    ...f(n),
    value: e
  });
}
function nt(e, n) {
  return new go({
    check: "max_size",
    ...f(n),
    maximum: e
  });
}
function Ne(e, n) {
  return new vo({
    check: "min_size",
    ...f(n),
    minimum: e
  });
}
function Sn(e, n) {
  return new ho({
    check: "size_equals",
    ...f(n),
    size: e
  });
}
function rt(e, n) {
  return new bo({
    check: "max_length",
    ...f(n),
    maximum: e
  });
}
function de(e, n) {
  return new $o({
    check: "min_length",
    ...f(n),
    minimum: e
  });
}
function it(e, n) {
  return new _o({
    check: "length_equals",
    ...f(n),
    length: e
  });
}
function zn(e, n) {
  return new yo({
    check: "string_format",
    format: "regex",
    ...f(n),
    pattern: e
  });
}
function xn(e) {
  return new ko({
    check: "string_format",
    format: "lowercase",
    ...f(e)
  });
}
function Nn(e) {
  return new wo({
    check: "string_format",
    format: "uppercase",
    ...f(e)
  });
}
function jn(e, n) {
  return new Io({
    check: "string_format",
    format: "includes",
    ...f(n),
    includes: e
  });
}
function On(e, n) {
  return new So({
    check: "string_format",
    format: "starts_with",
    ...f(n),
    prefix: e
  });
}
function Un(e, n) {
  return new zo({
    check: "string_format",
    format: "ends_with",
    ...f(n),
    suffix: e
  });
}
function xu(e, n, r) {
  return new xo({
    check: "property",
    property: e,
    schema: n,
    ...f(r)
  });
}
function Tn(e, n) {
  return new No({
    check: "mime_type",
    mime: e,
    ...f(n)
  });
}
function ae(e) {
  return new jo({
    check: "overwrite",
    tx: e
  });
}
function En(e) {
  return ae((n) => n.normalize(e));
}
function Pn() {
  return ae((e) => e.trim());
}
function Cn() {
  return ae((e) => e.toLowerCase());
}
function Dn() {
  return ae((e) => e.toUpperCase());
}
function Nu(e, n, r) {
  return new e({
    type: "array",
    element: n,
    // get element() {
    //   return element;
    // },
    ...f(r)
  });
}
function vm(e, n, r) {
  return new e({
    type: "union",
    options: n,
    ...f(r)
  });
}
function hm(e, n, r, o) {
  return new e({
    type: "union",
    options: r,
    discriminator: n,
    ...f(o)
  });
}
function bm(e, n, r) {
  return new e({
    type: "intersection",
    left: n,
    right: r
  });
}
function $m(e, n, r, o) {
  const t = r instanceof S, i = t ? o : r, a = t ? r : null;
  return new e({
    type: "tuple",
    items: n,
    rest: a,
    ...f(i)
  });
}
function _m(e, n, r, o) {
  return new e({
    type: "record",
    keyType: n,
    valueType: r,
    ...f(o)
  });
}
function ym(e, n, r, o) {
  return new e({
    type: "map",
    keyType: n,
    valueType: r,
    ...f(o)
  });
}
function km(e, n, r) {
  return new e({
    type: "set",
    valueType: n,
    ...f(r)
  });
}
function wm(e, n, r) {
  const o = Array.isArray(n) ? Object.fromEntries(n.map((t) => [t, t])) : n;
  return new e({
    type: "enum",
    entries: o,
    ...f(r)
  });
}
function Im(e, n, r) {
  return new e({
    type: "enum",
    entries: n,
    ...f(r)
  });
}
function Sm(e, n, r) {
  return new e({
    type: "literal",
    values: Array.isArray(n) ? n : [n],
    ...f(r)
  });
}
function ju(e, n) {
  return new e({
    type: "file",
    ...f(n)
  });
}
function zm(e, n) {
  return new e({
    type: "transform",
    transform: n
  });
}
function xm(e, n) {
  return new e({
    type: "optional",
    innerType: n
  });
}
function Nm(e, n) {
  return new e({
    type: "nullable",
    innerType: n
  });
}
function jm(e, n, r) {
  return new e({
    type: "default",
    innerType: n,
    get defaultValue() {
      return typeof r == "function" ? r() : Zt(r);
    }
  });
}
function Om(e, n, r) {
  return new e({
    type: "nonoptional",
    innerType: n,
    ...f(r)
  });
}
function Um(e, n) {
  return new e({
    type: "success",
    innerType: n
  });
}
function Tm(e, n, r) {
  return new e({
    type: "catch",
    innerType: n,
    catchValue: typeof r == "function" ? r : () => r
  });
}
function Em(e, n, r) {
  return new e({
    type: "pipe",
    in: n,
    out: r
  });
}
function Pm(e, n) {
  return new e({
    type: "readonly",
    innerType: n
  });
}
function Cm(e, n, r) {
  return new e({
    type: "template_literal",
    parts: n,
    ...f(r)
  });
}
function Dm(e, n) {
  return new e({
    type: "lazy",
    getter: n
  });
}
function Am(e, n) {
  return new e({
    type: "promise",
    innerType: n
  });
}
function Ou(e, n, r) {
  const o = f(r);
  return o.abort ?? (o.abort = !0), new e({
    type: "custom",
    check: "custom",
    fn: n,
    ...o
  });
}
function Uu(e, n, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: n,
    ...f(r)
  });
}
function Tu(e) {
  const n = Eu((r) => (r.addIssue = (o) => {
    if (typeof o == "string")
      r.issues.push(Se(o, r.value, n._zod.def));
    else {
      const t = o;
      t.fatal && (t.continue = !1), t.code ?? (t.code = "custom"), t.input ?? (t.input = r.value), t.inst ?? (t.inst = n), t.continue ?? (t.continue = !n._zod.def.abort), r.issues.push(Se(t));
    }
  }, e(r.value, r)));
  return n;
}
function Eu(e, n) {
  const r = new T({
    check: "custom",
    ...f(n)
  });
  return r._zod.check = e, r;
}
function Pu(e, n) {
  const r = f(n);
  let o = r.truthy ?? ["true", "1", "yes", "on", "y", "enabled"], t = r.falsy ?? ["false", "0", "no", "off", "n", "disabled"];
  r.case !== "sensitive" && (o = o.map((_) => typeof _ == "string" ? _.toLowerCase() : _), t = t.map((_) => typeof _ == "string" ? _.toLowerCase() : _));
  const i = new Set(o), a = new Set(t), u = e.Codec ?? tn, c = e.Boolean ?? Xt, s = e.String ?? Pe, m = new s({ type: "string", error: r.error }), p = new c({ type: "boolean", error: r.error }), b = new u({
    type: "pipe",
    in: m,
    out: p,
    transform: (_, g) => {
      let N = _;
      return r.case !== "sensitive" && (N = N.toLowerCase()), i.has(N) ? !0 : a.has(N) ? !1 : (g.issues.push({
        code: "invalid_value",
        expected: "stringbool",
        values: [...i, ...a],
        input: g.value,
        inst: b,
        continue: !1
      }), {});
    },
    reverseTransform: (_, g) => _ === !0 ? o[0] || "true" : t[0] || "false",
    error: r.error
  });
  return b;
}
function Ce(e, n, r, o = {}) {
  const t = f(o), i = {
    ...f(o),
    check: "string_format",
    type: "string",
    format: n,
    fn: typeof r == "function" ? r : (u) => r.test(u),
    ...t
  };
  return r instanceof RegExp && (i.pattern = r), new e(i);
}
class xt {
  constructor(n) {
    this.counter = 0, this.metadataRegistry = (n == null ? void 0 : n.metadata) ?? ee, this.target = (n == null ? void 0 : n.target) ?? "draft-2020-12", this.unrepresentable = (n == null ? void 0 : n.unrepresentable) ?? "throw", this.override = (n == null ? void 0 : n.override) ?? (() => {
    }), this.io = (n == null ? void 0 : n.io) ?? "output", this.seen = /* @__PURE__ */ new Map();
  }
  process(n, r = { path: [], schemaPath: [] }) {
    var p, b, _;
    var o;
    const t = n._zod.def, i = {
      guid: "uuid",
      url: "uri",
      datetime: "date-time",
      json_string: "json-string",
      regex: ""
      // do not set
    }, a = this.seen.get(n);
    if (a)
      return a.count++, r.schemaPath.includes(n) && (a.cycle = r.path), a.schema;
    const u = { schema: {}, count: 1, cycle: void 0, path: r.path };
    this.seen.set(n, u);
    const c = (b = (p = n._zod).toJSONSchema) == null ? void 0 : b.call(p);
    if (c)
      u.schema = c;
    else {
      const g = {
        ...r,
        schemaPath: [...r.schemaPath, n],
        path: r.path
      }, N = n._zod.parent;
      if (N)
        u.ref = N, this.process(N, g), this.seen.get(N).isParent = !0;
      else {
        const $ = u.schema;
        switch (t.type) {
          case "string": {
            const d = $;
            d.type = "string";
            const { minimum: y, maximum: v, format: k, patterns: w, contentEncoding: j } = n._zod.bag;
            if (typeof y == "number" && (d.minLength = y), typeof v == "number" && (d.maxLength = v), k && (d.format = i[k] ?? k, d.format === "" && delete d.format), j && (d.contentEncoding = j), w && w.size > 0) {
              const E = [...w];
              E.length === 1 ? d.pattern = E[0].source : E.length > 1 && (u.schema.allOf = [
                ...E.map((J) => ({
                  ...this.target === "draft-7" || this.target === "draft-4" || this.target === "openapi-3.0" ? { type: "string" } : {},
                  pattern: J.source
                }))
              ]);
            }
            break;
          }
          case "number": {
            const d = $, { minimum: y, maximum: v, format: k, multipleOf: w, exclusiveMaximum: j, exclusiveMinimum: E } = n._zod.bag;
            typeof k == "string" && k.includes("int") ? d.type = "integer" : d.type = "number", typeof E == "number" && (this.target === "draft-4" || this.target === "openapi-3.0" ? (d.minimum = E, d.exclusiveMinimum = !0) : d.exclusiveMinimum = E), typeof y == "number" && (d.minimum = y, typeof E == "number" && this.target !== "draft-4" && (E >= y ? delete d.minimum : delete d.exclusiveMinimum)), typeof j == "number" && (this.target === "draft-4" || this.target === "openapi-3.0" ? (d.maximum = j, d.exclusiveMaximum = !0) : d.exclusiveMaximum = j), typeof v == "number" && (d.maximum = v, typeof j == "number" && this.target !== "draft-4" && (j <= v ? delete d.maximum : delete d.exclusiveMaximum)), typeof w == "number" && (d.multipleOf = w);
            break;
          }
          case "boolean": {
            const d = $;
            d.type = "boolean";
            break;
          }
          case "bigint": {
            if (this.unrepresentable === "throw")
              throw new Error("BigInt cannot be represented in JSON Schema");
            break;
          }
          case "symbol": {
            if (this.unrepresentable === "throw")
              throw new Error("Symbols cannot be represented in JSON Schema");
            break;
          }
          case "null": {
            this.target === "openapi-3.0" ? ($.type = "string", $.nullable = !0, $.enum = [null]) : $.type = "null";
            break;
          }
          case "any":
            break;
          case "unknown":
            break;
          case "undefined": {
            if (this.unrepresentable === "throw")
              throw new Error("Undefined cannot be represented in JSON Schema");
            break;
          }
          case "void": {
            if (this.unrepresentable === "throw")
              throw new Error("Void cannot be represented in JSON Schema");
            break;
          }
          case "never": {
            $.not = {};
            break;
          }
          case "date": {
            if (this.unrepresentable === "throw")
              throw new Error("Date cannot be represented in JSON Schema");
            break;
          }
          case "array": {
            const d = $, { minimum: y, maximum: v } = n._zod.bag;
            typeof y == "number" && (d.minItems = y), typeof v == "number" && (d.maxItems = v), d.type = "array", d.items = this.process(t.element, { ...g, path: [...g.path, "items"] });
            break;
          }
          case "object": {
            const d = $;
            d.type = "object", d.properties = {};
            const y = t.shape;
            for (const w in y)
              d.properties[w] = this.process(y[w], {
                ...g,
                path: [...g.path, "properties", w]
              });
            const v = new Set(Object.keys(y)), k = new Set([...v].filter((w) => {
              const j = t.shape[w]._zod;
              return this.io === "input" ? j.optin === void 0 : j.optout === void 0;
            }));
            k.size > 0 && (d.required = Array.from(k)), ((_ = t.catchall) == null ? void 0 : _._zod.def.type) === "never" ? d.additionalProperties = !1 : t.catchall ? t.catchall && (d.additionalProperties = this.process(t.catchall, {
              ...g,
              path: [...g.path, "additionalProperties"]
            })) : this.io === "output" && (d.additionalProperties = !1);
            break;
          }
          case "union": {
            const d = $, y = t.options.map((v, k) => this.process(v, {
              ...g,
              path: [...g.path, "anyOf", k]
            }));
            d.anyOf = y;
            break;
          }
          case "intersection": {
            const d = $, y = this.process(t.left, {
              ...g,
              path: [...g.path, "allOf", 0]
            }), v = this.process(t.right, {
              ...g,
              path: [...g.path, "allOf", 1]
            }), k = (j) => "allOf" in j && Object.keys(j).length === 1, w = [
              ...k(y) ? y.allOf : [y],
              ...k(v) ? v.allOf : [v]
            ];
            d.allOf = w;
            break;
          }
          case "tuple": {
            const d = $;
            d.type = "array";
            const y = this.target === "draft-2020-12" ? "prefixItems" : "items", v = this.target === "draft-2020-12" || this.target === "openapi-3.0" ? "items" : "additionalItems", k = t.items.map((J, _t) => this.process(J, {
              ...g,
              path: [...g.path, y, _t]
            })), w = t.rest ? this.process(t.rest, {
              ...g,
              path: [...g.path, v, ...this.target === "openapi-3.0" ? [t.items.length] : []]
            }) : null;
            this.target === "draft-2020-12" ? (d.prefixItems = k, w && (d.items = w)) : this.target === "openapi-3.0" ? (d.items = {
              anyOf: k
            }, w && d.items.anyOf.push(w), d.minItems = k.length, w || (d.maxItems = k.length)) : (d.items = k, w && (d.additionalItems = w));
            const { minimum: j, maximum: E } = n._zod.bag;
            typeof j == "number" && (d.minItems = j), typeof E == "number" && (d.maxItems = E);
            break;
          }
          case "record": {
            const d = $;
            d.type = "object", (this.target === "draft-7" || this.target === "draft-2020-12") && (d.propertyNames = this.process(t.keyType, {
              ...g,
              path: [...g.path, "propertyNames"]
            })), d.additionalProperties = this.process(t.valueType, {
              ...g,
              path: [...g.path, "additionalProperties"]
            });
            break;
          }
          case "map": {
            if (this.unrepresentable === "throw")
              throw new Error("Map cannot be represented in JSON Schema");
            break;
          }
          case "set": {
            if (this.unrepresentable === "throw")
              throw new Error("Set cannot be represented in JSON Schema");
            break;
          }
          case "enum": {
            const d = $, y = ri(t.entries);
            y.every((v) => typeof v == "number") && (d.type = "number"), y.every((v) => typeof v == "string") && (d.type = "string"), d.enum = y;
            break;
          }
          case "literal": {
            const d = $, y = [];
            for (const v of t.values)
              if (v === void 0) {
                if (this.unrepresentable === "throw")
                  throw new Error("Literal `undefined` cannot be represented in JSON Schema");
              } else if (typeof v == "bigint") {
                if (this.unrepresentable === "throw")
                  throw new Error("BigInt literals cannot be represented in JSON Schema");
                y.push(Number(v));
              } else
                y.push(v);
            if (y.length !== 0) if (y.length === 1) {
              const v = y[0];
              d.type = v === null ? "null" : typeof v, this.target === "draft-4" || this.target === "openapi-3.0" ? d.enum = [v] : d.const = v;
            } else
              y.every((v) => typeof v == "number") && (d.type = "number"), y.every((v) => typeof v == "string") && (d.type = "string"), y.every((v) => typeof v == "boolean") && (d.type = "string"), y.every((v) => v === null) && (d.type = "null"), d.enum = y;
            break;
          }
          case "file": {
            const d = $, y = {
              type: "string",
              format: "binary",
              contentEncoding: "binary"
            }, { minimum: v, maximum: k, mime: w } = n._zod.bag;
            v !== void 0 && (y.minLength = v), k !== void 0 && (y.maxLength = k), w ? w.length === 1 ? (y.contentMediaType = w[0], Object.assign(d, y)) : d.anyOf = w.map((j) => ({ ...y, contentMediaType: j })) : Object.assign(d, y);
            break;
          }
          case "transform": {
            if (this.unrepresentable === "throw")
              throw new Error("Transforms cannot be represented in JSON Schema");
            break;
          }
          case "nullable": {
            const d = this.process(t.innerType, g);
            this.target === "openapi-3.0" ? (u.ref = t.innerType, $.nullable = !0) : $.anyOf = [d, { type: "null" }];
            break;
          }
          case "nonoptional": {
            this.process(t.innerType, g), u.ref = t.innerType;
            break;
          }
          case "success": {
            const d = $;
            d.type = "boolean";
            break;
          }
          case "default": {
            this.process(t.innerType, g), u.ref = t.innerType, $.default = JSON.parse(JSON.stringify(t.defaultValue));
            break;
          }
          case "prefault": {
            this.process(t.innerType, g), u.ref = t.innerType, this.io === "input" && ($._prefault = JSON.parse(JSON.stringify(t.defaultValue)));
            break;
          }
          case "catch": {
            this.process(t.innerType, g), u.ref = t.innerType;
            let d;
            try {
              d = t.catchValue(void 0);
            } catch {
              throw new Error("Dynamic catch values are not supported in JSON Schema");
            }
            $.default = d;
            break;
          }
          case "nan": {
            if (this.unrepresentable === "throw")
              throw new Error("NaN cannot be represented in JSON Schema");
            break;
          }
          case "template_literal": {
            const d = $, y = n._zod.pattern;
            if (!y)
              throw new Error("Pattern not found in template literal");
            d.type = "string", d.pattern = y.source;
            break;
          }
          case "pipe": {
            const d = this.io === "input" ? t.in._zod.def.type === "transform" ? t.out : t.in : t.out;
            this.process(d, g), u.ref = d;
            break;
          }
          case "readonly": {
            this.process(t.innerType, g), u.ref = t.innerType, $.readOnly = !0;
            break;
          }
          case "promise": {
            this.process(t.innerType, g), u.ref = t.innerType;
            break;
          }
          case "optional": {
            this.process(t.innerType, g), u.ref = t.innerType;
            break;
          }
          case "lazy": {
            const d = n._zod.innerType;
            this.process(d, g), u.ref = d;
            break;
          }
          case "custom": {
            if (this.unrepresentable === "throw")
              throw new Error("Custom types cannot be represented in JSON Schema");
            break;
          }
          case "function": {
            if (this.unrepresentable === "throw")
              throw new Error("Function types cannot be represented in JSON Schema");
            break;
          }
        }
      }
    }
    const s = this.metadataRegistry.get(n);
    return s && Object.assign(u.schema, s), this.io === "input" && P(n) && (delete u.schema.examples, delete u.schema.default), this.io === "input" && u.schema._prefault && ((o = u.schema).default ?? (o.default = u.schema._prefault)), delete u.schema._prefault, this.seen.get(n).schema;
  }
  emit(n, r) {
    var m, p, b, _, g, N;
    const o = {
      cycles: (r == null ? void 0 : r.cycles) ?? "ref",
      reused: (r == null ? void 0 : r.reused) ?? "inline",
      // unrepresentable: _params?.unrepresentable ?? "throw",
      // uri: _params?.uri ?? ((id) => `${id}`),
      external: (r == null ? void 0 : r.external) ?? void 0
    }, t = this.seen.get(n);
    if (!t)
      throw new Error("Unprocessed schema. This is a bug in Zod.");
    const i = ($) => {
      var w;
      const d = this.target === "draft-2020-12" ? "$defs" : "definitions";
      if (o.external) {
        const j = (w = o.external.registry.get($[0])) == null ? void 0 : w.id, E = o.external.uri ?? ((_t) => _t);
        if (j)
          return { ref: E(j) };
        const J = $[1].defId ?? $[1].schema.id ?? `schema${this.counter++}`;
        return $[1].defId = J, { defId: J, ref: `${E("__shared")}#/${d}/${J}` };
      }
      if ($[1] === t)
        return { ref: "#" };
      const v = `#/${d}/`, k = $[1].schema.id ?? `__schema${this.counter++}`;
      return { defId: k, ref: v + k };
    }, a = ($) => {
      if ($[1].schema.$ref)
        return;
      const d = $[1], { ref: y, defId: v } = i($);
      d.def = { ...d.schema }, v && (d.defId = v);
      const k = d.schema;
      for (const w in k)
        delete k[w];
      k.$ref = y;
    };
    if (o.cycles === "throw")
      for (const $ of this.seen.entries()) {
        const d = $[1];
        if (d.cycle)
          throw new Error(`Cycle detected: #/${(m = d.cycle) == null ? void 0 : m.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
      }
    for (const $ of this.seen.entries()) {
      const d = $[1];
      if (n === $[0]) {
        a($);
        continue;
      }
      if (o.external) {
        const v = (p = o.external.registry.get($[0])) == null ? void 0 : p.id;
        if (n !== $[0] && v) {
          a($);
          continue;
        }
      }
      if ((b = this.metadataRegistry.get($[0])) == null ? void 0 : b.id) {
        a($);
        continue;
      }
      if (d.cycle) {
        a($);
        continue;
      }
      if (d.count > 1 && o.reused === "ref") {
        a($);
        continue;
      }
    }
    const u = ($, d) => {
      const y = this.seen.get($), v = y.def ?? y.schema, k = { ...v };
      if (y.ref === null)
        return;
      const w = y.ref;
      if (y.ref = null, w) {
        u(w, d);
        const j = this.seen.get(w).schema;
        j.$ref && (d.target === "draft-7" || d.target === "draft-4" || d.target === "openapi-3.0") ? (v.allOf = v.allOf ?? [], v.allOf.push(j)) : (Object.assign(v, j), Object.assign(v, k));
      }
      y.isParent || this.override({
        zodSchema: $,
        jsonSchema: v,
        path: y.path ?? []
      });
    };
    for (const $ of [...this.seen.entries()].reverse())
      u($[0], { target: this.target });
    const c = {};
    if (this.target === "draft-2020-12" ? c.$schema = "https://json-schema.org/draft/2020-12/schema" : this.target === "draft-7" ? c.$schema = "http://json-schema.org/draft-07/schema#" : this.target === "draft-4" ? c.$schema = "http://json-schema.org/draft-04/schema#" : this.target === "openapi-3.0" || console.warn(`Invalid target: ${this.target}`), (_ = o.external) != null && _.uri) {
      const $ = (g = o.external.registry.get(n)) == null ? void 0 : g.id;
      if (!$)
        throw new Error("Schema is missing an `id` property");
      c.$id = o.external.uri($);
    }
    Object.assign(c, t.def);
    const s = ((N = o.external) == null ? void 0 : N.defs) ?? {};
    for (const $ of this.seen.entries()) {
      const d = $[1];
      d.def && d.defId && (s[d.defId] = d.def);
    }
    o.external || Object.keys(s).length > 0 && (this.target === "draft-2020-12" ? c.$defs = s : c.definitions = s);
    try {
      return JSON.parse(JSON.stringify(c));
    } catch {
      throw new Error("Error converting schema to JSON.");
    }
  }
}
function Cu(e, n) {
  if (e instanceof nn) {
    const o = new xt(n), t = {};
    for (const u of e._idmap.entries()) {
      const [c, s] = u;
      o.process(s);
    }
    const i = {}, a = {
      registry: e,
      uri: n == null ? void 0 : n.uri,
      defs: t
    };
    for (const u of e._idmap.entries()) {
      const [c, s] = u;
      i[c] = o.emit(s, {
        ...n,
        external: a
      });
    }
    if (Object.keys(t).length > 0) {
      const u = o.target === "draft-2020-12" ? "$defs" : "definitions";
      i.__shared = {
        [u]: t
      };
    }
    return { schemas: i };
  }
  const r = new xt(n);
  return r.process(e), r.emit(e, n);
}
function P(e, n) {
  const r = n ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(e))
    return !1;
  r.seen.add(e);
  const t = e._zod.def;
  switch (t.type) {
    case "string":
    case "number":
    case "bigint":
    case "boolean":
    case "date":
    case "symbol":
    case "undefined":
    case "null":
    case "any":
    case "unknown":
    case "never":
    case "void":
    case "literal":
    case "enum":
    case "nan":
    case "file":
    case "template_literal":
      return !1;
    case "array":
      return P(t.element, r);
    case "object": {
      for (const i in t.shape)
        if (P(t.shape[i], r))
          return !0;
      return !1;
    }
    case "union": {
      for (const i of t.options)
        if (P(i, r))
          return !0;
      return !1;
    }
    case "intersection":
      return P(t.left, r) || P(t.right, r);
    case "tuple": {
      for (const i of t.items)
        if (P(i, r))
          return !0;
      return !!(t.rest && P(t.rest, r));
    }
    case "record":
      return P(t.keyType, r) || P(t.valueType, r);
    case "map":
      return P(t.keyType, r) || P(t.valueType, r);
    case "set":
      return P(t.valueType, r);
    case "promise":
    case "optional":
    case "nonoptional":
    case "nullable":
    case "readonly":
      return P(t.innerType, r);
    case "lazy":
      return P(t.getter(), r);
    case "default":
      return P(t.innerType, r);
    case "prefault":
      return P(t.innerType, r);
    case "custom":
      return !1;
    case "transform":
      return !0;
    case "pipe":
      return P(t.in, r) || P(t.out, r);
    case "success":
      return !1;
    case "catch":
      return !1;
    case "function":
      return !1;
  }
  throw new Error(`Unknown schema type: ${t.type}`);
}
const Zm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Lm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $ZodAny: sa,
  $ZodArray: pa,
  $ZodAsyncError: we,
  $ZodBase64: qo,
  $ZodBase64URL: Qo,
  $ZodBigInt: qt,
  $ZodBigIntFormat: oa,
  $ZodBoolean: Xt,
  $ZodCIDRv4: Ko,
  $ZodCIDRv6: Xo,
  $ZodCUID: Zo,
  $ZodCUID2: Lo,
  $ZodCatch: Ta,
  $ZodCheck: T,
  $ZodCheckBigIntFormat: po,
  $ZodCheckEndsWith: zo,
  $ZodCheckGreaterThan: Jt,
  $ZodCheckIncludes: Io,
  $ZodCheckLengthEquals: _o,
  $ZodCheckLessThan: Wt,
  $ZodCheckLowerCase: ko,
  $ZodCheckMaxLength: bo,
  $ZodCheckMaxSize: go,
  $ZodCheckMimeType: No,
  $ZodCheckMinLength: $o,
  $ZodCheckMinSize: vo,
  $ZodCheckMultipleOf: mo,
  $ZodCheckNumberFormat: fo,
  $ZodCheckOverwrite: jo,
  $ZodCheckProperty: xo,
  $ZodCheckRegex: yo,
  $ZodCheckSizeEquals: ho,
  $ZodCheckStartsWith: So,
  $ZodCheckStringFormat: Ee,
  $ZodCheckUpperCase: wo,
  $ZodCodec: tn,
  $ZodCustom: Ma,
  $ZodCustomStringFormat: ra,
  $ZodDate: fa,
  $ZodDefault: ge,
  $ZodDiscriminatedUnion: $a,
  $ZodE164: ea,
  $ZodEmail: Po,
  $ZodEmoji: Do,
  $ZodEncodeError: Ye,
  $ZodEnum: Ia,
  $ZodError: ii,
  $ZodFile: za,
  $ZodFunction: Aa,
  $ZodGUID: To,
  $ZodIPv4: Jo,
  $ZodIPv6: Go,
  $ZodISODate: Vo,
  $ZodISODateTime: Fo,
  $ZodISODuration: Wo,
  $ZodISOTime: Ho,
  $ZodIntersection: _a,
  $ZodJWT: na,
  $ZodKSUID: Ro,
  $ZodLazy: La,
  $ZodLiteral: Sa,
  $ZodMap: ka,
  $ZodNaN: Ea,
  $ZodNanoID: Ao,
  $ZodNever: da,
  $ZodNonOptional: Oa,
  $ZodNull: ca,
  $ZodNullable: Na,
  $ZodNumber: Kt,
  $ZodNumberFormat: ia,
  $ZodObject: ha,
  $ZodObjectJIT: ba,
  $ZodOptional: en,
  $ZodPipe: Pa,
  $ZodPrefault: ja,
  $ZodPromise: Za,
  $ZodReadonly: Ca,
  $ZodRealError: cs,
  $ZodRecord: ya,
  $ZodRegistry: nn,
  $ZodSet: wa,
  $ZodString: Pe,
  $ZodStringFormat: O,
  $ZodSuccess: Ua,
  $ZodSymbol: aa,
  $ZodTemplateLiteral: Da,
  $ZodTransform: xa,
  $ZodTuple: Qt,
  $ZodType: S,
  $ZodULID: Mo,
  $ZodURL: Co,
  $ZodUUID: Eo,
  $ZodUndefined: ua,
  $ZodUnion: Yt,
  $ZodUnknown: la,
  $ZodVoid: ma,
  $ZodXID: Bo,
  $brand: oi,
  $constructor: l,
  $input: Wa,
  $output: Ha,
  Doc: Oo,
  JSONSchema: Zm,
  JSONSchemaGenerator: xt,
  NEVER: ai,
  TimePrecision: Ka,
  _any: vu,
  _array: Nu,
  _base64: yn,
  _base64url: kn,
  _bigint: su,
  _boolean: uu,
  _catch: Tm,
  _check: Eu,
  _cidrv4: $n,
  _cidrv6: _n,
  _coercedBigint: lu,
  _coercedBoolean: cu,
  _coercedDate: yu,
  _coercedNumber: tu,
  _coercedString: Ga,
  _cuid: mn,
  _cuid2: fn,
  _custom: Ou,
  _date: _u,
  _decode: ui,
  _decodeAsync: ci,
  _default: jm,
  _discriminatedUnion: hm,
  _e164: wn,
  _email: on,
  _emoji: ln,
  _encode: si,
  _encodeAsync: li,
  _endsWith: Un,
  _enum: wm,
  _file: ju,
  _float32: ru,
  _float64: iu,
  _gt: oe,
  _gte: M,
  _guid: Je,
  _includes: jn,
  _int: nu,
  _int32: ou,
  _int64: du,
  _intersection: bm,
  _ipv4: hn,
  _ipv6: bn,
  _isoDate: qa,
  _isoDateTime: Xa,
  _isoDuration: Qa,
  _isoTime: Ya,
  _jwt: In,
  _ksuid: vn,
  _lazy: Dm,
  _length: it,
  _literal: Sm,
  _lowercase: xn,
  _lt: ie,
  _lte: H,
  _map: ym,
  _max: H,
  _maxLength: rt,
  _maxSize: nt,
  _mime: Tn,
  _min: M,
  _minLength: de,
  _minSize: Ne,
  _multipleOf: xe,
  _nan: ku,
  _nanoid: dn,
  _nativeEnum: Im,
  _negative: Iu,
  _never: bu,
  _nonnegative: zu,
  _nonoptional: Om,
  _nonpositive: Su,
  _normalize: En,
  _null: gu,
  _nullable: Nm,
  _number: eu,
  _optional: xm,
  _overwrite: ae,
  _parse: di,
  _parseAsync: mi,
  _pipe: Em,
  _positive: wu,
  _promise: Am,
  _property: xu,
  _readonly: Pm,
  _record: _m,
  _refine: Uu,
  _regex: zn,
  _safeDecode: fi,
  _safeDecodeAsync: pi,
  _safeEncode: gi,
  _safeEncodeAsync: vi,
  _safeParse: hi,
  _safeParseAsync: bi,
  _set: km,
  _size: Sn,
  _startsWith: On,
  _string: Ja,
  _stringFormat: Ce,
  _stringbool: Pu,
  _success: Um,
  _superRefine: Tu,
  _symbol: fu,
  _templateLiteral: Cm,
  _toLowerCase: Cn,
  _toUpperCase: Dn,
  _transform: zm,
  _trim: Pn,
  _tuple: $m,
  _uint32: au,
  _uint64: mu,
  _ulid: pn,
  _undefined: pu,
  _union: vm,
  _unknown: hu,
  _uppercase: Nn,
  _url: tt,
  _uuid: an,
  _uuidv4: un,
  _uuidv6: cn,
  _uuidv7: sn,
  _void: $u,
  _xid: gn,
  clone: Qe,
  config: W,
  decode: ss,
  decodeAsync: ls,
  encode: ds,
  encodeAsync: ms,
  flattenError: Lt,
  formatError: Mt,
  globalConfig: ni,
  globalRegistry: ee,
  isValidBase64: Gt,
  isValidBase64URL: Yo,
  isValidJWT: ta,
  locales: Va,
  parse: Ie,
  parseAsync: It,
  prettifyError: $i,
  regexes: Ht,
  registry: rn,
  safeDecode: fs,
  safeDecodeAsync: ps,
  safeEncode: gs,
  safeEncodeAsync: vs,
  safeParse: Pt,
  safeParseAsync: ti,
  toDotPath: hs,
  toJSONSchema: Cu,
  treeifyError: _i,
  util: yi,
  version: Uo
}, Symbol.toStringTag, { value: "Module" }));
function ne(e) {
  return "data-" + e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function iv(e) {
  const n = e.split("/");
  return !n.length || // invalid?
  n[n.length - 1] === "" ? e : n[n.length - 1];
}
function ov(e) {
  var r;
  const n = [
    "mp4",
    "webm",
    "ogg",
    "mov",
    "mkv",
    "flv",
    "avi",
    "wmv",
    "m4v"
  ];
  try {
    const t = ((r = new URL(e).pathname.split(".").pop()) == null ? void 0 : r.toLowerCase()) || "";
    return n.includes(t);
  } catch {
    return !1;
  }
}
function Mm(e) {
  const n = {};
  return Object.entries(e._zodSource._zod.def.shape).forEach(
    ([r, o]) => {
      const t = o instanceof ge ? o._zod.def.defaultValue : void 0;
      n[r] = {
        default: t,
        keepOnSplit: !0,
        // Props are displayed in kebab-case as HTML attributes. If a prop's
        // value is the same as its default, we don't display an HTML
        // attribute for it.
        // TODO: needed? (seems tiptap specific)
        parseHTML: (i) => {
          const a = i.getAttribute(ne(r));
          if (a === null)
            return null;
          try {
            const u = JSON.parse(a);
            return Ie(o, u);
          } catch {
            return Ie(o, a);
          }
        },
        // TODO: needed? (seems tiptap specific)
        renderHTML: (i) => i[r] === t ? {} : typeof i[r] == "object" ? {
          [ne(r)]: JSON.stringify(i[r])
        } : {
          [ne(r)]: i[r]
        }
      };
    }
  ), n;
}
function Bm(e, n, r, o) {
  const t = e();
  if (t === void 0)
    throw new Error("Cannot find node position");
  const a = r.state.doc.resolve(t).node().attrs.id;
  if (!a)
    throw new Error("Block doesn't have id");
  const u = n.getBlock(a);
  if (u.type !== o)
    throw new Error("Block type does not match");
  return u;
}
function Nt(e, n, r, o, t = !1, i) {
  const a = document.createElement("div");
  if (i !== void 0)
    for (const [u, c] of Object.entries(i))
      u !== "class" && a.setAttribute(u, c);
  a.className = ze(
    "bn-block-content",
    (i == null ? void 0 : i.class) || ""
  ), a.setAttribute("data-content-type", n);
  for (const [u, c] of Object.entries(r)) {
    const s = o._zodSource._zod.def.shape[u], m = s instanceof ge ? s._zod.def.defaultValue : void 0;
    c !== m && (typeof c == "string" ? a.setAttribute(ne(u), c) : a.setAttribute(
      ne(u),
      JSON.stringify(c)
    ));
  }
  return t && a.setAttribute("data-file-block", ""), a.appendChild(e.dom), e.contentDOM && (e.contentDOM.className = ze(
    "bn-inline-content",
    e.contentDOM.className
  )), {
    ...e,
    dom: a
  };
}
function Rm(e, n, r) {
  return {
    config: {
      type: e.type,
      content: e.content,
      propSchema: n
    },
    implementation: {
      node: e.node,
      render: jr,
      toExternalHTML: jr
    },
    extensions: r
  };
}
function Fm(e, n) {
  e.stopEvent = (r) => (r.type === "mousedown" && setTimeout(() => {
    n.view.dom.blur();
  }, 10), !0);
}
function Vm(e, n) {
  const r = [
    {
      tag: "[data-content-type=" + e.type + "]",
      contentElement: ".bn-inline-content"
    }
  ];
  return n.parse && r.push({
    tag: "*",
    getAttrs(o) {
      var i;
      if (typeof o == "string")
        return !1;
      const t = (i = n.parse) == null ? void 0 : i.call(n, o);
      return t === void 0 ? !1 : t;
    },
    getContent: e.content === "inline" || e.content === "none" ? (o, t) => {
      var i;
      if (n.parseContent)
        return n.parseContent({
          el: o,
          schema: t
        });
      if (e.content === "inline") {
        const u = o.cloneNode(!0);
        return rl(
          u,
          (i = n.meta) != null && i.code ? `
` : "<br>"
        ), Ni.fromSchema(t).parse(u, {
          topNode: t.nodes.paragraph.create()
        }).content;
      }
      return Ks.empty;
    } : void 0
  }), r;
}
function av(e, n, r, o) {
  var i, a, u, c;
  const t = n.node || pe.create({
    name: e.type,
    content: e.content === "inline" ? "inline*" : e.content === "none" ? "" : e.content,
    group: "blockContent",
    selectable: ((i = n.meta) == null ? void 0 : i.selectable) ?? !0,
    isolating: ((a = n.meta) == null ? void 0 : a.isolating) ?? !0,
    code: ((u = n.meta) == null ? void 0 : u.code) ?? !1,
    defining: ((c = n.meta) == null ? void 0 : c.defining) ?? !0,
    priority: o,
    addAttributes() {
      return Mm(e.propSchema);
    },
    parseHTML() {
      return Vm(e, n);
    },
    renderHTML({ HTMLAttributes: s }) {
      var p;
      const m = document.createElement("div");
      return Nt(
        {
          dom: m,
          contentDOM: e.content === "inline" ? m : void 0
        },
        e.type,
        {},
        e.propSchema,
        ((p = n.meta) == null ? void 0 : p.fileBlockAccept) !== void 0,
        s
      );
    },
    addNodeView() {
      return (s) => {
        var g, N;
        const m = this.options.editor, p = Bm(
          s.getPos,
          m,
          this.editor,
          e.type
        ), b = ((g = this.options.domAttributes) == null ? void 0 : g.blockContent) || {}, _ = n.render.call(
          { blockContentDOMAttributes: b, props: s, renderType: "nodeView" },
          p,
          m
        );
        return ((N = n.meta) == null ? void 0 : N.selectable) === !1 && Fm(_, this.editor), _;
      };
    }
  });
  if (t.name !== e.type)
    throw new Error(
      "Node name does not match block type. This is a bug in BlockNote."
    );
  return {
    config: e,
    implementation: {
      ...n,
      node: t,
      render(s, m) {
        var b;
        const p = ((b = t.options.domAttributes) == null ? void 0 : b.blockContent) || {};
        return n.render.call(
          {
            blockContentDOMAttributes: p,
            props: void 0,
            renderType: "dom"
          },
          s,
          m
        );
      },
      // TODO: this should not have wrapInBlockStructure and generally be a lot simpler
      // post-processing in externalHTMLExporter should not be necessary
      toExternalHTML: (s, m) => {
        var b, _;
        const p = ((b = t.options.domAttributes) == null ? void 0 : b.blockContent) || {};
        return ((_ = n.toExternalHTML) == null ? void 0 : _.call(
          { blockContentDOMAttributes: p },
          s,
          m
        )) ?? n.render.call(
          { blockContentDOMAttributes: p, renderType: "dom", props: void 0 },
          s,
          m
        );
      }
    },
    extensions: r
  };
}
function uv(e) {
  return e;
}
function B(e, n, r) {
  return (o = {}) => {
    const t = typeof e == "function" ? e(o) : e, i = typeof n == "function" ? n(o) : n, a = r ? typeof r == "function" ? r(o) : r : void 0;
    return {
      config: t,
      implementation: {
        ...i,
        // If the block implementation does not specify a runsBefore, we default to ["default"]
        // This allows for custom blocks to always be prioritized over default blocks.
        runsBefore: i.runsBefore ?? ["default"],
        // TODO: this should not have wrapInBlockStructure and generally be a lot simpler
        // post-processing in externalHTMLExporter should not be necessary
        toExternalHTML(u, c) {
          var m, p;
          const s = (m = i.toExternalHTML) == null ? void 0 : m.call(
            { blockContentDOMAttributes: this.blockContentDOMAttributes },
            u,
            c
          );
          if (s !== void 0)
            return Nt(
              s,
              u.type,
              u.props,
              t.propSchema,
              ((p = i.meta) == null ? void 0 : p.fileBlockAccept) !== void 0
            );
        },
        render(u, c) {
          var p;
          const s = i.render.call(
            {
              blockContentDOMAttributes: this.blockContentDOMAttributes,
              renderType: this.renderType,
              props: this.props
            },
            u,
            c
          );
          return Nt(
            s,
            u.type,
            u.props,
            t.propSchema,
            ((p = i.meta) == null ? void 0 : p.fileBlockAccept) !== void 0,
            this.blockContentDOMAttributes
          );
        }
      },
      extensions: a
    };
  };
}
function cv(e, n, r, o) {
  e.dom.setAttribute("data-inline-content-type", n);
  for (const [t, i] of Object.entries(r)) {
    const a = o._zodSource._zod.def.shape[t], u = a instanceof ge ? a._zod.def.defaultValue : void 0;
    i !== u && (typeof i == "string" ? e.dom.setAttribute(ne(t), i) : e.dom.setAttribute(ne(t), JSON.stringify(i)));
  }
  return e.contentDOM && e.contentDOM.setAttribute("data-editable", ""), e;
}
function sv(e) {
  return {
    Backspace: ({ editor: n }) => {
      const r = n.state.selection.$from;
      return n.state.selection.empty && r.node().type.name === e.type && r.parentOffset === 0;
    }
  };
}
function Hm(e, n) {
  return {
    config: e,
    implementation: n
  };
}
function lv(e, n, r) {
  return Hm(
    {
      type: e.name,
      propSchema: n,
      content: e.config.content === "inline*" ? "styled" : "none"
    },
    {
      ...r,
      node: e
    }
  );
}
function Wm(e) {
  return Object.fromEntries(
    Object.entries(e).map(([n, r]) => [n, r.config])
  );
}
function Jm(e) {
  return e === "boolean" ? {} : {
    stringValue: {
      default: void 0,
      keepOnSplit: !0,
      parseHTML: (n) => n.getAttribute("data-value"),
      renderHTML: (n) => n.stringValue !== void 0 ? {
        "data-value": n.stringValue
      } : {}
    }
  };
}
function Fe(e, n, r, o) {
  return e.dom.setAttribute("data-style-type", n), o === "string" && e.dom.setAttribute("data-value", r), e.contentDOM && e.contentDOM.setAttribute("data-editable", ""), e;
}
function Du(e, n) {
  return {
    config: e,
    implementation: n
  };
}
function _e(e, n) {
  return Du(
    {
      type: e.name,
      propSchema: n
    },
    {
      mark: e,
      render(r, o) {
        const t = o.pmSchema.marks[e.name].spec.toDOM;
        if (t === void 0)
          throw new Error(
            "This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`."
          );
        const i = o.pmSchema.mark(e.name, {
          stringValue: r
        }), a = xr.renderSpec(
          document,
          t(i, !0)
        );
        if (typeof a != "object" || !("dom" in a))
          throw new Error(
            "Cannot use this block's default HTML serialization as its corresponding TipTap mark's `renderHTML` function does not return an object with the `dom` property."
          );
        return a;
      },
      toExternalHTML(r, o) {
        const t = o.pmSchema.marks[e.name].spec.toDOM;
        if (t === void 0)
          throw new Error(
            "This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`."
          );
        const i = o.pmSchema.mark(e.name, {
          stringValue: r
        }), a = xr.renderSpec(
          document,
          t(i, !0)
        );
        if (typeof a != "object" || !("dom" in a))
          throw new Error(
            "Cannot use this block's default HTML serialization as its corresponding TipTap mark's `renderHTML` function does not return an object with the `dom` property."
          );
        return a;
      }
    }
  );
}
function Gm(e) {
  return Object.fromEntries(
    Object.entries(e).map(([n, r]) => [n, r.config])
  );
}
const An = /* @__PURE__ */ l("ZodISODateTime", (e, n) => {
  Fo.init(e, n), U.init(e, n);
});
function Au(e) {
  return Xa(An, e);
}
const Zn = /* @__PURE__ */ l("ZodISODate", (e, n) => {
  Vo.init(e, n), U.init(e, n);
});
function Zu(e) {
  return qa(Zn, e);
}
const Ln = /* @__PURE__ */ l("ZodISOTime", (e, n) => {
  Ho.init(e, n), U.init(e, n);
});
function Lu(e) {
  return Ya(Ln, e);
}
const Mn = /* @__PURE__ */ l("ZodISODuration", (e, n) => {
  Wo.init(e, n), U.init(e, n);
});
function Mu(e) {
  return Qa(Mn, e);
}
const Km = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ZodISODate: Zn,
  ZodISODateTime: An,
  ZodISODuration: Mn,
  ZodISOTime: Ln,
  date: Zu,
  datetime: Au,
  duration: Mu,
  time: Lu
}, Symbol.toStringTag, { value: "Module" })), Bu = (e, n) => {
  ii.init(e, n), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (r) => Mt(e, r)
      // enumerable: false,
    },
    flatten: {
      value: (r) => Lt(e, r)
      // enumerable: false,
    },
    addIssue: {
      value: (r) => {
        e.issues.push(r), e.message = JSON.stringify(e.issues, kr, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (r) => {
        e.issues.push(...r), e.message = JSON.stringify(e.issues, kr, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Xm = l("ZodError", Bu), R = l("ZodError", Bu, {
  Parent: Error
}), Ru = /* @__PURE__ */ di(R), Fu = /* @__PURE__ */ mi(R), Vu = /* @__PURE__ */ hi(R), Hu = /* @__PURE__ */ bi(R), Wu = /* @__PURE__ */ si(R), Ju = /* @__PURE__ */ ui(R), Gu = /* @__PURE__ */ li(R), Ku = /* @__PURE__ */ ci(R), Xu = /* @__PURE__ */ gi(R), qu = /* @__PURE__ */ fi(R), Yu = /* @__PURE__ */ vi(R), Qu = /* @__PURE__ */ pi(R), z = /* @__PURE__ */ l("ZodType", (e, n) => (S.init(e, n), e.def = n, e.type = n.type, Object.defineProperty(e, "_def", { value: n }), e.check = (...r) => e.clone(bs(n, {
  checks: [
    ...n.checks ?? [],
    ...r.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
  ]
})), e.clone = (r, o) => Qe(e, r, o), e.brand = () => e, e.register = (r, o) => (r.add(e, o), e), e.parse = (r, o) => Ru(e, r, o, { callee: e.parse }), e.safeParse = (r, o) => Vu(e, r, o), e.parseAsync = async (r, o) => Fu(e, r, o, { callee: e.parseAsync }), e.safeParseAsync = async (r, o) => Hu(e, r, o), e.spa = e.safeParseAsync, e.encode = (r, o) => Wu(e, r, o), e.decode = (r, o) => Ju(e, r, o), e.encodeAsync = async (r, o) => Gu(e, r, o), e.decodeAsync = async (r, o) => Ku(e, r, o), e.safeEncode = (r, o) => Xu(e, r, o), e.safeDecode = (r, o) => qu(e, r, o), e.safeEncodeAsync = async (r, o) => Yu(e, r, o), e.safeDecodeAsync = async (r, o) => Qu(e, r, o), e.refine = (r, o) => e.check(Zc(r, o)), e.superRefine = (r) => e.check(Lc(r)), e.overwrite = (r) => e.check(ae(r)), e.optional = () => Ke(e), e.nullable = () => Xe(e), e.nullish = () => Ke(Xe(e)), e.nonoptional = (r) => zc(e, r), e.array = () => dt(e), e.or = (r) => ft([e, r]), e.and = (r) => dc(e, r), e.transform = (r) => qe(e, sr(r)), e.default = (r) => wc(e, r), e.prefault = (r) => Sc(e, r), e.catch = (r) => jc(e, r), e.pipe = (r) => qe(e, r), e.readonly = () => Tc(e), e.describe = (r) => {
  const o = e.clone();
  return ee.add(o, { description: r }), o;
}, Object.defineProperty(e, "description", {
  get() {
    var r;
    return (r = ee.get(e)) == null ? void 0 : r.description;
  },
  configurable: !0
}), e.meta = (...r) => {
  if (r.length === 0)
    return ee.get(e);
  const o = e.clone();
  return ee.add(o, r[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), Bn = /* @__PURE__ */ l("_ZodString", (e, n) => {
  Pe.init(e, n), z.init(e, n);
  const r = e._zod.bag;
  e.format = r.format ?? null, e.minLength = r.minimum ?? null, e.maxLength = r.maximum ?? null, e.regex = (...o) => e.check(zn(...o)), e.includes = (...o) => e.check(jn(...o)), e.startsWith = (...o) => e.check(On(...o)), e.endsWith = (...o) => e.check(Un(...o)), e.min = (...o) => e.check(de(...o)), e.max = (...o) => e.check(rt(...o)), e.length = (...o) => e.check(it(...o)), e.nonempty = (...o) => e.check(de(1, ...o)), e.lowercase = (o) => e.check(xn(o)), e.uppercase = (o) => e.check(Nn(o)), e.trim = () => e.check(Pn()), e.normalize = (...o) => e.check(En(...o)), e.toLowerCase = () => e.check(Cn()), e.toUpperCase = () => e.check(Dn());
}), ot = /* @__PURE__ */ l("ZodString", (e, n) => {
  Pe.init(e, n), Bn.init(e, n), e.email = (r) => e.check(on(Rn, r)), e.url = (r) => e.check(tt(at, r)), e.jwt = (r) => e.check(In(rr, r)), e.emoji = (r) => e.check(ln(Fn, r)), e.guid = (r) => e.check(Je(Ge, r)), e.uuid = (r) => e.check(an(K, r)), e.uuidv4 = (r) => e.check(un(K, r)), e.uuidv6 = (r) => e.check(cn(K, r)), e.uuidv7 = (r) => e.check(sn(K, r)), e.nanoid = (r) => e.check(dn(Vn, r)), e.guid = (r) => e.check(Je(Ge, r)), e.cuid = (r) => e.check(mn(Hn, r)), e.cuid2 = (r) => e.check(fn(Wn, r)), e.ulid = (r) => e.check(pn(Jn, r)), e.base64 = (r) => e.check(yn(er, r)), e.base64url = (r) => e.check(kn(tr, r)), e.xid = (r) => e.check(gn(Gn, r)), e.ksuid = (r) => e.check(vn(Kn, r)), e.ipv4 = (r) => e.check(hn(Xn, r)), e.ipv6 = (r) => e.check(bn(qn, r)), e.cidrv4 = (r) => e.check($n(Yn, r)), e.cidrv6 = (r) => e.check(_n(Qn, r)), e.e164 = (r) => e.check(wn(nr, r)), e.datetime = (r) => e.check(Au(r)), e.date = (r) => e.check(Zu(r)), e.time = (r) => e.check(Lu(r)), e.duration = (r) => e.check(Mu(r));
});
function X(e) {
  return Ja(ot, e);
}
const U = /* @__PURE__ */ l("ZodStringFormat", (e, n) => {
  O.init(e, n), Bn.init(e, n);
}), Rn = /* @__PURE__ */ l("ZodEmail", (e, n) => {
  Po.init(e, n), U.init(e, n);
});
function qm(e) {
  return on(Rn, e);
}
const Ge = /* @__PURE__ */ l("ZodGUID", (e, n) => {
  To.init(e, n), U.init(e, n);
});
function Ym(e) {
  return Je(Ge, e);
}
const K = /* @__PURE__ */ l("ZodUUID", (e, n) => {
  Eo.init(e, n), U.init(e, n);
});
function Qm(e) {
  return an(K, e);
}
function ef(e) {
  return un(K, e);
}
function tf(e) {
  return cn(K, e);
}
function nf(e) {
  return sn(K, e);
}
const at = /* @__PURE__ */ l("ZodURL", (e, n) => {
  Co.init(e, n), U.init(e, n);
});
function rf(e) {
  return tt(at, e);
}
function of(e) {
  return tt(at, {
    protocol: /^https?$/,
    hostname: Ji,
    ...f(e)
  });
}
const Fn = /* @__PURE__ */ l("ZodEmoji", (e, n) => {
  Do.init(e, n), U.init(e, n);
});
function af(e) {
  return ln(Fn, e);
}
const Vn = /* @__PURE__ */ l("ZodNanoID", (e, n) => {
  Ao.init(e, n), U.init(e, n);
});
function uf(e) {
  return dn(Vn, e);
}
const Hn = /* @__PURE__ */ l("ZodCUID", (e, n) => {
  Zo.init(e, n), U.init(e, n);
});
function cf(e) {
  return mn(Hn, e);
}
const Wn = /* @__PURE__ */ l("ZodCUID2", (e, n) => {
  Lo.init(e, n), U.init(e, n);
});
function sf(e) {
  return fn(Wn, e);
}
const Jn = /* @__PURE__ */ l("ZodULID", (e, n) => {
  Mo.init(e, n), U.init(e, n);
});
function lf(e) {
  return pn(Jn, e);
}
const Gn = /* @__PURE__ */ l("ZodXID", (e, n) => {
  Bo.init(e, n), U.init(e, n);
});
function df(e) {
  return gn(Gn, e);
}
const Kn = /* @__PURE__ */ l("ZodKSUID", (e, n) => {
  Ro.init(e, n), U.init(e, n);
});
function mf(e) {
  return vn(Kn, e);
}
const Xn = /* @__PURE__ */ l("ZodIPv4", (e, n) => {
  Jo.init(e, n), U.init(e, n);
});
function ff(e) {
  return hn(Xn, e);
}
const qn = /* @__PURE__ */ l("ZodIPv6", (e, n) => {
  Go.init(e, n), U.init(e, n);
});
function pf(e) {
  return bn(qn, e);
}
const Yn = /* @__PURE__ */ l("ZodCIDRv4", (e, n) => {
  Ko.init(e, n), U.init(e, n);
});
function gf(e) {
  return $n(Yn, e);
}
const Qn = /* @__PURE__ */ l("ZodCIDRv6", (e, n) => {
  Xo.init(e, n), U.init(e, n);
});
function vf(e) {
  return _n(Qn, e);
}
const er = /* @__PURE__ */ l("ZodBase64", (e, n) => {
  qo.init(e, n), U.init(e, n);
});
function hf(e) {
  return yn(er, e);
}
const tr = /* @__PURE__ */ l("ZodBase64URL", (e, n) => {
  Qo.init(e, n), U.init(e, n);
});
function bf(e) {
  return kn(tr, e);
}
const nr = /* @__PURE__ */ l("ZodE164", (e, n) => {
  ea.init(e, n), U.init(e, n);
});
function $f(e) {
  return wn(nr, e);
}
const rr = /* @__PURE__ */ l("ZodJWT", (e, n) => {
  na.init(e, n), U.init(e, n);
});
function _f(e) {
  return In(rr, e);
}
const De = /* @__PURE__ */ l("ZodCustomStringFormat", (e, n) => {
  ra.init(e, n), U.init(e, n);
});
function yf(e, n, r = {}) {
  return Ce(De, e, n, r);
}
function kf(e) {
  return Ce(De, "hostname", Vt, e);
}
function wf(e) {
  return Ce(De, "hex", so, e);
}
function If(e, n) {
  const r = (n == null ? void 0 : n.enc) ?? "hex", o = `${e}_${r}`, t = Ht[o];
  if (!t)
    throw new Error(`Unrecognized hash format: ${o}`);
  return Ce(De, o, t, n);
}
const ut = /* @__PURE__ */ l("ZodNumber", (e, n) => {
  Kt.init(e, n), z.init(e, n), e.gt = (o, t) => e.check(oe(o, t)), e.gte = (o, t) => e.check(M(o, t)), e.min = (o, t) => e.check(M(o, t)), e.lt = (o, t) => e.check(ie(o, t)), e.lte = (o, t) => e.check(H(o, t)), e.max = (o, t) => e.check(H(o, t)), e.int = (o) => e.check(jt(o)), e.safe = (o) => e.check(jt(o)), e.positive = (o) => e.check(oe(0, o)), e.nonnegative = (o) => e.check(M(0, o)), e.negative = (o) => e.check(ie(0, o)), e.nonpositive = (o) => e.check(H(0, o)), e.multipleOf = (o, t) => e.check(xe(o, t)), e.step = (o, t) => e.check(xe(o, t)), e.finite = () => e;
  const r = e._zod.bag;
  e.minValue = Math.max(r.minimum ?? Number.NEGATIVE_INFINITY, r.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(r.maximum ?? Number.POSITIVE_INFINITY, r.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (r.format ?? "").includes("int") || Number.isSafeInteger(r.multipleOf ?? 0.5), e.isFinite = !0, e.format = r.format ?? null;
});
function ct(e) {
  return eu(ut, e);
}
const ve = /* @__PURE__ */ l("ZodNumberFormat", (e, n) => {
  ia.init(e, n), ut.init(e, n);
});
function jt(e) {
  return nu(ve, e);
}
function Sf(e) {
  return ru(ve, e);
}
function zf(e) {
  return iu(ve, e);
}
function xf(e) {
  return ou(ve, e);
}
function Nf(e) {
  return au(ve, e);
}
const st = /* @__PURE__ */ l("ZodBoolean", (e, n) => {
  Xt.init(e, n), z.init(e, n);
});
function Ae(e) {
  return uu(st, e);
}
const lt = /* @__PURE__ */ l("ZodBigInt", (e, n) => {
  qt.init(e, n), z.init(e, n), e.gte = (o, t) => e.check(M(o, t)), e.min = (o, t) => e.check(M(o, t)), e.gt = (o, t) => e.check(oe(o, t)), e.gte = (o, t) => e.check(M(o, t)), e.min = (o, t) => e.check(M(o, t)), e.lt = (o, t) => e.check(ie(o, t)), e.lte = (o, t) => e.check(H(o, t)), e.max = (o, t) => e.check(H(o, t)), e.positive = (o) => e.check(oe(BigInt(0), o)), e.negative = (o) => e.check(ie(BigInt(0), o)), e.nonpositive = (o) => e.check(H(BigInt(0), o)), e.nonnegative = (o) => e.check(M(BigInt(0), o)), e.multipleOf = (o, t) => e.check(xe(o, t));
  const r = e._zod.bag;
  e.minValue = r.minimum ?? null, e.maxValue = r.maximum ?? null, e.format = r.format ?? null;
});
function jf(e) {
  return su(lt, e);
}
const ir = /* @__PURE__ */ l("ZodBigIntFormat", (e, n) => {
  oa.init(e, n), lt.init(e, n);
});
function Of(e) {
  return du(ir, e);
}
function Uf(e) {
  return mu(ir, e);
}
const ec = /* @__PURE__ */ l("ZodSymbol", (e, n) => {
  aa.init(e, n), z.init(e, n);
});
function Tf(e) {
  return fu(ec, e);
}
const tc = /* @__PURE__ */ l("ZodUndefined", (e, n) => {
  ua.init(e, n), z.init(e, n);
});
function Ef(e) {
  return pu(tc, e);
}
const nc = /* @__PURE__ */ l("ZodNull", (e, n) => {
  ca.init(e, n), z.init(e, n);
});
function rc(e) {
  return gu(nc, e);
}
const ic = /* @__PURE__ */ l("ZodAny", (e, n) => {
  sa.init(e, n), z.init(e, n);
});
function Pf() {
  return vu(ic);
}
const oc = /* @__PURE__ */ l("ZodUnknown", (e, n) => {
  la.init(e, n), z.init(e, n);
});
function me() {
  return hu(oc);
}
const ac = /* @__PURE__ */ l("ZodNever", (e, n) => {
  da.init(e, n), z.init(e, n);
});
function or(e) {
  return bu(ac, e);
}
const uc = /* @__PURE__ */ l("ZodVoid", (e, n) => {
  ma.init(e, n), z.init(e, n);
});
function Cf(e) {
  return $u(uc, e);
}
const ar = /* @__PURE__ */ l("ZodDate", (e, n) => {
  fa.init(e, n), z.init(e, n), e.min = (o, t) => e.check(M(o, t)), e.max = (o, t) => e.check(H(o, t));
  const r = e._zod.bag;
  e.minDate = r.minimum ? new Date(r.minimum) : null, e.maxDate = r.maximum ? new Date(r.maximum) : null;
});
function Df(e) {
  return _u(ar, e);
}
const cc = /* @__PURE__ */ l("ZodArray", (e, n) => {
  pa.init(e, n), z.init(e, n), e.element = n.element, e.min = (r, o) => e.check(de(r, o)), e.nonempty = (r) => e.check(de(1, r)), e.max = (r, o) => e.check(rt(r, o)), e.length = (r, o) => e.check(it(r, o)), e.unwrap = () => e.element;
});
function dt(e, n) {
  return Nu(cc, e, n);
}
function Af(e) {
  const n = e._zod.def.shape;
  return pt(Object.keys(n));
}
const mt = /* @__PURE__ */ l("ZodObject", (e, n) => {
  ba.init(e, n), z.init(e, n), x(e, "shape", () => n.shape), e.keyof = () => pt(Object.keys(e._zod.def.shape)), e.catchall = (r) => e.clone({ ...e._zod.def, catchall: r }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: me() }), e.loose = () => e.clone({ ...e._zod.def, catchall: me() }), e.strict = () => e.clone({ ...e._zod.def, catchall: or() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (r) => $s(e, r), e.safeExtend = (r) => _s(e, r), e.merge = (r) => ys(e, r), e.pick = (r) => ks(e, r), e.omit = (r) => ws(e, r), e.partial = (...r) => Is(lr, e, r[0]), e.required = (...r) => Ss(dr, e, r[0]);
});
function Ze(e, n) {
  const r = {
    type: "object",
    shape: e ?? {},
    ...f(n)
  };
  return new mt(r);
}
function Zf(e, n) {
  return new mt({
    type: "object",
    shape: e,
    catchall: or(),
    ...f(n)
  });
}
function Lf(e, n) {
  return new mt({
    type: "object",
    shape: e,
    catchall: me(),
    ...f(n)
  });
}
const ur = /* @__PURE__ */ l("ZodUnion", (e, n) => {
  Yt.init(e, n), z.init(e, n), e.options = n.options;
});
function ft(e, n) {
  return new ur({
    type: "union",
    options: e,
    ...f(n)
  });
}
const sc = /* @__PURE__ */ l("ZodDiscriminatedUnion", (e, n) => {
  ur.init(e, n), $a.init(e, n);
});
function Mf(e, n, r) {
  return new sc({
    type: "union",
    options: n,
    discriminator: e,
    ...f(r)
  });
}
const lc = /* @__PURE__ */ l("ZodIntersection", (e, n) => {
  _a.init(e, n), z.init(e, n);
});
function dc(e, n) {
  return new lc({
    type: "intersection",
    left: e,
    right: n
  });
}
const mc = /* @__PURE__ */ l("ZodTuple", (e, n) => {
  Qt.init(e, n), z.init(e, n), e.rest = (r) => e.clone({
    ...e._zod.def,
    rest: r
  });
});
function fc(e, n, r) {
  const o = n instanceof S, t = o ? r : n, i = o ? n : null;
  return new mc({
    type: "tuple",
    items: e,
    rest: i,
    ...f(t)
  });
}
const cr = /* @__PURE__ */ l("ZodRecord", (e, n) => {
  ya.init(e, n), z.init(e, n), e.keyType = n.keyType, e.valueType = n.valueType;
});
function pc(e, n, r) {
  return new cr({
    type: "record",
    keyType: e,
    valueType: n,
    ...f(r)
  });
}
function Bf(e, n, r) {
  const o = Qe(e);
  return o._zod.values = void 0, new cr({
    type: "record",
    keyType: o,
    valueType: n,
    ...f(r)
  });
}
const gc = /* @__PURE__ */ l("ZodMap", (e, n) => {
  ka.init(e, n), z.init(e, n), e.keyType = n.keyType, e.valueType = n.valueType;
});
function Rf(e, n, r) {
  return new gc({
    type: "map",
    keyType: e,
    valueType: n,
    ...f(r)
  });
}
const vc = /* @__PURE__ */ l("ZodSet", (e, n) => {
  wa.init(e, n), z.init(e, n), e.min = (...r) => e.check(Ne(...r)), e.nonempty = (r) => e.check(Ne(1, r)), e.max = (...r) => e.check(nt(...r)), e.size = (...r) => e.check(Sn(...r));
});
function Ff(e, n) {
  return new vc({
    type: "set",
    valueType: e,
    ...f(n)
  });
}
const je = /* @__PURE__ */ l("ZodEnum", (e, n) => {
  Ia.init(e, n), z.init(e, n), e.enum = n.entries, e.options = Object.values(n.entries);
  const r = new Set(Object.keys(n.entries));
  e.extract = (o, t) => {
    const i = {};
    for (const a of o)
      if (r.has(a))
        i[a] = n.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new je({
      ...n,
      checks: [],
      ...f(t),
      entries: i
    });
  }, e.exclude = (o, t) => {
    const i = { ...n.entries };
    for (const a of o)
      if (r.has(a))
        delete i[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new je({
      ...n,
      checks: [],
      ...f(t),
      entries: i
    });
  };
});
function pt(e, n) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new je({
    type: "enum",
    entries: r,
    ...f(n)
  });
}
function Vf(e, n) {
  return new je({
    type: "enum",
    entries: e,
    ...f(n)
  });
}
const hc = /* @__PURE__ */ l("ZodLiteral", (e, n) => {
  Sa.init(e, n), z.init(e, n), e.values = new Set(n.values), Object.defineProperty(e, "value", {
    get() {
      if (n.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return n.values[0];
    }
  });
});
function bc(e, n) {
  return new hc({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...f(n)
  });
}
const $c = /* @__PURE__ */ l("ZodFile", (e, n) => {
  za.init(e, n), z.init(e, n), e.min = (r, o) => e.check(Ne(r, o)), e.max = (r, o) => e.check(nt(r, o)), e.mime = (r, o) => e.check(Tn(Array.isArray(r) ? r : [r], o));
});
function Hf(e) {
  return ju($c, e);
}
const _c = /* @__PURE__ */ l("ZodTransform", (e, n) => {
  xa.init(e, n), z.init(e, n), e._zod.parse = (r, o) => {
    if (o.direction === "backward")
      throw new Ye(e.constructor.name);
    r.addIssue = (i) => {
      if (typeof i == "string")
        r.issues.push(Se(i, r.value, n));
      else {
        const a = i;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = r.value), a.inst ?? (a.inst = e), r.issues.push(Se(a));
      }
    };
    const t = n.transform(r.value, r);
    return t instanceof Promise ? t.then((i) => (r.value = i, r)) : (r.value = t, r);
  };
});
function sr(e) {
  return new _c({
    type: "transform",
    transform: e
  });
}
const lr = /* @__PURE__ */ l("ZodOptional", (e, n) => {
  en.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function Ke(e) {
  return new lr({
    type: "optional",
    innerType: e
  });
}
const yc = /* @__PURE__ */ l("ZodNullable", (e, n) => {
  Na.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function Xe(e) {
  return new yc({
    type: "nullable",
    innerType: e
  });
}
function Wf(e) {
  return Ke(Xe(e));
}
const kc = /* @__PURE__ */ l("ZodDefault", (e, n) => {
  ge.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function wc(e, n) {
  return new kc({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof n == "function" ? n() : Zt(n);
    }
  });
}
const Ic = /* @__PURE__ */ l("ZodPrefault", (e, n) => {
  ja.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function Sc(e, n) {
  return new Ic({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof n == "function" ? n() : Zt(n);
    }
  });
}
const dr = /* @__PURE__ */ l("ZodNonOptional", (e, n) => {
  Oa.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function zc(e, n) {
  return new dr({
    type: "nonoptional",
    innerType: e,
    ...f(n)
  });
}
const xc = /* @__PURE__ */ l("ZodSuccess", (e, n) => {
  Ua.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function Jf(e) {
  return new xc({
    type: "success",
    innerType: e
  });
}
const Nc = /* @__PURE__ */ l("ZodCatch", (e, n) => {
  Ta.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function jc(e, n) {
  return new Nc({
    type: "catch",
    innerType: e,
    catchValue: typeof n == "function" ? n : () => n
  });
}
const Oc = /* @__PURE__ */ l("ZodNaN", (e, n) => {
  Ea.init(e, n), z.init(e, n);
});
function Gf(e) {
  return ku(Oc, e);
}
const mr = /* @__PURE__ */ l("ZodPipe", (e, n) => {
  Pa.init(e, n), z.init(e, n), e.in = n.in, e.out = n.out;
});
function qe(e, n) {
  return new mr({
    type: "pipe",
    in: e,
    out: n
    // ...util.normalizeParams(params),
  });
}
const fr = /* @__PURE__ */ l("ZodCodec", (e, n) => {
  mr.init(e, n), tn.init(e, n);
});
function Kf(e, n, r) {
  return new fr({
    type: "pipe",
    in: e,
    out: n,
    transform: r.decode,
    reverseTransform: r.encode
  });
}
const Uc = /* @__PURE__ */ l("ZodReadonly", (e, n) => {
  Ca.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function Tc(e) {
  return new Uc({
    type: "readonly",
    innerType: e
  });
}
const Ec = /* @__PURE__ */ l("ZodTemplateLiteral", (e, n) => {
  Da.init(e, n), z.init(e, n);
});
function Xf(e, n) {
  return new Ec({
    type: "template_literal",
    parts: e,
    ...f(n)
  });
}
const Pc = /* @__PURE__ */ l("ZodLazy", (e, n) => {
  La.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.getter();
});
function Cc(e) {
  return new Pc({
    type: "lazy",
    getter: e
  });
}
const Dc = /* @__PURE__ */ l("ZodPromise", (e, n) => {
  Za.init(e, n), z.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function qf(e) {
  return new Dc({
    type: "promise",
    innerType: e
  });
}
const Ac = /* @__PURE__ */ l("ZodFunction", (e, n) => {
  Aa.init(e, n), z.init(e, n);
});
function Vr(e) {
  return new Ac({
    type: "function",
    input: Array.isArray(e == null ? void 0 : e.input) ? fc(e == null ? void 0 : e.input) : (e == null ? void 0 : e.input) ?? dt(me()),
    output: (e == null ? void 0 : e.output) ?? me()
  });
}
const gt = /* @__PURE__ */ l("ZodCustom", (e, n) => {
  Ma.init(e, n), z.init(e, n);
});
function Yf(e) {
  const n = new T({
    check: "custom"
    // ...util.normalizeParams(params),
  });
  return n._zod.check = e, n;
}
function Qf(e, n) {
  return Ou(gt, e ?? (() => !0), n);
}
function Zc(e, n = {}) {
  return Uu(gt, e, n);
}
function Lc(e) {
  return Tu(e);
}
function ep(e, n = {
  error: `Input not instance of ${e.name}`
}) {
  const r = new gt({
    type: "custom",
    check: "custom",
    fn: (o) => o instanceof e,
    abort: !0,
    ...f(n)
  });
  return r._zod.bag.Class = e, r;
}
const tp = (...e) => Pu({
  Codec: fr,
  Boolean: st,
  String: ot
}, ...e);
function np(e) {
  const n = Cc(() => ft([X(e), ct(), Ae(), rc(), dt(n), pc(X(), n)]));
  return n;
}
function rp(e, n) {
  return qe(sr(e), n);
}
const ip = {
  invalid_type: "invalid_type",
  too_big: "too_big",
  too_small: "too_small",
  invalid_format: "invalid_format",
  not_multiple_of: "not_multiple_of",
  unrecognized_keys: "unrecognized_keys",
  invalid_union: "invalid_union",
  invalid_key: "invalid_key",
  invalid_element: "invalid_element",
  invalid_value: "invalid_value",
  custom: "custom"
};
function op(e) {
  W({
    customError: e
  });
}
function ap() {
  return W().customError;
}
var Ot;
Ot || (Ot = {});
function up(e) {
  return Ga(ot, e);
}
function cp(e) {
  return tu(ut, e);
}
function sp(e) {
  return cu(st, e);
}
function lp(e) {
  return lu(lt, e);
}
function dp(e) {
  return yu(ar, e);
}
const mp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bigint: lp,
  boolean: sp,
  date: dp,
  number: cp,
  string: up
}, Symbol.toStringTag, { value: "Module" }));
W(Ba());
const fp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $brand: oi,
  $input: Wa,
  $output: Ha,
  NEVER: ai,
  TimePrecision: Ka,
  ZodAny: ic,
  ZodArray: cc,
  ZodBase64: er,
  ZodBase64URL: tr,
  ZodBigInt: lt,
  ZodBigIntFormat: ir,
  ZodBoolean: st,
  ZodCIDRv4: Yn,
  ZodCIDRv6: Qn,
  ZodCUID: Hn,
  ZodCUID2: Wn,
  ZodCatch: Nc,
  ZodCodec: fr,
  ZodCustom: gt,
  ZodCustomStringFormat: De,
  ZodDate: ar,
  ZodDefault: kc,
  ZodDiscriminatedUnion: sc,
  ZodE164: nr,
  ZodEmail: Rn,
  ZodEmoji: Fn,
  ZodEnum: je,
  ZodError: Xm,
  ZodFile: $c,
  get ZodFirstPartyTypeKind() {
    return Ot;
  },
  ZodFunction: Ac,
  ZodGUID: Ge,
  ZodIPv4: Xn,
  ZodIPv6: qn,
  ZodISODate: Zn,
  ZodISODateTime: An,
  ZodISODuration: Mn,
  ZodISOTime: Ln,
  ZodIntersection: lc,
  ZodIssueCode: ip,
  ZodJWT: rr,
  ZodKSUID: Kn,
  ZodLazy: Pc,
  ZodLiteral: hc,
  ZodMap: gc,
  ZodNaN: Oc,
  ZodNanoID: Vn,
  ZodNever: ac,
  ZodNonOptional: dr,
  ZodNull: nc,
  ZodNullable: yc,
  ZodNumber: ut,
  ZodNumberFormat: ve,
  ZodObject: mt,
  ZodOptional: lr,
  ZodPipe: mr,
  ZodPrefault: Ic,
  ZodPromise: Dc,
  ZodReadonly: Uc,
  ZodRealError: R,
  ZodRecord: cr,
  ZodSet: vc,
  ZodString: ot,
  ZodStringFormat: U,
  ZodSuccess: xc,
  ZodSymbol: ec,
  ZodTemplateLiteral: Ec,
  ZodTransform: _c,
  ZodTuple: mc,
  ZodType: z,
  ZodULID: Jn,
  ZodURL: at,
  ZodUUID: K,
  ZodUndefined: tc,
  ZodUnion: ur,
  ZodUnknown: oc,
  ZodVoid: uc,
  ZodXID: Gn,
  _ZodString: Bn,
  _default: wc,
  _function: Vr,
  any: Pf,
  array: dt,
  base64: hf,
  base64url: bf,
  bigint: jf,
  boolean: Ae,
  catch: jc,
  check: Yf,
  cidrv4: gf,
  cidrv6: vf,
  clone: Qe,
  codec: Kf,
  coerce: mp,
  config: W,
  core: Lm,
  cuid: cf,
  cuid2: sf,
  custom: Qf,
  date: Df,
  decode: Ju,
  decodeAsync: Ku,
  discriminatedUnion: Mf,
  e164: $f,
  email: qm,
  emoji: af,
  encode: Wu,
  encodeAsync: Gu,
  endsWith: Un,
  enum: pt,
  file: Hf,
  flattenError: Lt,
  float32: Sf,
  float64: zf,
  formatError: Mt,
  function: Vr,
  getErrorMap: ap,
  globalRegistry: ee,
  gt: oe,
  gte: M,
  guid: Ym,
  hash: If,
  hex: wf,
  hostname: kf,
  httpUrl: of,
  includes: jn,
  instanceof: ep,
  int: jt,
  int32: xf,
  int64: Of,
  intersection: dc,
  ipv4: ff,
  ipv6: pf,
  iso: Km,
  json: np,
  jwt: _f,
  keyof: Af,
  ksuid: mf,
  lazy: Cc,
  length: it,
  literal: bc,
  locales: Va,
  looseObject: Lf,
  lowercase: xn,
  lt: ie,
  lte: H,
  map: Rf,
  maxLength: rt,
  maxSize: nt,
  mime: Tn,
  minLength: de,
  minSize: Ne,
  multipleOf: xe,
  nan: Gf,
  nanoid: uf,
  nativeEnum: Vf,
  negative: Iu,
  never: or,
  nonnegative: zu,
  nonoptional: zc,
  nonpositive: Su,
  normalize: En,
  null: rc,
  nullable: Xe,
  nullish: Wf,
  number: ct,
  object: Ze,
  optional: Ke,
  overwrite: ae,
  parse: Ru,
  parseAsync: Fu,
  partialRecord: Bf,
  pipe: qe,
  positive: wu,
  prefault: Sc,
  preprocess: rp,
  prettifyError: $i,
  promise: qf,
  property: xu,
  readonly: Tc,
  record: pc,
  refine: Zc,
  regex: zn,
  regexes: Ht,
  registry: rn,
  safeDecode: qu,
  safeDecodeAsync: Qu,
  safeEncode: Xu,
  safeEncodeAsync: Yu,
  safeParse: Vu,
  safeParseAsync: Hu,
  set: Ff,
  setErrorMap: op,
  size: Sn,
  startsWith: On,
  strictObject: Zf,
  string: X,
  stringFormat: yf,
  stringbool: tp,
  success: Jf,
  superRefine: Lc,
  symbol: Tf,
  templateLiteral: Xf,
  toJSONSchema: Cu,
  toLowerCase: Cn,
  toUpperCase: Dn,
  transform: sr,
  treeifyError: _i,
  trim: Pn,
  tuple: fc,
  uint32: Nf,
  uint64: Uf,
  ulid: lf,
  undefined: Ef,
  union: ft,
  unknown: me,
  uppercase: Nn,
  url: rf,
  util: yi,
  uuid: Qm,
  uuidv4: ef,
  uuidv6: tf,
  uuidv7: nf,
  void: Cf,
  xid: df
}, Symbol.toStringTag, { value: "Module" })), Y = {
  gray: {
    text: "#9b9a97",
    background: "#ebeced"
  },
  brown: {
    text: "#64473a",
    background: "#e9e5e3"
  },
  red: {
    text: "#e03e3e",
    background: "#fbe4e4"
  },
  orange: {
    text: "#d9730d",
    background: "#f6e9d9"
  },
  yellow: {
    text: "#dfab01",
    background: "#fbf3db"
  },
  green: {
    text: "#4d6461",
    background: "#ddedea"
  },
  blue: {
    text: "#0b6e99",
    background: "#ddebf1"
  },
  purple: {
    text: "#6940a5",
    background: "#eae4f2"
  },
  pink: {
    text: "#ad1a72",
    background: "#f4dfeb"
  }
}, dv = {
  gray: {
    text: "#bebdb8",
    background: "#9b9a97"
  },
  brown: {
    text: "#8e6552",
    background: "#64473a"
  },
  red: {
    text: "#ec4040",
    background: "#be3434"
  },
  orange: {
    text: "#e3790d",
    background: "#b7600a"
  },
  yellow: {
    text: "#dfab01",
    background: "#b58b00"
  },
  green: {
    text: "#6b8b87",
    background: "#4d6461"
  },
  blue: {
    text: "#0e87bc",
    background: "#0b6e99"
  },
  purple: {
    text: "#8552d7",
    background: "#6940a5"
  },
  pink: {
    text: "#da208f",
    background: "#ad1a72"
  }
}, L = Ze({
  backgroundColor: X().default("default"),
  textColor: X().default("default"),
  textAlignment: pt(["left", "center", "right", "justify"]).default("left")
}), pr = V(L), F = L.parse({}), Z = (e) => {
  const n = {};
  return e.hasAttribute("data-background-color") ? n.backgroundColor = e.getAttribute("data-background-color") : e.style.backgroundColor && (n.backgroundColor = e.style.backgroundColor), e.hasAttribute("data-text-color") ? n.textColor = e.getAttribute("data-text-color") : e.style.color && (n.textColor = e.style.color), n.textAlignment = L.shape.textAlignment._zod.values.values().some(
    (r) => r === e.style.textAlign
  ) ? e.style.textAlign : void 0, n;
}, ue = (e, n) => {
  e.backgroundColor && e.backgroundColor !== F.backgroundColor && (n.style.backgroundColor = e.backgroundColor in Y ? Y[e.backgroundColor].background : e.backgroundColor), e.textColor && e.textColor !== F.textColor && (n.style.color = e.textColor in Y ? Y[e.textColor].text : e.textColor), e.textAlignment && e.textAlignment !== F.textAlignment && (n.style.textAlign = e.textAlignment);
}, mv = (e = "backgroundColor") => ({
  default: F.backgroundColor,
  parseHTML: (n) => n.hasAttribute("data-background-color") ? n.getAttribute("data-background-color") : n.style.backgroundColor ? n.style.backgroundColor : F.backgroundColor,
  renderHTML: (n) => n[e] === F.backgroundColor ? {} : {
    "data-background-color": n[e]
  }
}), fv = (e = "textColor") => ({
  default: F.textColor,
  parseHTML: (n) => n.hasAttribute("data-text-color") ? n.getAttribute("data-text-color") : n.style.color ? n.style.color : F.textColor,
  renderHTML: (n) => n[e] === F.textColor ? {} : {
    "data-text-color": n[e]
  }
}), pv = (e = "textAlignment") => ({
  default: F.textAlignment,
  parseHTML: (n) => n.hasAttribute("data-text-alignment") ? n.getAttribute("data-text-alignment") : n.style.textAlign ? n.style.textAlign : F.textAlignment,
  renderHTML: (n) => n[e] === F.textAlignment ? {} : {
    "data-text-alignment": n[e]
  }
}), gv = (e, n, r) => ({
  state: o,
  dispatch: t
}) => t ? Mc(o.tr, e, n, r) : !0, Mc = (e, n, r, o) => {
  const t = zs(e.doc, n), i = St(t);
  if (!i.isBlockContainer)
    return !1;
  const a = Oe(e), u = [
    {
      type: i.bnBlock.node.type,
      // always keep blockcontainer type
      attrs: o ? { ...i.bnBlock.node.attrs, id: void 0 } : {}
    },
    {
      type: r ? i.blockContent.node.type : a.nodes.paragraph,
      attrs: o ? { ...i.blockContent.node.attrs } : {}
    }
  ];
  return e.split(n, 2, u), !0;
};
function pp(e, n) {
  let r, o;
  if (n.firstChild.descendants((t, i) => r ? !1 : !gp(t) || t.attrs.id !== e ? !0 : (r = t, o = i + 1, !1)), !(r === void 0 || o === void 0))
    return {
      node: r,
      posBeforeNode: o
    };
}
function gp(e) {
  return e.type.isInGroup("bnBlock");
}
const vv = (e, n) => ({
  tr: r,
  dispatch: o
}) => (o && gr(r, e, n), !0);
function gr(e, n, r, o, t) {
  const i = xs(e.doc.resolve(n));
  let a = null;
  i.blockNoteType === "table" && (a = hp(e));
  const u = Oe(e), c = Bt(u);
  if (o !== void 0 && t !== void 0 && o > t)
    throw new Error("Invalid replaceFromPos or replaceToPos");
  const s = u.nodes[i.blockNoteType], m = u.nodes[r.type || i.blockNoteType], p = m.isInGroup("bnBlock") ? m : u.nodes.blockContainer;
  if (i.isBlockContainer && m.isInGroup("blockContent")) {
    const b = o !== void 0 && o > i.blockContent.beforePos && o < i.blockContent.afterPos ? o - i.blockContent.beforePos - 1 : void 0, _ = t !== void 0 && t > i.blockContent.beforePos && t < i.blockContent.afterPos ? t - i.blockContent.beforePos - 1 : void 0;
    Hr(r, e, i), vp(
      r,
      e,
      s,
      m,
      i,
      b,
      _
    );
  } else if (!i.isBlockContainer && m.isInGroup("bnBlock"))
    Hr(r, e, i);
  else {
    const b = vt(c, r);
    if (r.children === void 0) {
      const _ = ki(
        i.bnBlock.node,
        u
      );
      b.children = _.children;
    }
    e.replaceWith(
      i.bnBlock.beforePos,
      i.bnBlock.afterPos,
      Ut(b, u)
    );
    return;
  }
  e.setNodeMarkup(i.bnBlock.beforePos, p, {
    ...i.bnBlock.node.attrs,
    ...r.props
  }), a && bp(e, i, a);
}
function vp(e, n, r, o, t, i, a) {
  const u = Oe(n), c = Bt(u);
  let s = "keep";
  if (e.content)
    if (typeof e.content == "string")
      s = wr(
        [e.content],
        u,
        o.name
      );
    else if (Array.isArray(e.content))
      s = wr(
        vr(
          e.content,
          c.inlineContentSchema
        ),
        u,
        o.name
      );
    else if (e.content.type === "tableContent")
      s = Ns(
        Rc(
          e.content,
          c.inlineContentSchema
        ),
        u
      );
    else
      throw new wi(e.content.type);
  else
    r.spec.content === "" || o.spec.content !== r.spec.content && (s = []);
  if (s === "keep")
    n.setNodeMarkup(t.blockContent.beforePos, o, {
      ...t.blockContent.node.attrs,
      ...e.props
    });
  else if (i !== void 0 || a !== void 0) {
    n.setNodeMarkup(t.blockContent.beforePos, o, {
      ...t.blockContent.node.attrs,
      ...e.props
    });
    const m = t.blockContent.beforePos + 1 + (i ?? 0), p = t.blockContent.beforePos + 1 + (a ?? t.blockContent.node.content.size), b = n.doc.resolve(t.blockContent.beforePos).depth, _ = n.doc.resolve(m).depth, g = n.doc.resolve(p).depth;
    n.replace(
      m,
      p,
      new ji(
        et.from(s),
        _ - b - 1,
        g - b - 1
      )
    );
  } else
    n.replaceWith(
      t.blockContent.beforePos,
      t.blockContent.afterPos,
      o.createChecked(
        {
          ...t.blockContent.node.attrs,
          ...e.props
        },
        s
      )
    );
}
function Hr(e, n, r) {
  const o = Oe(n), t = Bt(o);
  if (e.children !== void 0 && e.children.length > 0) {
    const i = e.children.map((a) => Ut(vt(t, a), o));
    if (r.childContainer)
      n.step(
        new Ms(
          r.childContainer.beforePos + 1,
          r.childContainer.afterPos - 1,
          new ji(et.from(i), 0, 0)
        )
      );
    else {
      if (!r.isBlockContainer)
        throw new Error("impossible");
      n.insert(
        r.blockContent.afterPos,
        o.nodes.blockGroup.createChecked({}, i)
      );
    }
  }
}
function hv(e, n, r, o, t) {
  const i = typeof n == "string" ? n : n.id, a = pp(i, e.doc);
  if (!a)
    throw new Error(`Block with ID ${i} not found`);
  gr(
    e,
    a.posBeforeNode,
    r,
    o,
    t
  );
  const u = e.doc.resolve(a.posBeforeNode + 1).node(), c = Oe(e);
  return ki(u, c);
}
function hp(e) {
  const n = "selection" in e ? e.selection : null;
  if (!(n instanceof zi))
    return null;
  const r = e.doc.resolve(n.head);
  let o = -1, t = -1;
  for (let $ = r.depth; $ >= 0; $--) {
    const d = r.node($).type.name;
    if (o < 0 && (d === "tableCell" || d === "tableHeader") && (o = $), d === "table") {
      t = $;
      break;
    }
  }
  if (o < 0 || t < 0)
    return null;
  const i = r.before(o), a = r.before(t), u = e.doc.nodeAt(a);
  if (!u || u.type.name !== "table")
    return null;
  const c = Qr.get(u), s = i - (a + 1), m = c.map.indexOf(s);
  if (m < 0)
    return null;
  const p = Math.floor(m / c.width), b = m % c.width, g = i + 1 + 1, N = Math.max(0, n.head - g);
  return { row: p, col: b, offset: N };
}
function bp(e, n, r) {
  var $;
  if (n.blockNoteType !== "table")
    return !1;
  let o = -1;
  if (n.isBlockContainer)
    o = e.mapping.map(n.blockContent.beforePos);
  else {
    const d = e.mapping.map(n.bnBlock.beforePos), y = d + ((($ = e.doc.nodeAt(d)) == null ? void 0 : $.nodeSize) || 0);
    e.doc.nodesBetween(d, y, (v, k) => v.type.name === "table" ? (o = k, !1) : !0);
  }
  const t = o >= 0 ? e.doc.nodeAt(o) : null;
  if (!t || t.type.name !== "table")
    return !1;
  const i = Qr.get(t), a = Math.max(0, Math.min(r.row, i.height - 1)), u = Math.max(0, Math.min(r.col, i.width - 1)), c = a * i.width + u, s = i.map[c];
  if (s == null)
    return !1;
  const p = o + 1 + s + 1, b = e.doc.nodeAt(p), _ = p + 1, g = b ? b.content.size : 0, N = _ + Math.max(0, Math.min(r.offset, g));
  return "selection" in e && e.setSelection(zi.create(e.doc, N)), !0;
}
const ke = A(({ editor: e }) => {
  const n = xi(void 0);
  function r() {
    n.setState(void 0);
  }
  return {
    key: "filePanel",
    store: n,
    mount({ signal: o }) {
      const t = e.onChange(
        r,
        // Don't trigger if the changes are caused by a remote user.
        !1
      ), i = e.onSelectionChange(
        r,
        // Don't trigger if the changes are caused by a remote user.
        !1
      );
      o.addEventListener("abort", () => {
        t(), i();
      });
    },
    closeMenu: r,
    showMenu(o) {
      n.setState(o);
    }
  };
});
function Bc(e, n) {
  const r = e || {};
  return Object.entries(n._zodSource._zod.def.shape).forEach(
    ([o, t]) => {
      r[o] === void 0 && (t instanceof ge && (r[o] = t._zod.def.defaultValue), t instanceof en && (r[o] = void 0));
    }
  ), r;
}
function He(e) {
  return {
    type: "text",
    styles: {},
    text: e
  };
}
function $p(e) {
  return {
    type: "link",
    href: e.href,
    content: typeof e.content == "string" ? [He(e.content)] : e.content
  };
}
function vr(e, n) {
  return e === void 0 ? [] : typeof e == "string" ? [He(e)] : e.map((r) => {
    if (typeof r == "string")
      return He(r);
    if (js(r))
      return $p(r);
    if (Ii(r))
      return r;
    const o = r.content, t = n[r.type];
    if (typeof t == "string")
      throw new Error(
        "unexpected, should be custom inline content (not 'text' or 'link'"
      );
    return {
      type: r.type,
      props: Bc(
        r.props,
        t.propSchema
      ),
      content: typeof o > "u" ? void 0 : typeof o == "string" ? [He(o)] : o
    };
  });
}
function Rc(e, n) {
  var t;
  const r = e.rows.map((i) => ({
    cells: i.cells.map((a) => {
      const u = Os(a);
      return u.content = vr(
        u.content,
        n
      ), u;
    })
  })), o = e.columnWidths || [];
  if (!e.columnWidths)
    for (const i of r[0].cells)
      for (let a = 0; a < (((t = i.props) == null ? void 0 : t.colspan) || 1); a++)
        o.push(void 0);
  return {
    type: "tableContent",
    headerRows: e.headerRows,
    headerCols: e.headerCols,
    columnWidths: o,
    rows: r
  };
}
function _p(e, n, r) {
  if (n === "table") {
    if (e = e || {
      type: "tableContent",
      rows: []
    }, typeof e != "object" || !("type" in e) || e.type !== "tableContent")
      throw new Error("Invalid partial block content");
    return Rc(
      e,
      r
    );
  } else if (n === "inline") {
    if (e = e || void 0, typeof e == "object" && "type" in e)
      throw new Error("Invalid partial block content. Table content passed!?");
    return vr(
      e,
      r
    );
  } else {
    if (n === "none")
      return;
    throw new wi(n);
  }
}
function vt(e, n) {
  var u;
  const r = n.id || Us.options.generateID(), o = n.type || "paragraph", t = Bc(
    n.props,
    e.blockSchema[o].propSchema
  ), i = _p(
    n.content,
    e.blockSchema[o].content,
    e.inlineContentSchema
  ), a = ((u = n.children) == null ? void 0 : u.map((c) => vt(e, c))) || [];
  return {
    id: r,
    type: o,
    props: t,
    content: i,
    children: a
  };
}
function bv(e, n) {
  return n.map(
    (r) => vt(e, r)
  );
}
function V(e) {
  return {
    _output: void 0,
    _input: void 0,
    _zodSource: e.strict()
    // force strict parsing
  };
}
function yp(e, n) {
  const r = [
    {
      tag: `[data-style-type="${e.type}"]`,
      contentElement: (o) => {
        const t = o;
        return t.matches("[data-editable]") ? t : t.querySelector("[data-editable]") || t;
      }
    }
  ];
  return n && r.push({
    tag: "*",
    // By default, styles can overlap each other, so the rules should not
    // completely consume the element they parse (which can have multiple
    // styles).
    consuming: !1,
    getAttrs(o) {
      if (typeof o == "string")
        return !1;
      const t = n == null ? void 0 : n(o);
      return t === void 0 ? !1 : { stringValue: t };
    }
  }), r;
}
function Fc(e, n) {
  const r = Es.create({
    name: e.type,
    addAttributes() {
      return Jm(e.propSchema);
    },
    parseHTML() {
      return yp(e, n.parse);
    },
    renderHTML({ mark: o }) {
      const t = (n.toExternalHTML || n.render)(o.attrs.stringValue);
      return Fe(
        t,
        e.type,
        o.attrs.stringValue,
        e.propSchema
      );
    },
    addMarkView() {
      return ({ mark: o }) => {
        const t = n.render(o.attrs.stringValue);
        return Fe(
          t,
          e.type,
          o.attrs.stringValue,
          e.propSchema
        );
      };
    }
  });
  return Du(e, {
    ...n,
    mark: r,
    render: (o) => {
      const t = n.render(o);
      return Fe(
        t,
        e.type,
        o,
        e.propSchema
      );
    },
    toExternalHTML: (o) => {
      const t = (n.toExternalHTML || n.render)(o);
      return Fe(
        t,
        e.type,
        o,
        e.propSchema
      );
    }
  });
}
const he = Ze({
  caption: X().default(""),
  // TODO: "" as defaults?
  name: X().default("")
}), be = Ze({
  // URL is optional, as we also want to accept files with no URL, but for example ids
  // (ids can be used for files that are resolved on the backend)
  url: X().default(""),
  // Whether to show the file preview or the name only.
  // This is useful for some file blocks, but not all
  // (e.g.: not relevant for default "file" block which doesn;'t show previews)
  showPreview: Ae().default(!0),
  // File preview width in px.
  previewWidth: ct().optional()
}), ht = (e, n) => {
  const r = e.querySelector(
    n
  );
  if (!r)
    return;
  const o = e.querySelector("figcaption"), t = (o == null ? void 0 : o.textContent) ?? void 0;
  return { targetElement: r, caption: t };
}, kp = (e, n, r) => {
  const o = document.createElement("div");
  o.className = "bn-add-file-button";
  const t = document.createElement("div");
  t.className = "bn-add-file-button-icon", r ? t.appendChild(r) : t.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z"></path></svg>', o.appendChild(t);
  const i = document.createElement("p");
  i.className = "bn-add-file-button-text", i.innerHTML = e.type in n.dictionary.file_blocks.add_button_text ? n.dictionary.file_blocks.add_button_text[e.type] : n.dictionary.file_blocks.add_button_text.file, o.appendChild(i);
  const a = (c) => {
    c.preventDefault(), c.stopPropagation();
  }, u = () => {
    var c;
    n.isEditable && ((c = n.getExtension(ke)) == null || c.showMenu(e.id));
  };
  return o.addEventListener(
    "mousedown",
    a,
    !0
  ), o.addEventListener("click", u, !0), {
    dom: o,
    destroy: () => {
      o.removeEventListener(
        "mousedown",
        a,
        !0
      ), o.removeEventListener(
        "click",
        u,
        !0
      );
    }
  };
}, wp = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z"></path></svg>', Ip = (e) => {
  const n = document.createElement("div");
  n.className = "bn-file-name-with-icon";
  const r = document.createElement("div");
  r.className = "bn-file-icon", r.innerHTML = wp, n.appendChild(r);
  const o = document.createElement("p");
  return o.className = "bn-file-name", o.textContent = e.props.name, n.appendChild(o), {
    dom: n
  };
};
he.extend({
  ...be.pick({ url: !0 }).shape
});
const hr = (e, n, r, o) => {
  const t = document.createElement("div");
  if (t.className = "bn-file-block-content-wrapper", e.props.url === "") {
    const a = kp(e, n, o);
    t.appendChild(a.dom);
    const u = n.onUploadStart((c) => {
      if (c === e.id) {
        t.removeChild(a.dom);
        const s = document.createElement("div");
        s.className = "bn-file-loading-preview", s.textContent = "Loading...", t.appendChild(s);
      }
    });
    return {
      dom: t,
      destroy: () => {
        u(), a.destroy();
      }
    };
  }
  const i = { dom: t };
  if (e.props.showPreview === !1 || !r) {
    const a = Ip(e);
    t.appendChild(a.dom), i.destroy = () => {
      var u;
      (u = a.destroy) == null || u.call(a);
    };
  } else
    t.appendChild(r.dom);
  if (e.props.caption) {
    const a = document.createElement("p");
    a.className = "bn-file-caption", a.textContent = e.props.caption, t.appendChild(a);
  }
  return i;
}, br = (e, n) => {
  const r = document.createElement("figure"), o = document.createElement("figcaption");
  return o.textContent = n, r.appendChild(e), r.appendChild(o), { dom: r };
}, bt = (e, n) => {
  const r = document.createElement("div"), o = document.createElement("p");
  return o.textContent = n, r.appendChild(e), r.appendChild(o), {
    dom: r
  };
}, Wr = (e) => ({ url: e.src || void 0 }), Sp = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z"></path></svg>', zp = L.pick({
  backgroundColor: !0
}).extend({
  ...he.shape,
  ...be.pick({
    url: !0,
    showPreview: !0
  }).shape
}), xp = (e) => ({
  type: "audio",
  propSchema: V(zp),
  content: "none"
}), Np = (e = {}) => (n) => {
  if (n.tagName === "AUDIO") {
    if (n.closest("figure"))
      return;
    const { backgroundColor: r } = Z(n);
    return {
      ...Wr(n),
      backgroundColor: r
    };
  }
  if (n.tagName === "FIGURE") {
    const r = ht(n, "audio");
    if (!r)
      return;
    const { targetElement: o, caption: t } = r, { backgroundColor: i } = Z(n);
    return {
      ...Wr(o),
      backgroundColor: i,
      caption: t
    };
  }
}, jp = (e = {}) => (n, r) => {
  const o = document.createElement("div");
  o.innerHTML = e.icon ?? Sp;
  const t = document.createElement("audio");
  return t.className = "bn-audio", r.resolveFileUrl ? r.resolveFileUrl(n.props.url).then((i) => {
    t.src = i;
  }) : t.src = n.props.url, t.controls = !0, t.contentEditable = "false", t.draggable = !1, hr(
    n,
    r,
    { dom: t },
    o.firstElementChild
  );
}, Op = (e = {}) => (n, r) => {
  if (!n.props.url) {
    const t = document.createElement("p");
    return t.textContent = "Add audio", {
      dom: t
    };
  }
  let o;
  return n.props.showPreview ? (o = document.createElement("audio"), o.src = n.props.url) : (o = document.createElement("a"), o.href = n.props.url, o.textContent = n.props.name || n.props.url), n.props.caption ? n.props.showPreview ? br(o, n.props.caption) : bt(o, n.props.caption) : {
    dom: o
  };
}, Up = B(
  xp,
  (e) => ({
    meta: {
      fileBlockAccept: ["audio/*"]
    },
    parse: Np(e),
    render: jp(e),
    toExternalHTML: Op(e),
    runsBefore: ["file"]
  })
), Jr = Symbol.for("blocknote.shikiParser"), yt = Symbol.for(
  "blocknote.shikiHighlighterPromise"
);
function Tp(e) {
  const n = globalThis;
  let r, o, t = !1;
  return Xs({
    parser: (a) => {
      if (!e.createHighlighter)
        return process.env.NODE_ENV === "development" && !t && (console.log(
          "For syntax highlighting of code blocks, you must provide a `createCodeBlockSpec({ createHighlighter: () => ... })` function"
        ), t = !0), [];
      if (!r)
        return n[yt] = n[yt] || e.createHighlighter(), n[yt].then(
          (c) => {
            r = c;
          }
        );
      const u = Vc(e, a.language);
      return !u || u === "text" || u === "none" || u === "plaintext" || u === "txt" ? [] : r.getLoadedLanguages().includes(u) ? (o || (o = n[Jr] || qs(r), n[Jr] = o), o(a)) : r.loadLanguage(u);
    },
    languageExtractor: (a) => a.attrs.language,
    nodeTypes: ["codeBlock"]
  });
}
const Ep = ({ defaultLanguage: e = "text" }) => ({
  type: "codeBlock",
  propSchema: V(
    Ze({
      language: X().default(e)
    })
  ),
  content: "inline"
}), Pp = B(
  Ep,
  (e) => ({
    meta: {
      code: !0,
      defining: !0,
      isolating: !1
    },
    parse: (n) => {
      var t, i;
      if (n.tagName !== "PRE" || n.childElementCount !== 1 || ((t = n.firstElementChild) == null ? void 0 : t.tagName) !== "CODE")
        return;
      const r = n.firstElementChild;
      return { language: r.getAttribute("data-language") || ((i = r.className.split(" ").find((a) => a.includes("language-"))) == null ? void 0 : i.replace("language-", "")) };
    },
    parseContent: ({ el: n, schema: r }) => {
      const o = Ni.fromSchema(r), t = n.firstElementChild;
      return o.parse(t, {
        preserveWhitespace: "full",
        topNode: r.nodes.codeBlock.create()
      }).content;
    },
    render(n, r) {
      const o = document.createDocumentFragment(), t = document.createElement("pre"), i = document.createElement("code");
      t.appendChild(i);
      let a;
      if (e.supportedLanguages) {
        const u = document.createElement("select");
        Object.entries(e.supportedLanguages ?? {}).forEach(
          ([m, { name: p }]) => {
            const b = document.createElement("option");
            b.value = m, b.text = p, u.appendChild(b);
          }
        ), u.value = n.props.language || e.defaultLanguage || "text";
        const c = (m) => {
          const p = m.target.value;
          r.updateBlock(n.id, { props: { language: p } });
        };
        u.addEventListener("change", c), a = () => u.removeEventListener("change", c);
        const s = document.createElement("div");
        s.contentEditable = "false", s.appendChild(u), o.appendChild(s);
      }
      return o.appendChild(t), {
        dom: o,
        contentDOM: i,
        destroy: () => {
          a == null || a();
        }
      };
    },
    toExternalHTML(n) {
      const r = document.createElement("pre"), o = document.createElement("code");
      return o.className = `language-${n.props.language}`, o.dataset.language = n.props.language, r.appendChild(o), {
        dom: r,
        contentDOM: o
      };
    },
    runsBefore: []
  }),
  (e) => [
    A({
      key: "code-block-highlighter",
      prosemirrorPlugins: [Tp(e)]
    }),
    A({
      key: "code-block-keyboard-shortcuts",
      keyboardShortcuts: {
        Delete: ({ editor: n }) => n.transact((r) => {
          const { block: o } = n.getTextCursorPosition();
          if (o.type !== "codeBlock")
            return !1;
          const { $from: t } = r.selection;
          return t.parent.textContent ? !1 : (n.removeBlocks([o]), !0);
        }),
        Tab: ({ editor: n }) => e.indentLineWithTab === !1 ? !1 : n.transact((r) => {
          const { block: o } = n.getTextCursorPosition();
          return o.type === "codeBlock" ? (r.insertText("  "), !0) : !1;
        }),
        Enter: ({ editor: n }) => n.transact((r) => {
          const { block: o, nextBlock: t } = n.getTextCursorPosition();
          if (o.type !== "codeBlock")
            return !1;
          const { $from: i } = r.selection, a = i.parentOffset === i.parent.nodeSize - 2, u = i.parent.textContent.endsWith(`

`);
          if (a && u) {
            if (r.delete(i.pos - 2, i.pos), t)
              return n.setTextCursorPosition(t, "start"), !0;
            const [c] = n.insertBlocks(
              [{ type: "paragraph" }],
              o,
              "after"
            );
            return n.setTextCursorPosition(c, "start"), !0;
          }
          return r.insertText(`
`), !0;
        }),
        "Shift-Enter": ({ editor: n }) => n.transact(() => {
          const { block: r } = n.getTextCursorPosition();
          if (r.type !== "codeBlock")
            return !1;
          const [o] = n.insertBlocks(
            // insert a new paragraph
            [{ type: "paragraph" }],
            r,
            "after"
          );
          return n.setTextCursorPosition(o, "start"), !0;
        })
      },
      inputRules: [
        {
          find: /^```(.*?)\s$/,
          replace: ({ match: n }) => {
            const r = n[1].trim();
            return {
              type: "codeBlock",
              props: {
                language: {
                  language: Vc(e, r) ?? r
                }.language
              },
              content: []
            };
          }
        }
      ]
    })
  ]
);
function Vc(e, n) {
  var r;
  return (r = Object.entries(e.supportedLanguages ?? {}).find(
    ([o, { aliases: t }]) => (t == null ? void 0 : t.includes(n)) || o === n
  )) == null ? void 0 : r[0];
}
const Cp = () => ({
  type: "divider",
  propSchema: V(fp.object({})),
  content: "none"
}), Dp = B(
  Cp,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      if (e.tagName === "HR")
        return {};
    },
    render() {
      return {
        dom: document.createElement("hr")
      };
    },
    runsBefore: []
  },
  [
    A({
      key: "divider-block-shortcuts",
      inputRules: [
        {
          find: new RegExp("^---$"),
          replace() {
            return { type: "divider", props: {}, content: [] };
          }
        }
      ]
    })
  ]
), Gr = (e) => ({ url: e.src || void 0 }), Ap = L.pick({
  backgroundColor: !0
}).extend({
  ...he.shape,
  ...be.pick({
    url: !0
  }).shape
}), Zp = () => ({
  type: "file",
  propSchema: V(Ap),
  content: "none"
}), Lp = () => (e) => {
  if (e.tagName === "EMBED") {
    if (e.closest("figure"))
      return;
    const { backgroundColor: n } = Z(e);
    return {
      ...Gr(e),
      backgroundColor: n
    };
  }
  if (e.tagName === "FIGURE") {
    const n = ht(e, "embed");
    if (!n)
      return;
    const { targetElement: r, caption: o } = n, { backgroundColor: t } = Z(e);
    return {
      ...Gr(r),
      backgroundColor: t,
      caption: o
    };
  }
}, Mp = B(Zp, {
  meta: {
    fileBlockAccept: ["*/*"]
  },
  parse: Lp(),
  render(e, n) {
    return hr(e, n);
  },
  toExternalHTML(e) {
    if (!e.props.url) {
      const r = document.createElement("p");
      return r.textContent = "Add file", {
        dom: r
      };
    }
    const n = document.createElement("a");
    return n.href = e.props.url, n.textContent = e.props.name || e.props.url, e.props.caption ? bt(n, e.props.caption) : {
      dom: n
    };
  },
  runsBefore: []
}), Bp = {
  set: (e, n) => window.localStorage.setItem(
    `toggle-${e.id}`,
    n ? "true" : "false"
  ),
  get: (e) => window.localStorage.getItem(`toggle-${e.id}`) === "true"
}, Hc = (e, n, r, o = Bp) => {
  if ("isToggleable" in e.props && !e.props.isToggleable)
    return {
      dom: r
    };
  const t = document.createElement("div"), i = document.createElement("div");
  i.className = "bn-toggle-wrapper";
  const a = document.createElement("button");
  a.className = "bn-toggle-button", a.type = "button", a.innerHTML = // https://fonts.google.com/icons?selected=Material+Symbols+Rounded:chevron_right:FILL@0;wght@700;GRAD@0;opsz@24&icon.query=chevron&icon.style=Rounded&icon.size=24&icon.color=%23e8eaed
  '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="CURRENTCOLOR"><path d="M320-200v-560l440 280-440 280Z"/></svg>';
  const u = (g) => g.preventDefault();
  a.addEventListener("mousedown", u);
  const c = () => {
    var g;
    i.getAttribute("data-show-children") === "true" ? (i.setAttribute("data-show-children", "false"), o.set(n.getBlock(e), !1), t.contains(s) && t.removeChild(s)) : (i.setAttribute("data-show-children", "true"), o.set(n.getBlock(e), !0), n.isEditable && ((g = n.getBlock(e)) == null ? void 0 : g.children.length) === 0 && !t.contains(s) && t.appendChild(s));
  };
  a.addEventListener("click", c), i.appendChild(a), i.appendChild(r);
  const s = document.createElement("button");
  s.className = "bn-toggle-add-block-button", s.type = "button", s.textContent = n.dictionary.toggle_blocks.add_block_button;
  const m = (g) => g.preventDefault();
  s.addEventListener(
    "mousedown",
    m
  );
  const p = () => {
    n.transact(() => {
      const g = n.updateBlock(e, {
        // Single empty block with default type.
        children: [{}]
      });
      n.setTextCursorPosition(g.children[0].id, "end"), n.focus();
    });
  };
  s.addEventListener("click", p), t.appendChild(i);
  let b = e.children.length;
  const _ = n.onChange(() => {
    var N;
    const g = ((N = n.getBlock(e)) == null ? void 0 : N.children.length) ?? 0;
    g > b ? (i.getAttribute("data-show-children") === "false" && (i.setAttribute("data-show-children", "true"), o.set(n.getBlock(e), !0)), t.contains(s) && t.removeChild(s)) : g === 0 && g < b && (i.getAttribute("data-show-children") === "true" && (i.setAttribute("data-show-children", "false"), o.set(n.getBlock(e), !1)), t.contains(s) && t.removeChild(s)), b = g;
  });
  return o.get(e) ? (i.setAttribute("data-show-children", "true"), n.isEditable && e.children.length === 0 && t.appendChild(s)) : i.setAttribute("data-show-children", "false"), {
    dom: t,
    // Prevents re-renders when the toggle button is clicked.
    ignoreMutation: (g) => g instanceof MutationRecord && // We want to prevent re-renders when the view changes, so we ignore
    // all mutations where the `data-show-children` attribute is changed
    // or the "add block" button is added/removed.
    (g.type === "attributes" && g.target === i && g.attributeName === "data-show-children" || g.type === "childList" && (g.addedNodes[0] === s || g.removedNodes[0] === s)),
    destroy: () => {
      a.removeEventListener("mousedown", u), a.removeEventListener("click", c), s.removeEventListener(
        "mousedown",
        m
      ), s.removeEventListener(
        "click",
        p
      ), _ == null || _();
    }
  };
}, Wc = [1, 2, 3, 4, 5, 6], Rp = (e) => ({ editor: n }) => {
  const r = n.getTextCursorPosition();
  return n.schema.blockSchema[r.block.type].content !== "inline" ? !1 : (n.updateBlock(r.block, {
    type: "heading",
    props: { level: e }
  }), !0);
}, Fp = ({
  defaultLevel: e = 1,
  levels: n = Wc,
  allowToggleHeadings: r = !0
} = {}) => ({
  type: "heading",
  propSchema: V(
    L.extend({
      level: ft(n.map((o) => bc(o))).default(e),
      ...r ? { isToggleable: Ae().default(!1) } : {}
    })
  ),
  content: "inline"
}), Vp = B(
  Fp,
  ({ allowToggleHeadings: e = !0 } = {}) => ({
    meta: {
      isolating: !1
    },
    parse(n) {
      let r;
      switch (n.tagName) {
        case "H1":
          r = 1;
          break;
        case "H2":
          r = 2;
          break;
        case "H3":
          r = 3;
          break;
        case "H4":
          r = 4;
          break;
        case "H5":
          r = 5;
          break;
        case "H6":
          r = 6;
          break;
        default:
          return;
      }
      return {
        ...Z(n),
        level: r
      };
    },
    render(n, r) {
      const o = document.createElement(`h${n.props.level}`);
      return e ? { ...Hc(n, r, o), contentDOM: o } : {
        dom: o,
        contentDOM: o
      };
    },
    toExternalHTML(n) {
      const r = document.createElement(`h${n.props.level}`);
      return ue(n.props, r), {
        dom: r,
        contentDOM: r
      };
    },
    runsBefore: []
  }),
  ({ levels: e = Wc } = {}) => [
    A({
      key: "heading-shortcuts",
      keyboardShortcuts: Object.fromEntries(
        e.map((n) => [
          `Mod-Alt-${n}`,
          Rp(n)
        ]) ?? []
      ),
      inputRules: e.map((n) => ({
        find: new RegExp(`^(#{${n}})\\s$`),
        replace({ match: r }) {
          return {
            type: "heading",
            props: {
              level: r[1].length
            }
          };
        }
      }))
    })
  ]
);
he.extend({
  ...be.pick({
    url: !0,
    previewWidth: !0,
    showPreview: !0
  }).shape
});
const Jc = (e, n, r, o, t) => {
  const { dom: i, destroy: a } = hr(
    e,
    n,
    r,
    t
  ), u = i;
  u.style.position = "relative", e.props.url && e.props.showPreview && (e.props.previewWidth ? u.style.width = `${e.props.previewWidth}px` : u.style.width = "fit-content");
  const c = document.createElement("div");
  c.className = "bn-resize-handle", c.style.left = "4px";
  const s = document.createElement("div");
  s.className = "bn-resize-handle", s.style.right = "4px";
  const m = document.createElement("div");
  m.style.position = "absolute", m.style.height = "100%", m.style.width = "100%";
  let p, b = e.props.previewWidth;
  const _ = (v) => {
    var E, J;
    if (!p) {
      !n.isEditable && o.contains(c) && o.contains(s) && (o.removeChild(c), o.removeChild(s));
      return;
    }
    let k;
    const w = "touches" in v ? v.touches[0].clientX : v.clientX;
    e.props.textAlignment === "center" ? p.handleUsed === "left" ? k = p.initialWidth + (p.initialClientX - w) * 2 : k = p.initialWidth + (w - p.initialClientX) * 2 : p.handleUsed === "left" ? k = p.initialWidth + p.initialClientX - w : k = p.initialWidth + w - p.initialClientX, b = Math.min(
      Math.max(k, 64),
      ((J = (E = n.domElement) == null ? void 0 : E.firstElementChild) == null ? void 0 : J.clientWidth) || Number.MAX_VALUE
    ), u.style.width = `${b}px`;
  }, g = (v) => {
    (!v.target || !u.contains(v.target) || !n.isEditable) && o.contains(c) && o.contains(s) && (o.removeChild(c), o.removeChild(s)), p && (p = void 0, u.contains(m) && u.removeChild(m), n.updateBlock(e, {
      props: {
        previewWidth: b
      }
    }));
  }, N = () => {
    n.isEditable && (o.appendChild(c), o.appendChild(s));
  }, $ = (v) => {
    v.relatedTarget === c || v.relatedTarget === s || p || n.isEditable && o.contains(c) && o.contains(s) && (o.removeChild(c), o.removeChild(s));
  }, d = (v) => {
    v.preventDefault(), u.contains(m) || u.appendChild(m);
    const k = "touches" in v ? v.touches[0].clientX : v.clientX;
    p = {
      handleUsed: "left",
      initialWidth: u.clientWidth,
      initialClientX: k
    };
  }, y = (v) => {
    v.preventDefault(), u.contains(m) || u.appendChild(m);
    const k = "touches" in v ? v.touches[0].clientX : v.clientX;
    p = {
      handleUsed: "right",
      initialWidth: u.clientWidth,
      initialClientX: k
    };
  };
  return window.addEventListener("mousemove", _), window.addEventListener("touchmove", _), window.addEventListener("mouseup", g), window.addEventListener("touchend", g), u.addEventListener("mouseenter", N), u.addEventListener("mouseleave", $), c.addEventListener(
    "mousedown",
    d
  ), c.addEventListener(
    "touchstart",
    d
  ), s.addEventListener(
    "mousedown",
    y
  ), s.addEventListener(
    "touchstart",
    y
  ), {
    dom: u,
    destroy: () => {
      a == null || a(), window.removeEventListener("mousemove", _), window.removeEventListener("touchmove", _), window.removeEventListener("mouseup", g), window.removeEventListener("touchend", g), u.removeEventListener("mouseenter", N), u.removeEventListener("mouseleave", $), c.removeEventListener(
        "mousedown",
        d
      ), c.removeEventListener(
        "touchstart",
        d
      ), s.removeEventListener(
        "mousedown",
        y
      ), s.removeEventListener(
        "touchstart",
        y
      );
    }
  };
}, Kr = (e) => {
  const n = e.src || void 0, r = e.width || void 0, o = e.alt || void 0;
  return { url: n, previewWidth: r, name: o };
}, Hp = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z"></path></svg>', Wp = L.pick({
  textAlignment: !0,
  backgroundColor: !0
}).extend({
  ...he.shape,
  ...be.pick({
    url: !0,
    showPreview: !0,
    previewWidth: !0
  }).shape
}), Jp = (e = {}) => ({
  type: "image",
  propSchema: V(Wp),
  content: "none"
}), Gp = (e = {}) => (n) => {
  if (n.tagName === "IMG") {
    if (n.closest("figure"))
      return;
    const { backgroundColor: r } = Z(n);
    return {
      ...Kr(n),
      backgroundColor: r
    };
  }
  if (n.tagName === "FIGURE") {
    const r = ht(n, "img");
    if (!r)
      return;
    const { targetElement: o, caption: t } = r, { backgroundColor: i } = Z(n);
    return {
      ...Kr(o),
      backgroundColor: i,
      caption: t
    };
  }
}, Kp = (e = {}) => (n, r) => {
  const o = document.createElement("div");
  o.innerHTML = e.icon ?? Hp;
  const t = document.createElement("div");
  t.className = "bn-visual-media-wrapper";
  const i = document.createElement("img");
  return i.className = "bn-visual-media", r.resolveFileUrl ? r.resolveFileUrl(n.props.url).then((a) => {
    i.src = a;
  }) : i.src = n.props.url, i.alt = n.props.name || n.props.caption || "BlockNote image", i.contentEditable = "false", i.draggable = !1, t.appendChild(i), Jc(
    n,
    r,
    { dom: t },
    t,
    o.firstElementChild
  );
}, Xp = (e = {}) => (n, r) => {
  if (!n.props.url) {
    const t = document.createElement("p");
    return t.textContent = "Add image", {
      dom: t
    };
  }
  let o;
  return n.props.showPreview ? (o = document.createElement("img"), o.src = n.props.url, o.alt = n.props.name || n.props.caption || "BlockNote image", n.props.previewWidth && (o.width = n.props.previewWidth)) : (o = document.createElement("a"), o.href = n.props.url, o.textContent = n.props.name || n.props.url), n.props.caption ? n.props.showPreview ? br(o, n.props.caption) : bt(o, n.props.caption) : {
    dom: o
  };
}, qp = B(
  Jp,
  (e) => ({
    meta: {
      fileBlockAccept: ["image/*"]
    },
    parse: Gp(e),
    render: Kp(e),
    toExternalHTML: Xp(e),
    runsBefore: ["file"]
  })
), $t = (e, n) => {
  const { blockInfo: r, selectionEmpty: o } = e.transact((a) => ({
    blockInfo: Ts(a),
    selectionEmpty: a.selection.anchor === a.selection.head
  }));
  if (!r.isBlockContainer)
    return !1;
  const { bnBlock: t, blockContent: i } = r;
  return i.node.type.name !== n || !o ? !1 : i.node.childCount === 0 ? (e.transact((a) => {
    gr(a, t.beforePos, {
      type: "paragraph",
      props: {}
    });
  }), !0) : i.node.childCount > 0 ? e.transact((a) => (a.deleteSelection(), Mc(a, a.selection.from, !0))) : !1;
};
function $r(e, n, r) {
  var p, b, _;
  const o = Oi.fromSchema(n), t = e, i = document.createElement("div");
  i.setAttribute("data-node-type", "blockGroup");
  for (const g of Array.from(t.childNodes))
    i.appendChild(g.cloneNode(!0));
  let a = o.parse(i, {
    topNode: n.nodes.blockGroup.create()
  });
  ((b = (p = a.firstChild) == null ? void 0 : p.firstChild) == null ? void 0 : b.type.name) === "checkListItem" && (a = a.copy(
    a.content.cut(
      a.firstChild.firstChild.nodeSize + 2
    )
  ));
  const u = (_ = a.firstChild) == null ? void 0 : _.firstChild;
  if (!(u != null && u.isTextblock))
    return et.from(a);
  const c = n.nodes[r].create(
    {},
    u.content
  ), s = a.content.cut(
    // +2 for the `blockGroup` node's start and end markers
    u.nodeSize + 2
  );
  if (s.size > 0) {
    const g = a.copy(s);
    return c.content.addToEnd(g);
  }
  return c.content;
}
const Yp = () => ({
  type: "bulletListItem",
  propSchema: pr,
  content: "inline"
}), Qp = B(
  Yp,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      var r;
      if (e.tagName !== "LI")
        return;
      const n = e.parentElement;
      if (n !== null && (n.tagName === "UL" || n.tagName === "DIV" && ((r = n.parentElement) == null ? void 0 : r.tagName) === "UL"))
        return Z(e);
    },
    // As `li` elements can contain multiple paragraphs, we need to merge their contents
    // into a single one so that ProseMirror can parse everything correctly.
    parseContent: ({ el: e, schema: n }) => $r(e, n, "bulletListItem"),
    render() {
      const e = document.createElement("p");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML(e) {
      const n = document.createElement("li"), r = document.createElement("p");
      return ue(e.props, n), n.appendChild(r), {
        dom: n,
        contentDOM: r
      };
    },
    runsBefore: []
  },
  [
    A({
      key: "bullet-list-item-shortcuts",
      keyboardShortcuts: {
        Enter: ({ editor: e }) => $t(e, "bulletListItem"),
        "Mod-Shift-8": ({ editor: e }) => {
          const n = e.getTextCursorPosition();
          return e.schema.blockSchema[n.block.type].content !== "inline" ? !1 : (e.updateBlock(n.block, {
            type: "bulletListItem",
            props: {}
          }), !0);
        }
      },
      inputRules: [
        {
          find: new RegExp("^[-+*]\\s$"),
          replace({ editor: e }) {
            if (Si(
              e.prosemirrorState
            ).blockNoteType !== "heading")
              return {
                type: "bulletListItem",
                props: {}
              };
          }
        }
      ]
    })
  ]
), eg = () => ({
  type: "checkListItem",
  propSchema: V(
    L.extend({
      checked: Ae().default(!1)
    })
  ),
  content: "inline"
}), tg = B(
  eg,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      var r;
      if (e.tagName === "input")
        return e.closest("[data-content-type]") || e.closest("li") ? void 0 : e.type === "checkbox" ? { checked: e.checked } : void 0;
      if (e.tagName !== "LI")
        return;
      const n = e.parentElement;
      if (n !== null && (n.tagName === "UL" || n.tagName === "DIV" && ((r = n.parentElement) == null ? void 0 : r.tagName) === "UL")) {
        const o = e.querySelector("input[type=checkbox]") || null;
        return o === null ? void 0 : { ...Z(e), checked: o.checked };
      }
    },
    // As `li` elements can contain multiple paragraphs, we need to merge their contents
    // into a single one so that ProseMirror can parse everything correctly.
    parseContent: ({ el: e, schema: n }) => $r(e, n, "checkListItem"),
    render(e, n) {
      const r = document.createDocumentFragment(), o = document.createElement("input");
      o.type = "checkbox", o.checked = e.props.checked, e.props.checked && o.setAttribute("checked", ""), o.addEventListener("change", () => {
        n.updateBlock(e, { props: { checked: !e.props.checked } });
      });
      const t = document.createElement("p");
      return r.appendChild(o), r.appendChild(t), {
        dom: r,
        contentDOM: t
      };
    },
    toExternalHTML(e) {
      const n = document.createElement("li"), r = document.createElement("input");
      r.type = "checkbox", r.checked = e.props.checked, e.props.checked && r.setAttribute("checked", "");
      const o = document.createElement("p");
      return ue(e.props, n), n.appendChild(r), n.appendChild(o), {
        dom: n,
        contentDOM: o
      };
    },
    runsBefore: ["bulletListItem"]
  },
  [
    A({
      key: "check-list-item-shortcuts",
      keyboardShortcuts: {
        Enter: ({ editor: e }) => $t(e, "checkListItem"),
        "Mod-Shift-9": ({ editor: e }) => {
          const n = e.getTextCursorPosition();
          return e.schema.blockSchema[n.block.type].content !== "inline" ? !1 : (e.updateBlock(n.block, {
            type: "checkListItem",
            props: {}
          }), !0);
        }
      },
      inputRules: [
        {
          find: new RegExp("\\[\\s*\\]\\s$"),
          replace() {
            return {
              type: "checkListItem",
              props: {
                checked: !1
              },
              content: []
            };
          }
        },
        {
          find: new RegExp("\\[[Xx]\\]\\s$"),
          replace() {
            return {
              type: "checkListItem",
              props: {
                checked: !0
              }
            };
          }
        }
      ]
    })
  ]
);
function Gc(e, n, r, o) {
  let t = e.firstChild.attrs.start || 1, i = !0;
  const a = !!e.firstChild.attrs.start, u = St({
    posBeforeNode: n,
    node: e
  });
  if (!u.isBlockContainer)
    throw new Error("impossible");
  const c = r.doc.resolve(u.bnBlock.beforePos).nodeBefore, s = c ? o.get(c) : void 0;
  return s !== void 0 ? (t = s + 1, i = !1) : c && St({
    posBeforeNode: u.bnBlock.beforePos - c.nodeSize,
    node: c
  }).blockNoteType === "numberedListItem" && (t = Gc(
    c,
    u.bnBlock.beforePos - c.nodeSize,
    r,
    o
  ).index + 1, i = !1), o.set(e, t), { index: t, isFirst: i, hasStart: a };
}
function Xr(e, n) {
  const r = /* @__PURE__ */ new Map(), o = n.decorations.map(
    e.mapping,
    e.doc
  ), t = [];
  e.doc.nodesBetween(0, e.doc.nodeSize - 2, (a, u) => {
    if (a.type.name === "blockContainer" && a.firstChild.type.name === "numberedListItem") {
      const { index: c, isFirst: s, hasStart: m } = Gc(
        a,
        u,
        e,
        r
      );
      if (o.find(
        u,
        u + a.nodeSize,
        (b) => b.index === c && b.isFirst === s && b.hasStart === m
      ).length === 0) {
        const b = e.doc.nodeAt(u + 1);
        t.push(
          // move in by 1 to account for the block container
          el.node(u + 1, u + 1 + b.nodeSize, {
            "data-index": c.toString()
          })
        );
      }
    }
  });
  const i = t.flatMap(
    (a) => o.find(a.from, a.to)
  );
  return {
    decorations: o.remove(i).add(e.doc, t)
  };
}
const ng = () => new Ys({
  key: new Qs("numbered-list-indexing-decorations"),
  state: {
    init(e, n) {
      return Xr(n.tr, {
        decorations: Nr.empty
      });
    },
    apply(e, n) {
      return !e.docChanged && !e.selectionSet && n.decorations ? n : Xr(e, n);
    }
  },
  props: {
    decorations(e) {
      var n;
      return ((n = this.getState(e)) == null ? void 0 : n.decorations) ?? Nr.empty;
    }
  }
}), rg = () => ({
  type: "numberedListItem",
  propSchema: V(
    L.extend({
      start: ct().optional()
    })
  ),
  content: "inline"
}), ig = B(
  rg,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      var r;
      if (e.tagName !== "LI")
        return;
      const n = e.parentElement;
      if (n !== null && (n.tagName === "OL" || n.tagName === "DIV" && ((r = n.parentElement) == null ? void 0 : r.tagName) === "OL")) {
        const o = parseInt(n.getAttribute("start") || "1"), t = Z(e);
        return e.previousElementSibling || o === 1 ? t : {
          ...t,
          start: o
        };
      }
    },
    // As `li` elements can contain multiple paragraphs, we need to merge their contents
    // into a single one so that ProseMirror can parse everything correctly.
    parseContent: ({ el: e, schema: n }) => $r(e, n, "numberedListItem"),
    render() {
      const e = document.createElement("p");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML(e) {
      const n = document.createElement("li"), r = document.createElement("p");
      return ue(e.props, n), n.appendChild(r), {
        dom: n,
        contentDOM: r
      };
    },
    runsBefore: []
  },
  [
    A({
      key: "numbered-list-item-shortcuts",
      inputRules: [
        {
          find: new RegExp("^(\\d+)\\.\\s$"),
          replace({ match: e, editor: n }) {
            if (Si(
              n.prosemirrorState
            ).blockNoteType === "heading")
              return;
            const o = parseInt(e[1]);
            return {
              type: "numberedListItem",
              props: {
                start: o !== 1 ? o : void 0
              }
            };
          }
        }
      ],
      keyboardShortcuts: {
        Enter: ({ editor: e }) => $t(e, "numberedListItem"),
        "Mod-Shift-7": ({ editor: e }) => {
          const n = e.getTextCursorPosition();
          return e.schema.blockSchema[n.block.type].content !== "inline" ? !1 : (e.updateBlock(n.block, {
            type: "numberedListItem",
            props: {}
          }), !0);
        }
      },
      prosemirrorPlugins: [ng()]
    })
  ]
), og = () => ({
  type: "toggleListItem",
  propSchema: pr,
  content: "inline"
}), ag = B(
  og,
  {
    meta: {
      isolating: !1
    },
    render(e, n) {
      const r = document.createElement("p");
      return { ...Hc(
        e,
        n,
        r
      ), contentDOM: r };
    },
    toExternalHTML(e) {
      const n = document.createElement("li"), r = document.createElement("p");
      return ue(e.props, n), n.appendChild(r), {
        dom: n,
        contentDOM: r
      };
    },
    runsBefore: []
  },
  [
    A({
      key: "toggle-list-item-shortcuts",
      keyboardShortcuts: {
        Enter: ({ editor: e }) => $t(e, "toggleListItem"),
        "Mod-Shift-6": ({ editor: e }) => {
          const n = e.getTextCursorPosition();
          return e.schema.blockSchema[n.block.type].content !== "inline" ? !1 : (e.updateBlock(n.block, {
            type: "toggleListItem",
            props: {}
          }), !0);
        }
      }
    })
  ]
), ug = () => ({
  type: "paragraph",
  propSchema: pr,
  content: "inline"
}), cg = B(
  ug(),
  {
    meta: {
      isolating: !1
    },
    parse: (e) => {
      var n;
      if (e.tagName === "P" && (n = e.textContent) != null && n.trim())
        return Z(e);
    },
    render: () => {
      const e = document.createElement("p");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML: (e) => {
      const n = document.createElement("p");
      return ue(e.props, n), {
        dom: n,
        contentDOM: n
      };
    },
    runsBefore: ["default"]
  },
  [
    A({
      key: "paragraph-shortcuts",
      keyboardShortcuts: {
        "Mod-Alt-0": ({ editor: e }) => {
          const n = e.getTextCursorPosition();
          return e.schema.blockSchema[n.block.type].content !== "inline" ? !1 : (e.updateBlock(n.block, {
            type: "paragraph",
            props: {}
          }), !0);
        }
      }
    })
  ]
), sg = () => ({
  type: "quote",
  propSchema: V(
    L.pick({
      backgroundColor: !0,
      textColor: !0
    })
  ),
  content: "inline"
}), lg = B(
  sg,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      if (e.tagName === "BLOCKQUOTE") {
        const { backgroundColor: n, textColor: r } = Z(e);
        return { backgroundColor: n, textColor: r };
      }
    },
    render() {
      const e = document.createElement("blockquote");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML(e) {
      const n = document.createElement("blockquote");
      return ue(e.props, n), {
        dom: n,
        contentDOM: n
      };
    },
    runsBefore: []
  },
  [
    A({
      key: "quote-block-shortcuts",
      keyboardShortcuts: {
        "Mod-Alt-q": ({ editor: e }) => {
          const n = e.getTextCursorPosition();
          return e.schema.blockSchema[n.block.type].content !== "inline" ? !1 : (e.updateBlock(n.block, {
            type: "quote",
            props: {}
          }), !0);
        }
      },
      inputRules: [
        {
          find: new RegExp("^>\\s$"),
          replace() {
            return {
              type: "quote",
              props: {}
            };
          }
        }
      ]
    })
  ]
), dg = 35, Kc = 120, $v = 31, mg = Ps.create({
  name: "BlockNoteTableExtension",
  addProseMirrorPlugins: () => [
    Qc({
      cellMinWidth: dg,
      defaultCellMinWidth: Kc,
      // We set this to null as we implement our own node view in the table
      // block content. This node view is the same as what's used by default,
      // but is wrapped in a `blockContent` HTML element.
      View: null
    }),
    es()
  ],
  addKeyboardShortcuts() {
    return {
      // Makes enter create a new line within the cell.
      Enter: () => this.editor.state.selection.empty && this.editor.state.selection.$head.parent.type.name === "tableParagraph" ? (this.editor.commands.insertContent({ type: "hardBreak" }), !0) : !1,
      // Ensures that backspace won't delete the table if the text cursor is at
      // the start of a cell and the selection is empty.
      Backspace: () => {
        const e = this.editor.state.selection, n = e.empty, r = e.$head.parentOffset === 0, o = e.$head.node().type.name === "tableParagraph";
        return n && r && o;
      },
      // Enables navigating cells using the tab key.
      Tab: () => this.editor.commands.command(
        ({ state: e, dispatch: n, view: r }) => _r(1)(e, n, r)
      ),
      "Shift-Tab": () => this.editor.commands.command(
        ({ state: e, dispatch: n, view: r }) => _r(-1)(e, n, r)
      )
    };
  },
  extendNodeSchema(e) {
    const n = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      tableRole: Cs(
        Ds(e, "tableRole", n)
      )
    };
  }
}), fg = L.pick({
  textColor: !0
}), pg = V(fg), gg = pe.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  /**
   * We allow table headers and cells to have multiple tableContent nodes because
   * when merging cells, prosemirror-tables will concat the contents of the cells naively.
   * This would cause that content to overflow into other cells when prosemirror tries to enforce the cell structure.
   *
   * So, we manually fix this up when reading back in the `nodeToBlock` and only ever place a single tableContent back into the cell.
   */
  content: "tableContent+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          const n = e.getAttribute("colwidth");
          return n ? n.split(",").map((o) => parseInt(o, 10)) : null;
        }
      }
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [
      {
        tag: "th",
        // As `th` elements can contain multiple paragraphs, we need to merge their contents
        // into a single one so that ProseMirror can parse everything correctly.
        getContent: (e, n) => Xc(e, n)
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "th",
      Rt(this.options.HTMLAttributes, e),
      0
    ];
  }
}), vg = pe.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "tableContent+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          const n = e.getAttribute("colwidth");
          return n ? n.split(",").map((o) => parseInt(o, 10)) : null;
        }
      }
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [
      {
        tag: "td",
        // As `td` elements can contain multiple paragraphs, we need to merge their contents
        // into a single one so that ProseMirror can parse everything correctly.
        getContent: (e, n) => Xc(e, n)
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "td",
      Rt(this.options.HTMLAttributes, e),
      0
    ];
  }
}), hg = pe.create({
  name: "table",
  content: "tableRow+",
  group: "blockContent",
  tableRole: "table",
  marks: "deletion insertion modification",
  isolating: !0,
  parseHTML() {
    return [
      {
        tag: "table"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    var t, i, a;
    const r = nl(
      this.name,
      "table",
      {
        ...((t = this.options.domAttributes) == null ? void 0 : t.blockContent) || {},
        ...n
      },
      ((i = this.options.domAttributes) == null ? void 0 : i.inlineContent) || {}
    ), o = document.createElement("colgroup");
    for (const u of e.children[0].children)
      if (u.attrs.colwidth)
        for (const s of u.attrs.colwidth) {
          const m = document.createElement("col");
          s && (m.style = `width: ${s}px`), o.appendChild(m);
        }
      else
        o.appendChild(document.createElement("col"));
    return (a = r.dom.firstChild) == null || a.appendChild(o), r;
  },
  // This node view is needed for the `columnResizing` plugin. By default, the
  // plugin adds its own node view, which overrides how the node is rendered vs
  // `renderHTML`. This means that the wrapping `blockContent` HTML element is
  // no longer rendered. The `columnResizing` plugin uses the `TableView` as its
  // default node view. `BlockNoteTableView` extends it by wrapping it in a
  // `blockContent` element, so the DOM structure is consistent with other block
  // types.
  addNodeView() {
    return ({ node: e, HTMLAttributes: n }) => {
      var o;
      class r extends ts {
        constructor(i, a, u) {
          super(i, a), this.node = i, this.cellMinWidth = a, this.blockContentHTMLAttributes = u;
          const c = document.createElement("div");
          c.className = ze(
            "bn-block-content",
            u.class
          ), c.setAttribute("data-content-type", "table");
          for (const [b, _] of Object.entries(
            u
          ))
            b !== "class" && c.setAttribute(b, _);
          const s = this.dom, m = document.createElement("div");
          m.className = "tableWrapper-inner", m.appendChild(s.firstChild), s.appendChild(m), c.appendChild(s);
          const p = document.createElement("div");
          p.className = "table-widgets-container", p.style.position = "relative", s.appendChild(p), this.dom = c;
        }
        ignoreMutation(i) {
          return !i.target.closest(".tableWrapper-inner") || super.ignoreMutation(i);
        }
      }
      return new r(e, Kc, {
        ...((o = this.options.domAttributes) == null ? void 0 : o.blockContent) || {},
        ...n
      });
    };
  }
}), bg = pe.create({
  name: "tableParagraph",
  group: "tableContent",
  content: "inline*",
  parseHTML() {
    return [
      {
        tag: "p",
        getAttrs: (e) => {
          if (typeof e == "string" || !e.textContent || !e.closest("[data-content-type]"))
            return !1;
          const n = e.parentElement;
          return n === null ? !1 : n.tagName === "TD" || n.tagName === "TH" ? {} : !1;
        },
        node: "tableParagraph"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", e, 0];
  }
}), $g = pe.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)+",
  tableRole: "row",
  marks: "deletion insertion modification",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "tr",
      Rt(this.options.HTMLAttributes, e),
      0
    ];
  }
});
function Xc(e, n) {
  const o = Oi.fromSchema(n).parse(e, {
    topNode: n.nodes.blockGroup.create()
  }), t = [];
  return o.content.descendants((i) => {
    if (i.isInline)
      return t.push(i), !1;
  }), et.fromArray(t);
}
const _g = () => Rm(
  { node: hg, type: "table", content: "table" },
  pg,
  [
    A({
      key: "table-extensions",
      tiptapExtensions: [
        mg,
        bg,
        gg,
        vg,
        $g
      ]
    }),
    // Extension for keyboard shortcut which deletes the table if it's empty
    // and all cells are selected. Uses a separate extension as it needs
    // priority over keyboard handlers in the `TableExtension`'s
    // `tableEditing` plugin.
    A({
      key: "table-keyboard-delete",
      keyboardShortcuts: {
        Backspace: ({ editor: e }) => {
          if (!(e.prosemirrorState.selection instanceof ei))
            return !1;
          const n = e.getTextCursorPosition().block, r = n.content;
          let o = 0;
          for (const i of r.rows)
            for (const a of i.cells) {
              if ("type" in a && a.content.length > 0 || !("type" in a) && a.length > 0)
                return !1;
              o++;
            }
          let t = 0;
          return e.prosemirrorState.selection.forEachCell(() => {
            t++;
          }), t < o ? !1 : (e.transact(() => {
            (e.getPrevBlock(n) || e.getNextBlock(n)) && e.setTextCursorPosition(n), e.removeBlocks([n]);
          }), !0);
        }
      }
    })
  ]
), qr = (e) => {
  const n = e.src || void 0, r = e.width || void 0;
  return { url: n, previewWidth: r };
}, yg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z"></path></svg>', kg = L.pick({
  textAlignment: !0,
  backgroundColor: !0
}).extend({
  ...he.shape,
  ...be.pick({
    url: !0,
    showPreview: !0,
    previewWidth: !0
  }).shape
}), wg = (e) => ({
  type: "video",
  propSchema: V(kg),
  content: "none"
}), Ig = (e) => (n) => {
  if (n.tagName === "VIDEO") {
    if (n.closest("figure"))
      return;
    const { backgroundColor: r } = Z(n);
    return {
      ...qr(n),
      backgroundColor: r
    };
  }
  if (n.tagName === "FIGURE") {
    const r = ht(n, "video");
    if (!r)
      return;
    const { targetElement: o, caption: t } = r, { backgroundColor: i } = Z(n);
    return {
      ...qr(o),
      backgroundColor: i,
      caption: t
    };
  }
}, Sg = B(
  wg,
  (e) => ({
    meta: {
      fileBlockAccept: ["video/*"]
    },
    parse: Ig(),
    render(n, r) {
      const o = document.createElement("div");
      o.innerHTML = e.icon ?? yg;
      const t = document.createElement("div");
      t.className = "bn-visual-media-wrapper";
      const i = document.createElement("video");
      return i.className = "bn-visual-media", r.resolveFileUrl ? r.resolveFileUrl(n.props.url).then((a) => {
        i.src = a;
      }) : i.src = n.props.url, i.controls = !0, i.contentEditable = "false", i.draggable = !1, n.props.previewWidth && (i.width = n.props.previewWidth), t.appendChild(i), Jc(
        n,
        r,
        { dom: t },
        t,
        o.firstElementChild
      );
    },
    toExternalHTML(n) {
      if (!n.props.url) {
        const o = document.createElement("p");
        return o.textContent = "Add video", {
          dom: o
        };
      }
      let r;
      return n.props.showPreview ? (r = document.createElement("video"), r.src = n.props.url, n.props.previewWidth && (r.width = n.props.previewWidth)) : (r = document.createElement("a"), r.href = n.props.url, r.textContent = n.props.name || n.props.url), n.props.caption ? n.props.showPreview ? br(r, n.props.caption) : bt(r, n.props.caption) : {
        dom: r
      };
    },
    runsBefore: ["file"]
  })
);
function C(e, n) {
  return n in e.schema.blockSpecs;
}
function zg(e, n, r) {
  if (!(n in e.schema.blockSpecs))
    return !1;
  const o = e.schema.blockSpecs[n].config.propSchema;
  return Object.entries(r._zod.def.shape).every(([t, i]) => {
    var a;
    return JSON.stringify(i._zod.def) === JSON.stringify((a = o._zodSource._zod.def.shape[t]) == null ? void 0 : a._zod.def);
  });
}
function Yr(e, n, r) {
  if (!(n in e.schema.blockSpecs))
    return !1;
  const o = e.schema.blockSpecs[n].config.propSchema;
  return Pt(o._zodSource, r).success;
}
function _v(e, n, r) {
  return zg(n, e.type, r);
}
function yv(e, n) {
  var r;
  if (!(n in e.schema.blockSpecs))
    throw new Error(`Block type ${n} not found`);
  return ((r = e.schema.blockSpecs[n].implementation.meta) == null ? void 0 : r.fileBlockAccept) !== void 0;
}
function kv(e) {
  return e instanceof ei;
}
const Ve = /* @__PURE__ */ new Map();
function xg(e) {
  if (Ve.has(e))
    return Ve.get(e);
  const n = new Bs();
  return e._tiptapEditor.on("transaction", ({ transaction: r }) => {
    n.appendMapping(r.mapping);
  }), e._tiptapEditor.on("destroy", () => {
    Ve.delete(e);
  }), Ve.set(e, n), n;
}
function Ng(e, n, r = "left") {
  const o = zr.getState(e.prosemirrorState);
  if (!o) {
    const i = xg(e), a = i.maps.length;
    return () => i.slice(a).map(n, r === "left" ? -1 : 1);
  }
  const t = Rs(
    // Track the position after the position if we are on the right side
    n + (r === "right" ? 1 : -1),
    o.binding.type,
    o.binding.mapping
  );
  return () => {
    const i = zr.getState(
      e.prosemirrorState
    ), a = Fs(
      i.doc,
      i.binding.type,
      t,
      i.binding.mapping
    );
    if (a === null)
      throw new Error("Position not found, cannot track positions");
    return a + (r === "right" ? -1 : 1);
  };
}
const jg = As((e) => e.type.name === "blockContainer");
class Og {
  constructor(n, r, o) {
    q(this, "state");
    q(this, "emitUpdate");
    q(this, "rootEl");
    q(this, "pluginState");
    q(this, "handleScroll", () => {
      var n, r;
      if ((n = this.state) != null && n.show) {
        const o = (r = this.rootEl) == null ? void 0 : r.querySelector(
          `[data-decoration-id="${this.pluginState.decorationId}"]`
        );
        if (!o)
          return;
        this.state.referencePos = o.getBoundingClientRect().toJSON(), this.emitUpdate(this.pluginState.triggerCharacter);
      }
    });
    q(this, "closeMenu", () => {
      this.editor.transact((n) => n.setMeta(te, null));
    });
    q(this, "clearQuery", () => {
      this.pluginState !== void 0 && this.editor._tiptapEditor.chain().focus().deleteRange({
        from: this.pluginState.queryStartPos() - (this.pluginState.deleteTriggerCharacter ? this.pluginState.triggerCharacter.length : 0),
        to: this.editor.transact((n) => n.selection.from)
      }).run();
    });
    var t;
    this.editor = n, this.pluginState = void 0, this.emitUpdate = (i) => {
      var a;
      if (!this.state)
        throw new Error("Attempting to update uninitialized suggestions menu");
      r(i, {
        ...this.state,
        ignoreQueryLength: (a = this.pluginState) == null ? void 0 : a.ignoreQueryLength
      });
    }, this.rootEl = o.root, (t = this.rootEl) == null || t.addEventListener("scroll", this.handleScroll, !0);
  }
  update(n, r) {
    var s;
    const o = te.getState(r), t = te.getState(
      n.state
    ), i = o === void 0 && t !== void 0, a = o !== void 0 && t === void 0;
    if (!i && !(o !== void 0 && t !== void 0) && !a)
      return;
    if (this.pluginState = a ? o : t, a || !this.editor.isEditable) {
      this.state && (this.state.show = !1), this.emitUpdate(this.pluginState.triggerCharacter);
      return;
    }
    const c = (s = this.rootEl) == null ? void 0 : s.querySelector(
      `[data-decoration-id="${this.pluginState.decorationId}"]`
    );
    this.editor.isEditable && c && (this.state = {
      show: !0,
      referencePos: c.getBoundingClientRect().toJSON(),
      query: this.pluginState.query
    }, this.emitUpdate(this.pluginState.triggerCharacter));
  }
  destroy() {
    var n;
    (n = this.rootEl) == null || n.removeEventListener("scroll", this.handleScroll, !0);
  }
}
const te = new Ls("SuggestionMenuPlugin"), Ug = A(({ editor: e }) => {
  const n = [];
  let r;
  const o = xi(void 0);
  return {
    key: "suggestionMenu",
    store: o,
    addTriggerCharacter: (t) => {
      n.push(t);
    },
    removeTriggerCharacter: (t) => {
      n.splice(n.indexOf(t), 1);
    },
    closeMenu: () => {
      r == null || r.closeMenu();
    },
    clearQuery: () => {
      r == null || r.clearQuery();
    },
    shown: () => {
      var t;
      return ((t = r == null ? void 0 : r.state) == null ? void 0 : t.show) || !1;
    },
    openSuggestionMenu: (t, i) => {
      e.headless || (e.focus(), e.transact((a) => {
        i != null && i.deleteTriggerCharacter && a.insertText(t), a.scrollIntoView().setMeta(te, {
          triggerCharacter: t,
          deleteTriggerCharacter: (i == null ? void 0 : i.deleteTriggerCharacter) || !1,
          ignoreQueryLength: (i == null ? void 0 : i.ignoreQueryLength) || !1
        });
      }));
    },
    // TODO this whole plugin needs to be refactored (but I've done the minimal)
    prosemirrorPlugins: [
      new Zs({
        key: te,
        view: (t) => (r = new Og(
          e,
          (i, a) => {
            o.setState({ ...a, triggerCharacter: i });
          },
          t
        ), r),
        state: {
          // Initialize the plugin's internal state.
          init() {
          },
          // Apply changes to the plugin state from an editor transaction.
          apply: (t, i, a, u) => {
            if (t.selection.$from.parent.type.spec.code)
              return i;
            const c = t.getMeta(te);
            if (typeof c == "object" && c !== null) {
              i && (r == null || r.closeMenu());
              const m = Ng(
                e,
                u.selection.from - // Need to account for the trigger char that was inserted, so we offset the position by the length of the trigger character.
                c.triggerCharacter.length
              );
              return {
                triggerCharacter: c.triggerCharacter,
                deleteTriggerCharacter: c.deleteTriggerCharacter !== !1,
                // When reading the queryStartPos, we offset the result by the length of the trigger character, to make it easy on the caller
                queryStartPos: () => m() + c.triggerCharacter.length,
                query: "",
                decorationId: `id_${Math.floor(Math.random() * 4294967295)}`,
                ignoreQueryLength: c == null ? void 0 : c.ignoreQueryLength
              };
            }
            if (i === void 0)
              return i;
            if (
              // Highlighting text should hide the menu.
              u.selection.from !== u.selection.to || // Transactions with plugin metadata should hide the menu.
              c === null || // Certain mouse events should hide the menu.
              // TODO: Change to global mousedown listener.
              t.getMeta("focus") || t.getMeta("blur") || t.getMeta("pointer") || // Moving the caret before the character which triggered the menu should hide it.
              i.triggerCharacter !== void 0 && u.selection.from < i.queryStartPos() || // Moving the caret to a new block should hide the menu.
              !u.selection.$from.sameParent(
                u.doc.resolve(i.queryStartPos())
              )
            )
              return;
            const s = { ...i };
            return s.query = u.doc.textBetween(
              i.queryStartPos(),
              u.selection.from
            ), s;
          }
        },
        props: {
          handleTextInput(t, i, a, u) {
            if (i === a) {
              const c = t.state.doc;
              for (const s of n) {
                const m = s.length > 1 ? c.textBetween(i - s.length, i) + u : u;
                if (s === m)
                  return t.dispatch(t.state.tr.insertText(u)), t.dispatch(
                    t.state.tr.setMeta(te, {
                      triggerCharacter: m
                    }).scrollIntoView()
                  ), !0;
              }
            }
            return !1;
          },
          // Setup decorator on the currently active suggestion.
          decorations(t) {
            const i = this.getState(t);
            if (i === void 0)
              return null;
            if (!i.deleteTriggerCharacter) {
              const a = jg(t.selection);
              if (a)
                return Ir.create(t.doc, [
                  Sr.node(
                    a.pos,
                    a.pos + a.node.nodeSize,
                    {
                      nodeName: "span",
                      class: "bn-suggestion-decorator",
                      "data-decoration-id": i.decorationId
                    }
                  )
                ]);
            }
            return Ir.create(t.doc, [
              Sr.inline(
                i.queryStartPos() - i.triggerCharacter.length,
                i.queryStartPos(),
                {
                  nodeName: "span",
                  class: "bn-suggestion-decorator",
                  "data-decoration-id": i.decorationId
                }
              )
            ]);
          }
        }
      })
    ]
  };
});
function Tg(e) {
  let n = e.getTextCursorPosition().block, r = e.schema.blockSchema[n.type].content;
  for (; r === "none"; ) {
    if (n = e.getTextCursorPosition().nextBlock, n === void 0)
      return;
    r = e.schema.blockSchema[n.type].content, e.setTextCursorPosition(n, "end");
  }
}
function D(e, n) {
  const r = e.getTextCursorPosition().block;
  if (r.content === void 0)
    throw new Error("Slash Menu open in a block that doesn't contain content.");
  let o;
  return Array.isArray(r.content) && (r.content.length === 1 && Ii(r.content[0]) && r.content[0].type === "text" && r.content[0].text === "/" || r.content.length === 0) ? (o = e.updateBlock(r, n), e.setTextCursorPosition(o)) : (o = e.insertBlocks([n], r, "after")[0], e.setTextCursorPosition(e.getTextCursorPosition().nextBlock)), Tg(e), o;
}
function wv(e) {
  const n = [];
  if (C(e, "heading"))
    for (const r of [1, 2, 3, 4, 5, 6])
      Yr(e, "heading", { level: r }) && n.push({
        onItemClick: () => {
          D(e, {
            type: "heading",
            props: { level: r }
          });
        },
        badge: Q(`Mod-Alt-${r}`),
        key: `heading_${r}`,
        ...e.dictionary.slash_menu[`heading_${r}`]
      });
  if (C(e, "quote") && n.push({
    onItemClick: () => {
      D(e, {
        type: "quote"
      });
    },
    key: "quote",
    ...e.dictionary.slash_menu.quote
  }), C(e, "toggleListItem") && n.push({
    onItemClick: () => {
      D(e, {
        type: "toggleListItem"
      });
    },
    badge: Q("Mod-Shift-6"),
    key: "toggle_list",
    ...e.dictionary.slash_menu.toggle_list
  }), C(e, "numberedListItem") && n.push({
    onItemClick: () => {
      D(e, {
        type: "numberedListItem"
      });
    },
    badge: Q("Mod-Shift-7"),
    key: "numbered_list",
    ...e.dictionary.slash_menu.numbered_list
  }), C(e, "bulletListItem") && n.push({
    onItemClick: () => {
      D(e, {
        type: "bulletListItem"
      });
    },
    badge: Q("Mod-Shift-8"),
    key: "bullet_list",
    ...e.dictionary.slash_menu.bullet_list
  }), C(e, "checkListItem") && n.push({
    onItemClick: () => {
      D(e, {
        type: "checkListItem"
      });
    },
    badge: Q("Mod-Shift-9"),
    key: "check_list",
    ...e.dictionary.slash_menu.check_list
  }), C(e, "paragraph") && n.push({
    onItemClick: () => {
      D(e, {
        type: "paragraph"
      });
    },
    badge: Q("Mod-Alt-0"),
    key: "paragraph",
    ...e.dictionary.slash_menu.paragraph
  }), C(e, "codeBlock") && n.push({
    onItemClick: () => {
      D(e, {
        type: "codeBlock"
      });
    },
    badge: Q("Mod-Alt-c"),
    key: "code_block",
    ...e.dictionary.slash_menu.code_block
  }), C(e, "divider") && n.push({
    onItemClick: () => {
      D(e, { type: "divider" });
    },
    key: "divider",
    ...e.dictionary.slash_menu.divider
  }), C(e, "table") && n.push({
    onItemClick: () => {
      D(e, {
        type: "table",
        content: {
          type: "tableContent",
          rows: [
            {
              cells: ["", "", ""]
            },
            {
              cells: ["", "", ""]
            }
          ]
        }
      });
    },
    badge: void 0,
    key: "table",
    ...e.dictionary.slash_menu.table
  }), C(e, "image") && n.push({
    onItemClick: () => {
      var o;
      const r = D(e, {
        type: "image"
      });
      (o = e.getExtension(ke)) == null || o.showMenu(r.id);
    },
    key: "image",
    ...e.dictionary.slash_menu.image
  }), C(e, "video") && n.push({
    onItemClick: () => {
      var o;
      const r = D(e, {
        type: "video"
      });
      (o = e.getExtension(ke)) == null || o.showMenu(r.id);
    },
    key: "video",
    ...e.dictionary.slash_menu.video
  }), C(e, "audio") && n.push({
    onItemClick: () => {
      var o;
      const r = D(e, {
        type: "audio"
      });
      (o = e.getExtension(ke)) == null || o.showMenu(r.id);
    },
    key: "audio",
    ...e.dictionary.slash_menu.audio
  }), C(e, "file") && n.push({
    onItemClick: () => {
      var o;
      const r = D(e, {
        type: "file"
      });
      (o = e.getExtension(ke)) == null || o.showMenu(r.id);
    },
    key: "file",
    ...e.dictionary.slash_menu.file
  }), C(e, "heading"))
    for (const r of [1, 2, 3])
      Yr(e, "heading", {
        level: r,
        isToggleable: !0
      }) && n.push({
        onItemClick: () => {
          D(e, {
            type: "heading",
            props: { level: 2, isToggleable: !0 }
          });
        },
        key: `toggle_heading_${r}`,
        ...e.dictionary.slash_menu[`toggle_heading_${r}`]
      });
  return n.push({
    onItemClick: () => {
      var r;
      (r = e.getExtension(Ug)) == null || r.openSuggestionMenu(":", {
        deleteTriggerCharacter: !0,
        ignoreQueryLength: !0
      });
    },
    key: "emoji",
    ...e.dictionary.slash_menu.emoji
  }), n;
}
function Iv(e, n) {
  return e.filter(
    ({ title: r, aliases: o }) => r.toLowerCase().includes(n.toLowerCase()) || o && o.filter(
      (t) => t.toLowerCase().includes(n.toLowerCase())
    ).length !== 0
  );
}
const Sv = {
  // To speed up TS compilation, we re-use the type assertions to avoid TS needing to compare types all the time
  audio: Up(),
  bulletListItem: Qp(),
  checkListItem: tg(),
  codeBlock: Pp(),
  divider: Dp(),
  file: Mp(),
  heading: Vp(),
  image: qp(),
  numberedListItem: ig(),
  paragraph: cg(),
  quote: lg(),
  table: _g(),
  toggleListItem: ag(),
  video: Sg()
}, Eg = Fc(
  {
    type: "textColor",
    propSchema: "string"
  },
  {
    render: () => {
      const e = document.createElement("span");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML: (e) => {
      const n = document.createElement("span"), r = L.shape.textColor.def.defaultValue;
      return e !== r && (n.style.color = e in Y ? Y[e].text : e), {
        dom: n,
        contentDOM: n
      };
    },
    parse: (e) => {
      if (e.tagName === "SPAN" && e.style.color)
        return e.style.color;
    }
  }
), Pg = Fc(
  {
    type: "backgroundColor",
    propSchema: "string"
  },
  {
    render: () => {
      const e = document.createElement("span");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML: (e) => {
      const n = document.createElement("span"), r = L.shape.backgroundColor.def.defaultValue;
      return e !== r && (n.style.backgroundColor = e in Y ? Y[e].background : e), {
        dom: n,
        contentDOM: n
      };
    },
    parse: (e) => {
      if (e.tagName === "SPAN" && e.style.backgroundColor)
        return e.style.backgroundColor;
    }
  }
), Cg = {
  bold: _e(
    Vs,
    "boolean"
  ),
  italic: _e(
    Ws,
    "boolean"
  ),
  underline: _e(
    Gs,
    "boolean"
  ),
  strike: _e(
    Js,
    "boolean"
  ),
  code: _e(
    Hs,
    "boolean"
  ),
  textColor: Eg,
  backgroundColor: Pg
}, zv = Gm(Cg), Dg = {
  text: { config: "text", implementation: {} },
  link: { config: "link", implementation: {} }
}, xv = Wm(
  Dg
);
export {
  C as $,
  tg as A,
  rg as B,
  ig as C,
  og as D,
  $v as E,
  Sp as F,
  ag as G,
  ug as H,
  cg as I,
  sg as J,
  lg as K,
  fg as L,
  _g as M,
  yg as N,
  wg as O,
  Ig as P,
  Sg as Q,
  Bp as R,
  Hc as S,
  nl as T,
  jr as U,
  rl as V,
  Sv as W,
  Cg as X,
  zv as Y,
  Dg as Z,
  xv as _,
  Kc as a,
  zg as a0,
  Yr as a1,
  _v as a2,
  yv as a3,
  kv as a4,
  he as a5,
  be as a6,
  L as a7,
  pr as a8,
  Z as a9,
  hv as aA,
  ov as aB,
  ze as aC,
  gr as aD,
  hp as aE,
  Y as aF,
  dv as aG,
  Fm as aH,
  Vm as aI,
  Bm as aJ,
  Nt as aK,
  Rm as aL,
  Hm as aM,
  Rc as aN,
  bv as aO,
  yp as aP,
  Fc as aQ,
  Jm as aR,
  Fe as aS,
  Du as aT,
  _e as aU,
  tl as aV,
  Q as aW,
  rv as aX,
  ne as aY,
  iv as aZ,
  Ng as a_,
  ue as aa,
  mv as ab,
  fv as ac,
  pv as ad,
  ke as ae,
  Ug as af,
  D as ag,
  wv as ah,
  Iv as ai,
  av as aj,
  Gm as ak,
  Wm as al,
  uv as am,
  B as an,
  V as ao,
  Ze as ap,
  gp as aq,
  pp as ar,
  gv as as,
  vv as at,
  vr as au,
  cv as av,
  sv as aw,
  Mm as ax,
  lv as ay,
  vt as az,
  Np as b,
  xp as c,
  jp as d,
  Op as e,
  Up as f,
  Ep as g,
  Pp as h,
  Vc as i,
  Cp as j,
  Dp as k,
  Zp as l,
  Lp as m,
  Mp as n,
  Fp as o,
  Wr as p,
  Vp as q,
  Hp as r,
  Jp as s,
  Gp as t,
  Kp as u,
  Xp as v,
  qp as w,
  Yp as x,
  Qp as y,
  eg as z
};
//# sourceMappingURL=defaultBlocks-CUZfrbY-.js.map
